import {
  SideMenuItems,
  HTTPResponse,
  ToastMessageType,
  ToastMessages,
  Values,
  PageDesignConstants,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import { AppContext } from "../../Contexts/AppContextProvider";
import DateControl from "../../Components/DateControl";
import React, { useState, useContext, useEffect, useRef } from "react";
import InfoPopUp from "../../Components/InfoPopUp";
import {
  GetLocalStorageData,
  GetLoggedInUserID,
  GetOrdinal,
  IsAdmin,
  applySidebarState,
  toggleSidebar,
  IsDateBefore,
  IsDateAfter,
  AdjustDays,
  DateValid,
} from "../../Helpers/Utilities";
import CustomTextArea from "../../Components/CustomTextArea ";

import {
  CommonError_Msgs,
  zeroToTwelve,
  zeroToThree,
  fourToFifteen,
  sixteenToTwentySeven,
} from "../../Helpers/HelperText";
import { laboratoryAssessmentService } from "../../WebApiServices/LaboratoryAssessmentService";
import ErrorField from "../../Components/ErrorField";
import { Dropdown } from "react-bootstrap";

const OtherLabAssessment = () => {
  const navigatePaths = {
    prevPage: "/RenalLabAssessment",
    currPage: "/OtherLabAssessment",
    nextPage: "/MMARelatedComplications",
  };

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setisSideMenuActive,
  } = useContext(AppContext);

  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);

  const pidRef = useRef(0);
  let loggedInUserId = GetLoggedInUserID();

  let dates = GetLocalStorageData("ClinicalCharacteristicsDates") || {};
  const indexMinus365days = AdjustDays(dates.indexDt, -365) || "([index date – 365 days])";
  const indexMinus182days = AdjustDays(dates.indexDt, -182) || "([index date – 182 days])";
  const indexPlus273days = AdjustDays(dates.indexDt, 273) || "([index date + 273 days])";
  const indexMinus456days = AdjustDays(dates.indexDt, -456);

  const labOptions = [
  { value: Values.value1, label: "Acetyl-carnitine (C2)" },
  { value: Values.value2, label: "Propionyl-carnitine (C3)" },
  { value: Values.value3, label: "Lactate" },
  { value: Values.value4, label: "Ammonia" },
  { value: Values.value5, label: "Glycine" },
  { value: Values.value6, label: "Glutamine" },
  { value: Values.value7, label: "Lysine" },
  { value: Values.value8, label: "Valine" },
  { value: Values.value9, label: "Alanine" },
  { value: Values.value10, label: "Serine" },
  { value: Values.value11, label: "Leucine" },
  { value: Values.value12, label: "Phenylalanine" },
  { value: Values.value13, label: "Tyrosine" },
  { value: Values.value14, label: "Hemoglobin" },
  { value: Values.value15, label: "Hematocrit" },
  { value: Values.value16, label: "Platelet count" },
  { value: Values.value17, label: "White blood cell count" },
  { value: Values.value18, label: "Neutrophil count" },
  { value: Values.value19, label: "Lymphocyte count" },
  { value: Values.value20, label: "Fibroblast growth factor 21 (FGF21)" },
  { value: Values.value21, label: "None of the above assessments reported" }
];


  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);

  const targetDates = [
    dates.transplant_admissionDt ? (
      <>
        Closest to the transplant admission date (
        <span className="indigo-text">{dates.transplant_admissionDt}</span>) to
        represent lab levels upon admission
      </>
    ) : (
      "Closest to the transplant admission date ([transplant admission date]) to represent lab levels upon admission"
    ),
    // dates.indexDt ? (
    //   <>
    //     Closest to the index date (
    //     <span className="indigo-text">{dates.indexDt}</span>) to represent lab
    //     levels at index{" "}
    //   </>
    // ) : (
    //   "Closest to the index date ([index date]) to represent lab levels at index"
    // ),
    // dates.transplant_dischargeDt ? (
    //   <>
    //     Closest to the transplant discharge date (
    //     <span className="indigo-text">{dates.transplant_dischargeDt}</span>) to
    //     represent lab levels upon discharge
    //   </>
    // ) : (
    //   "Closest to the transplant discharge date ([transplant discharge date]) to represent lab levels upon discharge"
    // ),
    dates.three_month_stabilization ? (
      <>
        Closest to 3 months after the index date (
        <span className="indigo-text">{dates.three_month_stabilization}</span>)
      </>
    ) : (
      "Closest to 3 months after the index date ([3-month stabilization date])"
    ),
    dates.twelve_month_post_stabilization ? (
      <>
        Closest to and after 15 months after the index date (
        <span className="indigo-text">
          {dates.twelve_month_post_stabilization}
        </span>
        )
      </>
    ) : (
      "Closest to and after 15 months after the index date ([12-month post-stabilization date])"
    ),
    dates.eighteen_month_post_stabilization ? (
      <>
        Closest to 21 months after the index date (
        <span className="indigo-text">
          {dates.eighteen_month_post_stabilization}
        </span>
        )
      </>
    ) : (
      "Closest to 21 months after the index date ([18-month post-stabilization date])"
    ),

    dates.twenty_four_months_post_stabilization ? (
      <>
        Closest to 27 months after the index date (
        <span className="indigo-text">
          {dates.twenty_four_months_post_stabilization}
        </span>
        )
      </>
    ) : (
      "Closest to 27 months after the index date ([24-month post-stabilization date])"
    ),
  ];

  ///Belinda
  const [showHide012HyperlinkModal, setShowHide012HyperlinkModal] =
    useState(false);
  const [showHide03HyperlinkModal, setShowHide03HyperlinkModal] =
    useState(false);
  const [showHide415HyperlinkModal, setShowHide415HyperlinkModal] =
    useState(false);
  const [showHide1627HyperlinkModal, setShowHide1627HyperlinkModal] =
    useState(false);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [patientLocked, setpatientLocked] = useState(false);


  //#region Q35
  const [labassessmentDetails, setlabassessmentDetails] = useState([
    {
      labassessmentid: 0,
      lab: "",
      labAssessment: "",
      labAssessment_dt: "",
      labAssessment_dt_estimated: false,
      labAssessmentUnkLTLKT: "",
      labspecimen: "",

      tyrosine_measurement: "",
      tyrosine_measurement_value_l: "",
      tyrosine_measurement_value_ml: "",
      tyrosine_measurement_value_nl: "",
      tyrosine_measurement_value_ugdl:"",

      hemoglobin_measurement: "",
      hemoglobin_measurement_value_gl: "",
      hemoglobin_measurement_value_gdl: "",
      hemoglobin_measurement_value_mgl: "",
      hemoglobin_measurement_value_mgdl: "",
      hematocrit_measurement: "",
      hematocrit_measurement_value: "",
      platelet_measurement: "",
      platelet_measurement_value_l: "",
      platelet_measurement_value_ul: "",
      fibroblast_measurement: "",
      fibroblast_measurement_value_ng: "",
      fibroblast_measurement_value_pg: "",

      q35labEmpty: false,
      q35assessmentEmpty: false,
      q35specimenEmpty: false,
      q35measurementEmpty: false,
      q35assessmentDateEmptyError: false,
      q35assessmentDateInvalid: false,
      q35AssessmentDateUnkEmpty: false,
      q35measurementTyrosineEmpty: false,
      q35measurementHemaglobinEmpty: false,
      q35measurementHematocritEmpty: false,
      q35measurementPlateletEmpty: false,
      q35measurementFibroblastEmpty: false,
      q35measurementTyrosineInvalid: false,
      q35measurementHemaglobinInvalid: false,
      q35measurementHematocritInvalid: false,
      q35measurementPlateletInvalid: false,
      q35measurementFibroblastInvalid: false,
    },
  ]);

  function addassessmentRow(e) {
    setlabassessmentDetails((prev) => [
      ...prev,
      {
        labassessmentid: 0,
        lab: "",
        labAssessment: "",
        labAssessment_dt: "",
        labAssessment_dt_estimated: false,
        labAssessmentUnkLTLKT: "",
        labspecimen: "",

        tyrosine_measurement: "",
        tyrosine_measurement_value_l: "",
        tyrosine_measurement_value_ml: "",
        tyrosine_measurement_value_nl: "",
        tyrosine_measurement_value_ugdl:"",
        hemoglobin_measurement: "",
        hemoglobin_measurement_value_gl: "",
        hemoglobin_measurement_value_gdl: "",
        hemoglobin_measurement_value_mgl: "",
        hemoglobin_measurement_value_mgdl: "",
        hematocrit_measurement: "",
        hematocrit_measurement_value: "",
        platelet_measurement: "",
        platelet_measurement_value_l: "",
        platelet_measurement_value_ul: "",
        fibroblast_measurement: "",
        fibroblast_measurement_value_ng: "",
        fibroblast_measurement_value_pg: "",

        q35labEmpty: false,
        q35assessmentEmpty: false,
        q35specimenEmpty: false,
        q35measurementEmpty: false,
        q35assessmentDateEmptyError: false,
        q35assessmentDateInvalid: false,
        q35AssessmentDateUnkEmpty: false,
        q35measurementTyrosineEmpty: false,
        q35measurementHemaglobinEmpty: false,
        q35measurementHematocritEmpty: false,
        q35measurementPlateletEmpty: false,
        q35measurementFibroblastEmpty: false,
        q35measurementTyrosineInvalid: false,
        q35measurementHemaglobinInvalid: false,
        q35measurementHematocritInvalid: false,
        q35measurementPlateletInvalid: false,
        q35measurementFibroblastInvalid: false,
      },
    ]);
  }

  function deleteAssessmentDetails(id) {
    const newAssessmentDetailsArray = [...labassessmentDetails];
    newAssessmentDetailsArray.splice(id, 1);
    setlabassessmentDetails(newAssessmentDetailsArray);
  }

  //#endregion


  //#region Q36-Q55
  const [Q36AdmissionHideColumn, setQ36AdmissionHideColumn] = useState(false);
  const [Q36DischargeHideColumn, setQ36DischargeHideColumn] = useState(false);
  const [Q36IndexHideColumn, setQ36IndexHideColumn] = useState(false);
  const [Q36ThreeMonthHideColumn, setQ36ThreeMonthHideColumn] = useState(false);
  const [Q36TwelveMonthHideColumn, setQ36TwelveMonthHideColumn] =
    useState(false);
  const [Q36TwentyFourMonthHideColumn, setQ36TwentyFourMonthHideColumn] =
    useState(false);
  const [Q36TwentyOneMonthHideColumn, setQ36TwentyOneMonthHideColumn] =
    useState(false);
  const mdeTypes = {
    question: "",
    label: "",
    specimenTypes: ["Blood", "Plasma", "Serum"],
    measurements: ["g/L", "mg/L", "mg/dL", "Unknown"],

    labAssessmentMdeId: 0,
    labAssessmentMdeTypeId: 0,
    admissionAssessment: "",
    admissionAssessmentDatedt: "",
    admissionAssessmentDateEstimated: false,
    admissionSpecimen: "",
    admissionMeasurement: "",
    admissionMeasurementValue_l: "",
    admissionMeasurementValue_ml: "",
    admissionMeasurementValue_nl: "",
    admissionMeasurementValue_mg: "",

    indexAssessment: "",
    indexAssessmentDate: "",
    indexAssessmentDateEstimated: false,
    indexSpecimen: "",
    indexMeasurement: "",
    indexMeasurementValue_l: "",
    indexMeasurementValue_ml: "",
    indexMeasurementValue_nl: "",
    indexMeasurementValue_mg: "",

    dischargeAssessment: "",
    dischargeAssessmentDatedt: "",
    dischargeAssessmentDateEstimated: false,
    dischargeSpecimen: "",
    dischargeMeasurement: "",
    dischargeMeasurementValue_l: "",
    dischargeMeasurementValue_ml: "",
    dischargeMeasurementValue_nl: "",
    dischargeMeasurementValue_mg: "",

    threemonthAssessment: "",
    threemonthAssessmentDate: "",
    threemonthAssessmentDateEstimated: false,
    threemonthSpecimen: "",
    threemonthMeasurement: "",
    threemonthMeasurementValue_l: "",
    threemonthMeasurementValue_ml: "",
    threemonthMeasurementValue_nl: "",
    threemonthMeasurementValue_mg: "",

    twelvemonthAssessment: "",
    twelvemonthAssessmentDate: "",
    twelvemonthAssessmentDateEstimated: false,
    twelvemonthSpecimen: "",
    twelvemonthMeasurement: "",
    twelvemonthMeasurementValue_l: "",
    twelvemonthMeasurementValue_ml: "",
    twelvemonthMeasurementValue_nl: "",
    twelvemonthMeasurementValue_mg: "",

    twentyonemonthAssessment: "",
    twentyonemonthAssessmentDate: "",
    twentyonemonthAssessmentDateEstimated: false,
    twentyonemonthSpecimen: "",
    twentyonemonthMeasurement: "",
    twentyonemonthMeasurementValue_l: "",
    twentyonemonthMeasurementValue_ml: "",
    twentyonemonthMeasurementValue_nl: "",
    twentyonemonthMeasurementValue_mg: "",

    twentyfourmonthAssessment: "",
    twentyfourmonthAssessmentDate: "",
    twentyfourmonthAssessmentDateEstimated: false,
    twentyfourmonthSpecimen: "",
    twentyfourmonthMeasurement: "",
    twentyfourmonthMeasurementValue_l: "",
    twentyfourmonthMeasurementValue_ml: "",
    twentyfourmonthMeasurementValue_nl: "",
    twentyfourmonthMeasurementValue_mg: "",

    q36AdmissionassessmentEmpty: false,
    q36IndexAssessmentEmpty: false,
    q36ThreemonthAssessmentEmpty: false,
    q36DischargeAssessmentEmpty: false,
    q36TwelvemonthAssessmentEmpty: false,
    q36TwentyonemonthAssessmentEmpty: false,
    q36TwentyfourmonthAssessmentEmpty: false,

    q36AdmissionspecimenEmpty: false,
    q36IndexSpecimenEmpty: false,
    q36ThreemonthSpecimenEmpty: false,
    q36DischargeSpecimenEmpty: false,
    q36TwelvemonthSpecimenEmpty: false,
    q36TwentyonemonthSpecimenEmpty: false,
    q36TwentyfourmonthSpecimenEmpty: false,

    q36AdmissionmeasurementEmpty: false,
    q36IndexMeasurementEmpty: false,
    q36ThreemonthMeasurementEmpty: false,
    q36DischargeMeasurementEmpty: false,
    q36TwelvemonthMeasurementEmpty: false,
    q36TwentyonemonthMeasurementEmpty: false,
    q36TwentyfourmonthMeasurementEmpty: false,

    q36AdmissionassessmentDateEmptyError: false,
    q36IndexAssessmentDateEmptyError: false,
    q36DischargeAssessmentDateEmptyError: false,
    q36ThreemonthAssessmentDateEmptyError: false,
    q36TwelvemonthAssessmentDateEmptyError: false,
    q36TwentyonemonthAssessmentDateEmptyError: false,
    q36TwentyfourmonthAssessmentDateEmptyError: false,

    q36AdmissionassessmentDateInvalid: false,
    q36IndexAssessmentDateInvalid: false,
    q36DischargeAssessmentDateInvalid: false,
    q36TwelvemonthAssessmentDateInvalid: false,
    q36TwentyfourmonthAssessmentDateInvalid: false,
    q36TwentyonemonthAssessmentDateInvalid: false,
    q36ThreemonthAssessmentDateInvalid: false,

    q36AdmissionmeasurementValueEmpty: false,
    q36IndexMeasurementValueEmpty: false,
    q36DischargeMeasurementValueEmpty: false,
    q36ThreemonthMeasurementValueEmpty: false,
    q36TwelvemonthMeasurementValueEmpty: false,
    q36TwentyonemonthMeasurementValueEmpty: false,
    q36TwentyfourmonthMeasurementValueEmpty: false,

    q36AdmissionmeasurementValueInvalid: false,
    q36IndexMeasurementValueInvalid: false,
    q36DischargeMeasurementValueInvalid: false,
    q36ThreemonthMeasurementValueInvalid: false,
    q36TwelvemonthMeasurementValueInvalid: false,
    q36TwentyonemonthMeasurementValueInvalid: false,
    q36TwentyfourmonthMeasurementValueInvalid: false,
  };
  // Iteration function for Q36-Q55
  const [mdeData, setmdeData] = useState(
    Array.from({ length: 20 }, (_, index) => ({
      ...mdeTypes,
      measurements:
        (index >= 0 && index <= 12 && index != 3)
          ? ["µmol/L", "µmol/mL ", "nmol/mL ", "Unknown"]
          : index === 3
          ? ["µmol/L", "µmol/mL ", "nmol/mL ", "µg/dL ", "Unknown"]
          : index === 13
          ? ["g/L","g/dL", "mg/L", "mg/dL", "Unknown"]
          : index === 14
          ? ["%", "Unknown"]
          : index >= 15 && index <= 18
          ? [
              <span key="1">
                10<sup>9</sup>/L
              </span>,
              <span key="2">
                10<sup>3</sup>/µL
              </span>,
              "Unknown",
            ]
          : ["ng/mL", "pg/mL", "Unknown"],
    }))
  );
  //#endregion



  const HandleLabFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    const splitNameArray = name.split("-");
    const fieldName = splitNameArray[0];
    const index = parseInt(splitNameArray[1], 10);
    const types = splitNameArray[2];

    const settingindex =
      types === "settingcare"
        ? parseInt(splitNameArray[3], 10)
        : types === "mde"
        ? parseInt(splitNameArray[3], 10)
        : "";
    const textindex =
      types === "settingcare"
        ? parseInt(splitNameArray[4], 10)
        : types === "mde"
        ? parseInt(splitNameArray[4], 10)
        : "";

        if (types === "lab") {
          //Q35
          setlabassessmentDetails((prevDetails) => {
            let updatedAssessmentDetails = prevDetails.map((item, idx) => {
              if (idx === index) {
                let updatedAssessmentItem = {
                  ...item,
                  [fieldName]:
                    type === "checkbox"
                      ? checked
                      : type === "radio" && fieldName !== "rvUnknown"
                      ? parseInt(value, 10) || 0
                      : value,
                };

                if (fieldName === "labspecimen")
                  updatedAssessmentItem.q35specimenEmpty = false;
    
                if (fieldName === "labAssessment") {
                  if (parseInt(value, 10) === Values.value99) {
                    updatedAssessmentItem.labAssessment_dt = "";
                    updatedAssessmentItem.labAssessment_dt_estimated = false;
                    updatedAssessmentItem.labAssessmentUnkLTLKT = "";
                    updatedAssessmentItem.q35assessmentEmpty = false;
                    updatedAssessmentItem.q35assessmentDateEmptyError = false;
                    updatedAssessmentItem.q35assessmentDateInvalid = false;
                    updatedAssessmentItem.q35AssessmentDateUnkEmpty = false;
                  } else {
                    updatedAssessmentItem.labAssessmentUnkLTLKT = "";
                    updatedAssessmentItem.q35assessmentEmpty = false;
                  }
                }
    
                if (fieldName === "labAssessmentUnkLTLKT") {
                  updatedAssessmentItem.labAssessmentUnkLTLKT = parseInt(value, 10);
                  updatedAssessmentItem.labAssessment_dt = "";
                  updatedAssessmentItem.labAssessment_dt_estimated = false;
                  updatedAssessmentItem.labAssessment = 99;
                  updatedAssessmentItem.q35assessmentEmpty = false;
                  updatedAssessmentItem.q35assessmentDateEmptyError = false;
                  updatedAssessmentItem.q35assessmentDateInvalid = false;
                  updatedAssessmentItem.q35AssessmentDateUnkEmpty = false;
                } else if (fieldName === "labAssessment_dt_estimated") {
                  updatedAssessmentItem.labAssessment = 1;
                  updatedAssessmentItem.labAssessmentUnkLTLKT = "";
                  updatedAssessmentItem.q35assessmentEmpty = false;
                  updatedAssessmentItem.q35assessmentDateEmptyError = false;
                  updatedAssessmentItem.q35assessmentDateInvalid = false;
                  updatedAssessmentItem.q35AssessmentDateUnkEmpty = false;
                }
    
                if (
                  fieldName === "tyrosine_measurement" &&
                  [
                    "",
                    Values.value1,
                    Values.value2,
                    Values.value3,
                    Values.value4,
                    Values.value5,
                    Values.value6,
                    Values.value7,
                    Values.value8,
                    Values.value9,
                    Values.value10,
                    Values.value11,
                    Values.value12,
                    Values.value13,
                  ].includes(updatedAssessmentItem.lab)
                ) {
                  if (parseInt(value, 10) === Values.value99) {
                    updatedAssessmentItem.tyrosine_measurement_value_l = "";
                    updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                    updatedAssessmentItem.tyrosine_measurement_value_nl = "";
                    updatedAssessmentItem.tyrosine_measurement_value_ugdl="";
                  } else {
                    updatedAssessmentItem.tyrosine_measurement_value_l = "";
                    updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                    updatedAssessmentItem.tyrosine_measurement_value_nl = "";
                    updatedAssessmentItem.tyrosine_measurement_value_ugdl="";
                  }
    
                  updatedAssessmentItem.q35measurementEmpty = false;
                  updatedAssessmentItem.q35measurementHemaglobinEmpty = false;
                  updatedAssessmentItem.q35measurementHematocritEmpty = false;
                  updatedAssessmentItem.q35measurementPlateletEmpty = false;
                  updatedAssessmentItem.q35measurementFibroblastEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineEmpty=false;
                  updatedAssessmentItem.q35measurementHemaglobinInvalid = false;
                  updatedAssessmentItem.q35measurementHematocritInvalid = false;
                  updatedAssessmentItem.q35measurementPlateletInvalid = false;
                  updatedAssessmentItem.q35measurementFibroblastInvalid = false;
                  updatedAssessmentItem.q35measurementTyrosineInvalid=false;
                }
    
                if (fieldName === "tyrosine_measurement_value_l") {
                  updatedAssessmentItem.tyrosine_measurement_value_l = value;
                  updatedAssessmentItem.tyrosine_measurement = 1;
                  updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                  updatedAssessmentItem.tyrosine_measurement_value_nl = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ugdl="";
                  updatedAssessmentItem.q35measurementTyrosineEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                } else if (fieldName === "tyrosine_measurement_value_ml") {
                  updatedAssessmentItem.tyrosine_measurement_value_ml = value;
                  updatedAssessmentItem.tyrosine_measurement = 2;
                  updatedAssessmentItem.tyrosine_measurement_value_l = "";
                  updatedAssessmentItem.tyrosine_measurement_value_nl = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ugdl="";
                  updatedAssessmentItem.q35measurementTyrosineEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                } else if (fieldName === "tyrosine_measurement_value_nl") {
                  updatedAssessmentItem.tyrosine_measurement_value_nl = value;
                  updatedAssessmentItem.tyrosine_measurement = 3;
                  updatedAssessmentItem.tyrosine_measurement_value_l = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ugdl="";
                  updatedAssessmentItem.q35measurementTyrosineEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                } else if (fieldName === "tyrosine_measurement_value_ugdl") {
                  updatedAssessmentItem.tyrosine_measurement_value_ugdl = value;
                  updatedAssessmentItem.tyrosine_measurement = 4;
                  updatedAssessmentItem.tyrosine_measurement_value_l = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                  updatedAssessmentItem.tyrosine_measurement_value_nl="";
                  updatedAssessmentItem.q35measurementTyrosineEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                }
    
                if (
                  fieldName === "lab" &&
                  [
                    "",
                    Values.value1,
                    Values.value2,
                    Values.value3,
                    Values.value4,
                    Values.value5,
                    Values.value6,
                    Values.value7,
                    Values.value8,
                    Values.value9,
                    Values.value10,
                    Values.value11,
                    Values.value12,
                    Values.value13,
                  ].includes(updatedAssessmentItem.lab)
                ) {
                  updatedAssessmentItem.hemoglobin_measurement_value_gl = "";
                  updatedAssessmentItem.hemoglobin_measurement = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgdl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gdl="";
                  updatedAssessmentItem.hematocrit_measurement_value = "";
                  updatedAssessmentItem.hematocrit_measurement = "";
                  updatedAssessmentItem.platelet_measurement_value_l = "";
                  updatedAssessmentItem.platelet_measurement = "";
                  updatedAssessmentItem.platelet_measurement_value_ul = "";
                  updatedAssessmentItem.fibroblast_measurement_value_ng = "";
                  updatedAssessmentItem.fibroblast_measurement = "";
                  updatedAssessmentItem.fibroblast_measurement_value_pg = "";
                  updatedAssessmentItem.q35labEmpty = false;


                  updatedAssessmentItem.tyrosine_measurement_value_l = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                  updatedAssessmentItem.tyrosine_measurement_value_nl = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ugdl = "";
                  updatedAssessmentItem.tyrosine_measurement = "";
                }
    
                if (
                  fieldName === "hemoglobin_measurement" &&
                  updatedAssessmentItem.lab === Values.value14
                ) {
                  if (parseInt(value, 10) === Values.value99) {
                    updatedAssessmentItem.hemoglobin_measurement_value_gl = "";
                    updatedAssessmentItem.hemoglobin_measurement_value_gdl="";
                    updatedAssessmentItem.hemoglobin_measurement_value_mgdl = "";
                    updatedAssessmentItem.hemoglobin_measurement_value_mgl = "";
                  } else {
                    updatedAssessmentItem.hemoglobin_measurement_value_gl = "";
                    updatedAssessmentItem.hemoglobin_measurement_value_gdl="";
                    updatedAssessmentItem.hemoglobin_measurement_value_mgdl = "";
                    updatedAssessmentItem.hemoglobin_measurement_value_mgl = "";
                  }
    
                  updatedAssessmentItem.q35measurementEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineEmpty = false;
                  updatedAssessmentItem.q35measurementHematocritEmpty = false;
                  updatedAssessmentItem.q35measurementPlateletEmpty = false;
                  updatedAssessmentItem.q35measurementFibroblastEmpty = false;
                  updatedAssessmentItem.q35measurementHemaglobinEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineInvalid = false;
                  updatedAssessmentItem.q35measurementHematocritInvalid = false;
                  updatedAssessmentItem.q35measurementPlateletInvalid = false;
                  updatedAssessmentItem.q35measurementFibroblastInvalid = false;
                  updatedAssessmentItem.q35measurementHemaglobinInvalid = false;
                }
    
                if (fieldName === "hemoglobin_measurement_value_gl") {
                  updatedAssessmentItem.hemoglobin_measurement_value_gl = value;
                  updatedAssessmentItem.hemoglobin_measurement = 1;
                  updatedAssessmentItem.hemoglobin_measurement_value_mgdl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gdl="";
                  updatedAssessmentItem.q35measurementHemaglobinEmpty = false;
                  updatedAssessmentItem.q35measurementHemaglobinInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                }
                 else if (fieldName === "hemoglobin_measurement_value_gdl") {
                  updatedAssessmentItem.hemoglobin_measurement_value_gdl = value;
                  updatedAssessmentItem.hemoglobin_measurement = 4;
                  updatedAssessmentItem.hemoglobin_measurement_value_mgdl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gl="";
                  updatedAssessmentItem.q35measurementHemaglobinEmpty = false;
                  updatedAssessmentItem.q35measurementHemaglobinInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                } 
                else if (fieldName === "hemoglobin_measurement_value_mgl") {
                  updatedAssessmentItem.hemoglobin_measurement_value_mgl = value;
                  updatedAssessmentItem.hemoglobin_measurement = 2;
                  updatedAssessmentItem.hemoglobin_measurement_value_gl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gdl="";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgdl = "";
                  updatedAssessmentItem.q35measurementHemaglobinEmpty = false;
                  updatedAssessmentItem.q35measurementHemaglobinInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                }
                if (fieldName === "hemoglobin_measurement_value_mgdl") {
                  updatedAssessmentItem.hemoglobin_measurement_value_mgdl = value;
                  updatedAssessmentItem.hemoglobin_measurement = 3;
                  updatedAssessmentItem.hemoglobin_measurement_value_gl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gdl="";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgl = "";
                  updatedAssessmentItem.q35measurementHemaglobinEmpty = false;
                  updatedAssessmentItem.q35measurementHemaglobinInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                }
                if (
                  fieldName === "lab" &&
                  updatedAssessmentItem.lab === Values.value14
                ) {
                  updatedAssessmentItem.q35labEmpty = false;
                  updatedAssessmentItem.tyrosine_measurement_value_nl = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ugdl = "";
                  updatedAssessmentItem.tyrosine_measurement = "";
                  updatedAssessmentItem.tyrosine_measurement_value_l = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                  updatedAssessmentItem.hematocrit_measurement_value = "";
                  updatedAssessmentItem.hematocrit_measurement = "";
                  updatedAssessmentItem.platelet_measurement_value_l = "";
                  updatedAssessmentItem.platelet_measurement = "";
                  updatedAssessmentItem.platelet_measurement_value_ul = "";
                  updatedAssessmentItem.fibroblast_measurement_value_ng = "";
                  updatedAssessmentItem.fibroblast_measurement = "";
                  updatedAssessmentItem.fibroblast_measurement_value_pg = "";
                }
    
                if (
                  fieldName === "hematocrit_measurement" &&
                  updatedAssessmentItem.lab === Values.value15
                ) {
                  if (parseInt(value, 10) === Values.value99) {
                    updatedAssessmentItem.hematocrit_measurement_value = "";
                  } else updatedAssessmentItem.hematocrit_measurement_value = "";
    
                  updatedAssessmentItem.q35measurementEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineEmpty = false;
                  updatedAssessmentItem.q35measurementHemaglobinEmpty = false;
                  updatedAssessmentItem.q35measurementPlateletEmpty = false;
                  updatedAssessmentItem.q35measurementFibroblastEmpty = false;
                  updatedAssessmentItem.q35measurementHematocritEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineInvalid = false;
                  updatedAssessmentItem.q35measurementHemaglobinInvalid = false;
                  updatedAssessmentItem.q35measurementPlateletInvalid = false;
                  updatedAssessmentItem.q35measurementFibroblastInvalid = false;
                  updatedAssessmentItem.q35measurementHematocritInvalid = false;
                }
    
                if (fieldName === "hematocrit_measurement_value") {
                  updatedAssessmentItem.hematocrit_measurement_value = value;
                  updatedAssessmentItem.hematocrit_measurement = 1;
                  updatedAssessmentItem.q35measurementHematocritEmpty = false;
                  updatedAssessmentItem.q35measurementHematocritInvalid = false;
                }
    
                if (
                  fieldName === "lab" &&
                  updatedAssessmentItem.lab === Values.value15
                ) {
                  updatedAssessmentItem.tyrosine_measurement_value_nl = "";
                  updatedAssessmentItem.tyrosine_measurement = "";
                  updatedAssessmentItem.tyrosine_measurement_value_l = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gdl="";
                  updatedAssessmentItem.hemoglobin_measurement = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgdl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgl = "";
                  updatedAssessmentItem.platelet_measurement_value_l = "";
                  updatedAssessmentItem.platelet_measurement = "";
                  updatedAssessmentItem.platelet_measurement_value_ul = "";
                  updatedAssessmentItem.fibroblast_measurement_value_ng = "";
                  updatedAssessmentItem.fibroblast_measurement = "";
                  updatedAssessmentItem.fibroblast_measurement_value_pg = "";
                  updatedAssessmentItem.q35labEmpty = false;
                }
    
                if (
                  fieldName === "platelet_measurement" &&
                  [
                    "",
                    Values.value16,
                    Values.value17,
                    Values.value18,
                    Values.value19,
                  ].includes(updatedAssessmentItem.lab)
                ) {
                  if (parseInt(value, 10) === Values.value99) {
                    updatedAssessmentItem.platelet_measurement_value_l = "";
                    updatedAssessmentItem.platelet_measurement_value_ul = "";
                  } else {
                    updatedAssessmentItem.platelet_measurement_value_l = "";
                    updatedAssessmentItem.platelet_measurement_value_ul = "";
                  }
    
                  updatedAssessmentItem.q35measurementEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineEmpty = false;
                  updatedAssessmentItem.q35measurementHemaglobinEmpty = false;
                  updatedAssessmentItem.q35measurementHematocritEmpty = false;
                  updatedAssessmentItem.q35measurementFibroblastEmpty = false;
                  updatedAssessmentItem.q35measurementPlateletEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineInvalid = false;
                  updatedAssessmentItem.q35measurementHemaglobinInvalid = false;
                  updatedAssessmentItem.q35measurementHematocritInvalid = false;
                  updatedAssessmentItem.q35measurementFibroblastInvalid = false;
                  updatedAssessmentItem.q35measurementPlateletInvalid = false;
                }
    
                if (fieldName === "platelet_measurement_value_l") {
                  updatedAssessmentItem.platelet_measurement_value_l = value;
                  updatedAssessmentItem.platelet_measurement = 1;
                  updatedAssessmentItem.platelet_measurement_value_ul = "";
                  updatedAssessmentItem.q35measurementPlateletEmpty = false;
                  updatedAssessmentItem.q35measurementPlateletInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                } else if (fieldName === "platelet_measurement_value_ul") {
                  updatedAssessmentItem.platelet_measurement_value_ul = value;
                  updatedAssessmentItem.platelet_measurement = 2;
                  updatedAssessmentItem.platelet_measurement_value_l = "";
                  updatedAssessmentItem.q35measurementPlateletEmpty = false;
                  updatedAssessmentItem.q35measurementPlateletInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                }
    
                if (
                  fieldName === "lab" &&
                  [
                    "",
                    Values.value16,
                    Values.value17,
                    Values.value18,
                    Values.value19,
                  ].includes(updatedAssessmentItem.lab)
                ) {
                  updatedAssessmentItem.tyrosine_measurement_value_nl = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ugdl = "";
                  updatedAssessmentItem.tyrosine_measurement = "";
                  updatedAssessmentItem.tyrosine_measurement_value_l = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gdl="";
                  updatedAssessmentItem.hemoglobin_measurement = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgdl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgl = "";
                  updatedAssessmentItem.hematocrit_measurement_value = "";
                  updatedAssessmentItem.hematocrit_measurement = "";
                  updatedAssessmentItem.fibroblast_measurement_value_ng = "";
                  updatedAssessmentItem.fibroblast_measurement = "";
                  updatedAssessmentItem.fibroblast_measurement_value_pg = "";
                  updatedAssessmentItem.q35labEmpty = false;
                }
    
                if (
                  fieldName === "fibroblast_measurement" &&
                  updatedAssessmentItem.lab === Values.value20
                ) {
                  if (parseInt(value, 10) === Values.value99) {
                    updatedAssessmentItem.fibroblast_measurement_value_ng = "";
                    updatedAssessmentItem.fibroblast_measurement_value_pg = "";
                  } else {
                    updatedAssessmentItem.fibroblast_measurement_value_ng = "";
                    updatedAssessmentItem.fibroblast_measurement_value_pg = "";
                  }
    
                  updatedAssessmentItem.q35measurementEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineEmpty = false;
                  updatedAssessmentItem.q35measurementHemaglobinEmpty = false;
                  updatedAssessmentItem.q35measurementHematocritEmpty = false;
                  updatedAssessmentItem.q35measurementPlateletEmpty = false;
                  updatedAssessmentItem.q35measurementFibroblastEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineInvalid = false;
                  updatedAssessmentItem.q35measurementHemaglobinInvalid = false;
                  updatedAssessmentItem.q35measurementHematocritInvalid = false;
                  updatedAssessmentItem.q35measurementPlateletInvalid = false;
                  updatedAssessmentItem.q35measurementFibroblastInvalid = false;
                  updatedAssessmentItem.q35measurementFibroblastInvalid = false;
                }
    
                if (fieldName === "fibroblast_measurement_value_ng") {
                  updatedAssessmentItem.fibroblast_measurement_value_ng = value;
                  updatedAssessmentItem.fibroblast_measurement = 1;
                  updatedAssessmentItem.fibroblast_measurement_value_pg = "";
                  updatedAssessmentItem.q35measurementFibroblastEmpty = false;
                  updatedAssessmentItem.q35measurementFibroblastInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                } else if (fieldName === "fibroblast_measurement_value_pg") {
                  updatedAssessmentItem.fibroblast_measurement_value_pg = value;
                  updatedAssessmentItem.fibroblast_measurement = 2;
                  updatedAssessmentItem.fibroblast_measurement_value_ng = "";
                  updatedAssessmentItem.q35measurementFibroblastEmpty = false;
                  updatedAssessmentItem.q35measurementFibroblastInvalid = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                }
    
                if (
                  fieldName === "lab" &&
                  updatedAssessmentItem.lab === Values.value20
                ) {
                  updatedAssessmentItem.tyrosine_measurement_value_nl = "";
                  updatedAssessmentItem.tyrosine_measurement = "";
                  updatedAssessmentItem.tyrosine_measurement_value_l = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gdl="";
                  updatedAssessmentItem.hemoglobin_measurement = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgdl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgl = "";
                  updatedAssessmentItem.hematocrit_measurement_value = "";
                  updatedAssessmentItem.hematocrit_measurement = "";
                  updatedAssessmentItem.platelet_measurement_value_l = "";
                  updatedAssessmentItem.platelet_measurement = "";
                  updatedAssessmentItem.platelet_measurement_value_ul = "";
                  updatedAssessmentItem.q35labEmpty = false;
                } else if (
                  fieldName === "lab" &&
                  parseInt(value, 10) === Values.value21
                ) {
                  updatedAssessmentItem.tyrosine_measurement_value_nl = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ugdl = "";
                  updatedAssessmentItem.tyrosine_measurement = "";
                  updatedAssessmentItem.tyrosine_measurement_value_l = "";
                  updatedAssessmentItem.tyrosine_measurement_value_ml = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_gdl="";
                  updatedAssessmentItem.hemoglobin_measurement = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgdl = "";
                  updatedAssessmentItem.hemoglobin_measurement_value_mgl = "";
                  updatedAssessmentItem.hematocrit_measurement_value = "";
                  updatedAssessmentItem.hematocrit_measurement = "";
                  updatedAssessmentItem.platelet_measurement_value_l = "";
                  updatedAssessmentItem.platelet_measurement = "";
                  updatedAssessmentItem.platelet_measurement_value_ul = "";
                  updatedAssessmentItem.fibroblast_measurement_value_ng = "";
                  updatedAssessmentItem.fibroblast_measurement = "";
                  updatedAssessmentItem.fibroblast_measurement_value_pg = "";
    
                  updatedAssessmentItem.labAssessmentUnkLTLKT = "";
                  updatedAssessmentItem.labAssessment_dt = "";
                  updatedAssessmentItem.labAssessment_dt_estimated = "";
                  updatedAssessmentItem.labAssessment = "";
                  updatedAssessmentItem.labspecimen = "";
    
                  updatedAssessmentItem.q35labEmpty = false;
                  updatedAssessmentItem.q35assessmentEmpty = false;
                  updatedAssessmentItem.q35specimenEmpty = false;
                  updatedAssessmentItem.q35measurementEmpty = false;
                  updatedAssessmentItem.q35assessmentDateEmptyError = false;
                  updatedAssessmentItem.q35assessmentDateInvalid = false;
                  updatedAssessmentItem.q35AssessmentDateUnkEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineEmpty = false;
                  updatedAssessmentItem.q35measurementHemaglobinEmpty = false;
                  updatedAssessmentItem.q35measurementHematocritEmpty = false;
                  updatedAssessmentItem.q35measurementPlateletEmpty = false;
                  updatedAssessmentItem.q35measurementFibroblastEmpty = false;
                  updatedAssessmentItem.q35measurementTyrosineInvalid = false;
                  updatedAssessmentItem.q35measurementHemaglobinInvalid = false;
                  updatedAssessmentItem.q35measurementHematocritInvalid = false;
                  updatedAssessmentItem.q35measurementPlateletInvalid = false;
                  updatedAssessmentItem.q35measurementFibroblastInvalid = false;
                }
    
                return updatedAssessmentItem;
              }
              return item;
            });
    
            if (
              fieldName === "lab" &&
              parseInt(value, 10) === Values.value21 &&
              updatedAssessmentDetails.length > 1
            ) {
              updatedAssessmentDetails = [updatedAssessmentDetails[0]]; // Keep only the first entry
            }
    
            return updatedAssessmentDetails;
          });
        }
      }

  const HandleMdeFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    const splitNameArray = name.split("-");
    const fieldName = splitNameArray[0];
    const index = parseInt(splitNameArray[1], 10);
    const types = splitNameArray[2];

    const settingindex =
      types === "settingcare"
        ? parseInt(splitNameArray[3], 10)
        : types === "mde"
        ? parseInt(splitNameArray[3], 10)
        : "";
    const textindex =
      types === "settingcare"
        ? parseInt(splitNameArray[4], 10)
        : types === "mde"
        ? parseInt(splitNameArray[4], 10)
        : "";    

    if (types === "mde") {

      setmdeData((prevDetails) => {
        let updatedmdeDetails = prevDetails.map((item, idx) => {
          if (idx === settingindex) {
            let updatedmdeItem = {
              ...item,
              [fieldName]:
                type === "checkbox"
                  ? checked
                  : type === "radio" && fieldName !== "rvUnknown"
                  ? parseInt(value, 10) || 0
                  : value,
            };

            // updatedItem.q29FullEmptyError = false;

            if (
              fieldName === "admissionAssessment" &&
              (parseInt(value, 10) === Values.value99 ||
                parseInt(value, 10) === Values.value2)
            ) {
              updatedmdeItem.admissionAssessmentDatedt = "";
              updatedmdeItem.admissionAssessmentDateEstimated = false;
              updatedmdeItem.q36AdmissionassessmentEmpty = false;
              if (parseInt(value, 10) === Values.value2) {
                updatedmdeItem.admissionMeasurementValue_l = "";
                updatedmdeItem.admissionMeasurementValue_ml = "";
                updatedmdeItem.admissionMeasurementValue_nl = "";
                updatedmdeItem.admissionMeasurementValue_mg = "";
                updatedmdeItem.admissionMeasurement = "";
                updatedmdeItem.admissionSpecimen = "";
                updatedmdeItem.q36AdmissionassessmentDateEmptyError = false;
                updatedmdeItem.q36AdmissionassessmentEmpty = false;
                updatedmdeItem.q36AdmissionassessmentDateInvalid = false;
                updatedmdeItem.q36AdmissionmeasurementValueEmpty = false;
                updatedmdeItem.q36AdmissionmeasurementValueInvalid = false;
                updatedmdeItem.q36AdmissionspecimenEmpty = false;
                updatedmdeItem.q36AdmissionmeasurementEmpty = false;
              }
            } else if (fieldName === "admissionAssessmentDateEstimated") {
              updatedmdeItem.admissionAssessment = 1;
              updatedmdeItem.q36AdmissionassessmentEmpty = false;
              updatedmdeItem.q36AdmissionassessmentDateEmptyError = false;
              updatedmdeItem.q36AdmissionassessmentDateInvalid = false;
            }

            if (
              fieldName === "dischargeAssessment" &&
              (parseInt(value, 10) === Values.value99 ||
                parseInt(value, 10) === Values.value2)
            ) {
              updatedmdeItem.dischargeAssessmentDatedt = "";
              updatedmdeItem.dischargeAssessmentDateEstimated = false;
              updatedmdeItem.q36DischargeAssessmentEmpty = false;

              if (parseInt(value, 10) === Values.value2) {
                updatedmdeItem.dischargeMeasurementValue_l = "";
                updatedmdeItem.dischargeMeasurementValue_ml = "";
                updatedmdeItem.dischargeMeasurementValue_nl = "";
                updatedmdeItem.dischargeMeasurementValue_mg = "";
                updatedmdeItem.dischargeMeasurement = "";
                updatedmdeItem.dischargeSpecimen = "";
                updatedmdeItem.q36DischargeAssessmentEmpty = false;
                updatedmdeItem.q36DischargeAssessmentDateEmptyError = false;
                updatedmdeItem.q36DischargeAssessmentDateInvalid = false;
                updatedmdeItem.q36DischargeMeasurementValueEmpty = false;
                updatedmdeItem.q36DischargeAssessmentDateInvalid = false;
                updatedmdeItem.q36DischargeSpecimenEmpty = false;
                updatedmdeItem.q36DischargeMeasurementEmpty = false;
              }
            } else if (fieldName === "dischargeAssessmentDateEstimated") {
              updatedmdeItem.dischargeAssessment = 1;
              updatedmdeItem.q36DischargeAssessmentEmpty = false;
              updatedmdeItem.q36DischargeAssessmentDateEmptyError = false;
              updatedmdeItem.q36DischargeAssessmentDateInvalid = false;
            }

            if (
              fieldName === "indexAssessment" &&
              (parseInt(value, 10) === Values.value99 ||
                parseInt(value, 10) === Values.value2)
            ) {
              updatedmdeItem.indexAssessmentDate = "";
              updatedmdeItem.indexAssessmentDateEstimated = false;
              updatedmdeItem.q36IndexAssessmentEmpty = false;
              if (parseInt(value, 10) === Values.value2) {
                updatedmdeItem.indexMeasurementValue_l = "";
                updatedmdeItem.indexMeasurementValue_ml = "";
                updatedmdeItem.indexMeasurementValue_nl = "";
                updatedmdeItem.indexMeasurementValue_mg = "";
                updatedmdeItem.indexMeasurement = "";
                updatedmdeItem.indexSpecimen = "";
                updatedmdeItem.q36IndexAssessmentEmpty = false;
                updatedmdeItem.q36IndexAssessmentDateEmptyError = false;
                updatedmdeItem.q36AdmissionassessmentDateInvalid = false;
                updatedmdeItem.q36IndexMeasurementValueEmpty = false;
                updatedmdeItem.q36IndexMeasurementValueInvalid = false;
                updatedmdeItem.q36IndexMeasurementEmpty = false;
                updatedmdeItem.q36IndexSpecimenEmpty = false;
              }
            } else if (fieldName === "indexAssessmentDateEstimated") {
              updatedmdeItem.indexAssessment = 1;
              updatedmdeItem.q36IndexAssessmentEmpty = false;
              updatedmdeItem.q36IndexAssessmentDateEmptyError = false;
              updatedmdeItem.q36IndexAssessmentDateInvalid = false;
            }

            if (
              fieldName === "threemonthAssessment" &&
              (parseInt(value, 10) === Values.value99 ||
                parseInt(value, 10) === Values.value2)
            ) {
              updatedmdeItem.threemonthAssessmentDate = "";
              updatedmdeItem.threemonthAssessmentDateEstimated = false;
              updatedmdeItem.q36ThreemonthAssessmentEmpty = false;
              if (parseInt(value, 10) === Values.value2) {
                updatedmdeItem.threemonthMeasurementValue_l = "";
                updatedmdeItem.threemonthMeasurementValue_ml = "";
                updatedmdeItem.threemonthMeasurementValue_nl = "";
                updatedmdeItem.threemonthMeasurementValue_mg = "";
                updatedmdeItem.threemonthMeasurement = "";
                updatedmdeItem.threemonthSpecimen = "";

                updatedmdeItem.q36ThreemonthAssessmentEmpty = false;
                updatedmdeItem.q36ThreemonthAssessmentDateEmptyError = false;
                updatedmdeItem.q36ThreemonthAssessmentDateInvalid = false;
                updatedmdeItem.q36ThreemonthMeasurementValueInvalid = false;
                updatedmdeItem.q36ThreemonthMeasurementEmpty = false;
                updatedmdeItem.q36ThreemonthMeasurementEmpty = false;
                updatedmdeItem.q36ThreemonthSpecimenEmpty = false;
              }
            } else if (fieldName === "threemonthAssessmentDateEstimated") {
              updatedmdeItem.threemonthAssessment = 1;
              updatedmdeItem.q36ThreemonthAssessmentEmpty = false;
              updatedmdeItem.q36ThreemonthAssessmentDateEmptyError = false;
              updatedmdeItem.q36ThreemonthAssessmentDateInvalid = false;
            }

            if (
              fieldName === "twelvemonthAssessment" &&
              (parseInt(value, 10) === Values.value99 ||
                parseInt(value, 10) === Values.value2)
            ) {
              updatedmdeItem.twelvemonthAssessmentDate = "";
              updatedmdeItem.twelvemonthAssessmentDateEstimated = false;
              updatedmdeItem.q36TwelvemonthAssessmentEmpty = false;
              if (parseInt(value, 10) === Values.value2) {
                updatedmdeItem.twelvemonthMeasurementValue_l = "";
                updatedmdeItem.twelvemonthMeasurementValue_ml = "";
                updatedmdeItem.twelvemonthMeasurementValue_nl = "";
                updatedmdeItem.twelvemonthMeasurementValue_mg = "";
                updatedmdeItem.twelvemonthMeasurement = "";
                updatedmdeItem.twelvemonthSpecimen = "";

                updatedmdeItem.q36TwelvemonthAssessmentEmpty = false;
                updatedmdeItem.q36TwelvemonthAssessmentDateEmptyError = false;
                updatedmdeItem.q36TwelvemonthAssessmentDateInvalid = false;
                updatedmdeItem.q36TwelvemonthMeasurementValueEmpty = false;
                updatedmdeItem.q36TwelvemonthMeasurementValueInvalid = false;
                updatedmdeItem.q36TwelvemonthMeasurementEmpty = false;
                updatedmdeItem.q36TwelvemonthSpecimenEmpty = false;
              }
            } else if (fieldName === "twelvemonthAssessmentDateEstimated") {
              updatedmdeItem.twelvemonthAssessment = 1;
              updatedmdeItem.q36TwelvemonthAssessmentEmpty = false;
              updatedmdeItem.q36TwelvemonthAssessmentDateEmptyError = false;
              updatedmdeItem.q36TwelvemonthAssessmentDateInvalid = false;
            }

            if (
              fieldName === "twentyonemonthAssessment" &&
              (parseInt(value, 10) === Values.value99 ||
                parseInt(value, 10) === Values.value2)
            ) {
              updatedmdeItem.twentyonemonthAssessmentDate = "";
              updatedmdeItem.twentyonemonthAssessmentDateEstimated = false;
              updatedmdeItem.q36TwentyonemonthAssessmentEmpty = false;
              if (parseInt(value, 10) === Values.value2) {
                updatedmdeItem.twentyonemonthMeasurementValue_l = "";
                updatedmdeItem.twentyonemonthMeasurementValue_ml = "";
                updatedmdeItem.twentyonemonthMeasurementValue_nl = "";
                updatedmdeItem.twentyonemonthMeasurementValue_mg = "";
                updatedmdeItem.twentyonemonthMeasurement = "";
                updatedmdeItem.twentyonemonthSpecimen = "";

                updatedmdeItem.q36TwentyonemonthAssessmentEmpty = false;
                updatedmdeItem.q36TwentyonemonthAssessmentDateEmptyError = false;
                updatedmdeItem.q36TwentyonemonthAssessmentDateInvalid = false;
                updatedmdeItem.q36TwentyonemonthMeasurementValueEmpty = false;
                updatedmdeItem.q36TwentyonemonthMeasurementValueInvalid = false;
                updatedmdeItem.q36TwentyonemonthMeasurementEmpty = false;
                updatedmdeItem.q36TwentyonemonthSpecimenEmpty = false;
              }
            } else if (fieldName === "twentyonemonthAssessmentDateEstimated") {
              updatedmdeItem.twentyonemonthAssessment = 1;
              updatedmdeItem.q36TwentyonemonthAssessmentEmpty = false;
              updatedmdeItem.q36TwentyonemonthAssessmentDateEmptyError = false;
              updatedmdeItem.q36TwentyonemonthAssessmentDateInvalid = false;
            }

            if (
              fieldName === "twentyfourmonthAssessment" &&
              (parseInt(value, 10) === Values.value99 ||
                parseInt(value, 10) === Values.value2)
            ) {
              updatedmdeItem.twentyfourmonthAssessmentDate = "";
              updatedmdeItem.twentyfourmonthAssessmentDateEstimated = false;
              updatedmdeItem.q36TwentyfourmonthAssessmentEmpty = false;
              if (parseInt(value, 10) === Values.value2) {
                updatedmdeItem.twentyfourmonthMeasurementValue_l = "";
                updatedmdeItem.twentyfourmonthMeasurementValue_ml = "";
                updatedmdeItem.twentyfourmonthMeasurementValue_nl = "";
                updatedmdeItem.twentyfourmonthMeasurementValue_mg = "";
                updatedmdeItem.twentyfourmonthMeasurement = "";
                updatedmdeItem.twentyfourmonthSpecimen = "";

                updatedmdeItem.q36TwentyfourmonthAssessmentEmpty = false;
                updatedmdeItem.q36TwentyfourmonthAssessmentDateEmptyError = false;
                updatedmdeItem.q36TwentyfourmonthAssessmentDateInvalid = false;
                updatedmdeItem.q36TwentyfourmonthMeasurementValueEmpty = false;
                updatedmdeItem.q36TwentyfourmonthMeasurementValueInvalid = false;
                updatedmdeItem.q36TwentyfourmonthMeasurementEmpty = false;
                updatedmdeItem.q36TwentyfourmonthSpecimenEmpty = false;
              }
            } else if (fieldName === "twentyfourmonthAssessmentDateEstimated") {
              updatedmdeItem.twentyfourmonthAssessment = 1;
              updatedmdeItem.q36TwentyfourmonthAssessmentEmpty = false;
              updatedmdeItem.q36TwentyfourmonthAssessmentDateEmptyError = false;
              updatedmdeItem.q36TwentyfourmonthAssessmentDateInvalid = false;
            }

            if (fieldName === "admissionSpecimen")
              updatedmdeItem.q36AdmissionspecimenEmpty = false;

            if (fieldName === "indexSpecimen")
              updatedmdeItem.q36IndexSpecimenEmpty = false;

            if (fieldName === "dischargeSpecimen")
              updatedmdeItem.q36DischargeSpecimenEmpty = false;

            if (fieldName === "threemonthSpecimen")
              updatedmdeItem.q36ThreemonthSpecimenEmpty = false;

            if (fieldName === "twelvemonthSpecimen")
              updatedmdeItem.q36TwelvemonthSpecimenEmpty = false;

            if (fieldName === "twentyonemonthSpecimen")
              updatedmdeItem.q36TwentyonemonthSpecimenEmpty = false;

            if (fieldName === "twentyfourmonthSpecimen")
              updatedmdeItem.q36TwentyfourmonthSpecimenEmpty = false;

            if (fieldName === "admissionMeasurement") {
              if (parseInt(value, 10) === Values.value99) {
                updatedmdeItem.admissionMeasurementValue_l = "";
                updatedmdeItem.admissionMeasurementValue_ml = "";
                updatedmdeItem.admissionMeasurementValue_nl = "";
                updatedmdeItem.admissionMeasurementValue_mg = "";
              } else {
                updatedmdeItem.admissionMeasurementValue_l = "";
                updatedmdeItem.admissionMeasurementValue_ml = "";
                updatedmdeItem.admissionMeasurementValue_nl = "";
                updatedmdeItem.admissionMeasurementValue_mg = "";
              }
              updatedmdeItem.q36AdmissionmeasurementEmpty = false;
              updatedmdeItem.q36AdmissionmeasurementValueInvalid = false;
              updatedmdeItem.q36AdmissionmeasurementValueEmpty = false;
            }
            if (fieldName === "admissionMeasurementValue_l") {
              updatedmdeItem.admissionMeasurementValue_l = value;
              updatedmdeItem.admissionMeasurement = textindex + 1;
              updatedmdeItem.admissionMeasurementValue_ml = "";
              updatedmdeItem.admissionMeasurementValue_nl = "";
              updatedmdeItem.admissionMeasurementValue_mg = "";
              updatedmdeItem.q36AdmissionmeasurementValueEmpty = false;
              updatedmdeItem.q36AdmissionmeasurementValueInvalid = false;
              updatedmdeItem.q36AdmissionmeasurementEmpty = false;
            } else if (fieldName === "admissionMeasurementValue_ml") {
              updatedmdeItem.admissionMeasurementValue_ml = value;
              updatedmdeItem.admissionMeasurement = textindex + 1;
              updatedmdeItem.admissionMeasurementValue_l = "";
              updatedmdeItem.admissionMeasurementValue_nl = "";
              updatedmdeItem.admissionMeasurementValue_mg = "";
              updatedmdeItem.q36AdmissionmeasurementValueEmpty = false;
              updatedmdeItem.q36AdmissionmeasurementValueInvalid = false;
              updatedmdeItem.q36AdmissionmeasurementEmpty = false;
            } else if (fieldName === "admissionMeasurementValue_nl") {
              updatedmdeItem.admissionMeasurementValue_nl = value;
              updatedmdeItem.admissionMeasurement = textindex + 1;
              updatedmdeItem.admissionMeasurementValue_ml = "";
              updatedmdeItem.admissionMeasurementValue_mg = "";
              updatedmdeItem.admissionMeasurementValue_l = "";
              updatedmdeItem.q36AdmissionmeasurementValueEmpty = false;
              updatedmdeItem.q36AdmissionmeasurementValueInvalid = false;
              updatedmdeItem.q36AdmissionmeasurementEmpty = false;
            } else if (fieldName === "admissionMeasurementValue_mg") {
              updatedmdeItem.admissionMeasurementValue_mg = value;
              updatedmdeItem.admissionMeasurement = textindex + 1;
              updatedmdeItem.admissionMeasurementValue_ml = "";
              updatedmdeItem.admissionMeasurementValue_nl = "";
              updatedmdeItem.admissionMeasurementValue_l = "";
              updatedmdeItem.q36AdmissionmeasurementValueEmpty = false;
              updatedmdeItem.q36AdmissionmeasurementValueInvalid = false;
              updatedmdeItem.q36AdmissionmeasurementEmpty = false;
            }
       

            if (fieldName === "indexMeasurement") {
              if (parseInt(value, 10) === Values.value99) {
                updatedmdeItem.indexMeasurementValue_l = "";
                updatedmdeItem.indexMeasurementValue_ml = "";
                updatedmdeItem.indexMeasurementValue_nl = "";
              } else {
                updatedmdeItem.indexMeasurementValue_l = "";
                updatedmdeItem.indexMeasurementValue_ml = "";
                updatedmdeItem.indexMeasurementValue_nl = "";
              }
              updatedmdeItem.q36IndexMeasurementEmpty = false;
              updatedmdeItem.q36IndexmeasurementValueInvalid = false;
              updatedmdeItem.q36IndexmeasurementValueEmpty = false;
            }
            if (fieldName === "indexMeasurementValue_l") {
              updatedmdeItem.indexMeasurementValue_l = value;
              updatedmdeItem.indexMeasurement = textindex + 1;
              updatedmdeItem.indexMeasurementValue_ml = "";
              updatedmdeItem.indexMeasurementValue_nl = "";
              updatedmdeItem.q36IndexMeasurementValueEmpty = false;
              updatedmdeItem.q36IndexMeasurementValueInvalid = false;
              updatedmdeItem.q36IndexMeasurementEmpty = false;
            } else if (fieldName === "indexMeasurementValue_ml") {
              updatedmdeItem.indexMeasurementValue_ml = value;
              updatedmdeItem.indexMeasurement = textindex + 1;
              updatedmdeItem.indexMeasurementValue_l = "";
              updatedmdeItem.indexMeasurementValue_nl = "";
              updatedmdeItem.q36IndexMeasurementValueEmpty = false;
              updatedmdeItem.q36IndexMeasurementValueInvalid = false;
              updatedmdeItem.q36IndexMeasurementEmpty = false;
            } else if (fieldName === "indexMeasurementValue_nl") {
              updatedmdeItem.indexMeasurementValue_nl = value;
              updatedmdeItem.indexMeasurement = textindex + 1;
              updatedmdeItem.indexMeasurementValue_ml = "";
              updatedmdeItem.indexMeasurementValue_l = "";
              updatedmdeItem.q36IndexMeasurementValueEmpty = false;
              updatedmdeItem.q36IndexMeasurementValueInvalid = false;
              updatedmdeItem.q36IndexMeasurementEmpty = false;
            }
           

            if (fieldName === "dischargeMeasurement") {
              if (parseInt(value, 10) === Values.value99) {
                updatedmdeItem.dischargeMeasurementValue_l = "";
                updatedmdeItem.dischargeMeasurementValue_ml = "";
                updatedmdeItem.dischargeMeasurementValue_nl = "";
              } else {
                updatedmdeItem.dischargeMeasurementValue_l = "";
                updatedmdeItem.dischargeMeasurementValue_ml = "";
                updatedmdeItem.dischargeMeasurementValue_nl = "";
              }
              updatedmdeItem.q36DischargeMeasurementEmpty = false;
              updatedmdeItem.q36DischargeMeasurementValueEmpty = false;
              updatedmdeItem.q36DischargeMeasurementValueInvalid = false;
            }
            if (fieldName === "dischargeMeasurementValue_l") {
              updatedmdeItem.dischargeMeasurementValue_l = value;
              updatedmdeItem.dischargeMeasurement = textindex + 1;
              updatedmdeItem.dischargeMeasurementValue_ml = "";
              updatedmdeItem.dischargeMeasurementValue_nl = "";
              updatedmdeItem.q36DischargeMeasurementValueEmpty = false;
              updatedmdeItem.q36AdmissionmeasurementValueInvalid = false;
              updatedmdeItem.q36DischargeMeasurementEmpty = false;
            } else if (fieldName === "dischargeMeasurementValue_ml") {
              updatedmdeItem.dischargeMeasurementValue_ml = value;
              updatedmdeItem.dischargeMeasurement = textindex + 1;
              updatedmdeItem.dischargeMeasurementValue_l = "";
              updatedmdeItem.dischargeMeasurementValue_nl = "";
              updatedmdeItem.q36DischargeMeasurementValueEmpty = false;
              updatedmdeItem.q36AdmissionmeasurementValueInvalid = false;
              updatedmdeItem.q36DischargeMeasurementEmpty = false;
            } else if (fieldName === "dischargeMeasurementValue_nl") {
              updatedmdeItem.dischargeMeasurementValue_nl = value;
              updatedmdeItem.dischargeMeasurement = textindex + 1;
              updatedmdeItem.dischargeMeasurementValue_ml = "";
              updatedmdeItem.dischargeMeasurementValue_l = "";
              updatedmdeItem.q36DischargeMeasurementValueEmpty = false;
              updatedmdeItem.q36AdmissionmeasurementValueInvalid = false;
              updatedmdeItem.q36DischargeMeasurementEmpty = false;
            }

            if (fieldName === "threemonthMeasurement") {
              if (parseInt(value, 10) === Values.value99) {
                updatedmdeItem.threemonthMeasurementValue_l = "";
                updatedmdeItem.threemonthMeasurementValue_ml = "";
                updatedmdeItem.threemonthMeasurementValue_nl = "";
                updatedmdeItem.threemonthMeasurementValue_mg = "";

              } else {
                updatedmdeItem.threemonthMeasurementValue_l = "";
                updatedmdeItem.threemonthMeasurementValue_ml = "";
                updatedmdeItem.threemonthMeasurementValue_nl = "";
                updatedmdeItem.threemonthMeasurementValue_mg = "";
              }
              updatedmdeItem.q36ThreemonthMeasurementEmpty = false;
              updatedmdeItem.q36ThreemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36ThreemonthMeasurementValueInvalid = false;
            }
            if (fieldName === "threemonthMeasurementValue_l") {
              updatedmdeItem.threemonthMeasurementValue_l = value;
              updatedmdeItem.threemonthMeasurement = textindex + 1;
              updatedmdeItem.threemonthMeasurementValue_ml = "";
              updatedmdeItem.threemonthMeasurementValue_nl = "";
              updatedmdeItem.threemonthMeasurementValue_mg = "";
              updatedmdeItem.q36ThreemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36ThreemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36ThreemonthMeasurementEmpty = false;
            } else if (fieldName === "threemonthMeasurementValue_ml") {
              updatedmdeItem.threemonthMeasurementValue_ml = value;
              updatedmdeItem.threemonthMeasurement = textindex + 1;
              updatedmdeItem.threemonthMeasurementValue_l = "";
              updatedmdeItem.threemonthMeasurementValue_nl = "";
              updatedmdeItem.threemonthMeasurementValue_mg = "";
              updatedmdeItem.q36ThreemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36ThreemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36ThreemonthMeasurementEmpty = false;
            } else if (fieldName === "threemonthMeasurementValue_nl") {
              updatedmdeItem.threemonthMeasurementValue_nl = value;
              updatedmdeItem.threemonthMeasurementValue_mg = "";
              updatedmdeItem.threemonthMeasurement = textindex + 1;
              updatedmdeItem.threemonthMeasurementValue_ml = "";
              updatedmdeItem.threemonthMeasurementValue_l = "";
              updatedmdeItem.q36ThreemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36ThreemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36ThreemonthMeasurementEmpty = false;
            } else if (fieldName === "threemonthMeasurementValue_mg") {
              updatedmdeItem.threemonthMeasurementValue_mg = value;
              updatedmdeItem.threemonthMeasurementValue_nl = "";
              updatedmdeItem.threemonthMeasurement = textindex + 1;
              updatedmdeItem.threemonthMeasurementValue_ml = "";
              updatedmdeItem.threemonthMeasurementValue_l = "";
              updatedmdeItem.q36ThreemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36ThreemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36ThreemonthMeasurementEmpty = false;
            }
           

            if (fieldName === "twelvemonthMeasurement") {
              if (parseInt(value, 10) === Values.value99) {
                updatedmdeItem.twelvemonthMeasurementValue_l = "";
                updatedmdeItem.twelvemonthMeasurementValue_ml = "";
                updatedmdeItem.twelvemonthMeasurementValue_nl = "";
                updatedmdeItem.twelvemonthMeasurementValue_mg = "";
              } else {
                updatedmdeItem.twelvemonthMeasurementValue_l = "";
                updatedmdeItem.twelvemonthMeasurementValue_ml = "";
                updatedmdeItem.twelvemonthMeasurementValue_nl = "";
                updatedmdeItem.twelvemonthMeasurementValue_mg = "";
              }
              updatedmdeItem.q36TwelvemonthMeasurementEmpty = false;
              updatedmdeItem.q36TwelvemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwelvemonthMeasurementValueInvalid = false;
            }
            if (fieldName === "twelvemonthMeasurementValue_l") {
              updatedmdeItem.twelvemonthMeasurementValue_l = value;
              updatedmdeItem.twelvemonthMeasurement = textindex + 1;
              updatedmdeItem.twelvemonthMeasurementValue_ml = "";
              updatedmdeItem.twelvemonthMeasurementValue_nl = "";
              updatedmdeItem.twelvemonthMeasurementValue_mg = "";
              updatedmdeItem.q36TwelvemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwelvemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwelvemonthMeasurementEmpty = false;
            } else if (fieldName === "twelvemonthMeasurementValue_ml") {
              updatedmdeItem.twelvemonthMeasurementValue_ml = value;
              updatedmdeItem.twelvemonthMeasurement = textindex + 1;
              updatedmdeItem.twelvemonthMeasurementValue_l = "";
              updatedmdeItem.twelvemonthMeasurementValue_nl = "";
              updatedmdeItem.twelvemonthMeasurementValue_mg = "";
              updatedmdeItem.q36TwelvemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwelvemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwelvemonthMeasurementEmpty = false;
            } else if (fieldName === "twelvemonthMeasurementValue_nl") {
              updatedmdeItem.twelvemonthMeasurementValue_nl = value;
              updatedmdeItem.twelvemonthMeasurement = textindex + 1;
              updatedmdeItem.twelvemonthMeasurementValue_ml = "";
              updatedmdeItem.twelvemonthMeasurementValue_mg = "";
              updatedmdeItem.twelvemonthMeasurementValue_l = "";
              updatedmdeItem.q36TwelvemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwelvemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwelvemonthMeasurementEmpty = false;
            } else if (fieldName === "twelvemonthMeasurementValue_mg") {
              updatedmdeItem.twelvemonthMeasurementValue_mg = value;
              updatedmdeItem.twelvemonthMeasurement = textindex + 1;
              updatedmdeItem.twelvemonthMeasurementValue_ml = "";
              updatedmdeItem.twelvemonthMeasurementValue_nl = "";
              updatedmdeItem.twelvemonthMeasurementValue_l = "";
              updatedmdeItem.q36TwelvemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwelvemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwelvemonthMeasurementEmpty = false;
            } 

            if (fieldName === "twentyonemonthMeasurement") {
              if (parseInt(value, 10) === Values.value99) {
                updatedmdeItem.twentyonemonthMeasurementValue_l = "";
                updatedmdeItem.twentyonemonthMeasurementValue_ml = "";
                updatedmdeItem.twentyonemonthMeasurementValue_nl = "";
                updatedmdeItem.twentyonemonthMeasurementValue_mg = "";
              } else {
                updatedmdeItem.twentyonemonthMeasurementValue_l = "";
                updatedmdeItem.twentyonemonthMeasurementValue_ml = "";
                updatedmdeItem.twentyonemonthMeasurementValue_nl = "";
                updatedmdeItem.twentyonemonthMeasurementValue_mg = "";
              }
              updatedmdeItem.q36TwentyonemonthMeasurementEmpty = false;
              updatedmdeItem.q36TwentyonemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyonemonthMeasurementValueInvalid = false;
            }
            if (fieldName === "twentyonemonthMeasurementValue_l") {
              updatedmdeItem.twentyonemonthMeasurementValue_l = value;
              updatedmdeItem.twentyonemonthMeasurement = textindex + 1;
              updatedmdeItem.twentyonemonthMeasurementValue_ml = "";
              updatedmdeItem.twentyonemonthMeasurementValue_nl = "";
              updatedmdeItem.twentyonemonthMeasurementValue_mg = "";
              updatedmdeItem.q36TwentyonemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyonemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwentyonemonthMeasurementEmpty = false;
            } else if (fieldName === "twentyonemonthMeasurementValue_ml") {
              updatedmdeItem.twentyonemonthMeasurementValue_ml = value;
              updatedmdeItem.twentyonemonthMeasurement = textindex + 1;
              updatedmdeItem.twentyonemonthMeasurementValue_l = "";
              updatedmdeItem.twentyonemonthMeasurementValue_nl = "";
              updatedmdeItem.twentyonemonthMeasurementValue_mg = "";
              updatedmdeItem.q36TwentyonemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyonemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwentyonemonthMeasurementEmpty = false;
            } else if (fieldName === "twentyonemonthMeasurementValue_nl") {
              updatedmdeItem.twentyonemonthMeasurementValue_nl = value;
              updatedmdeItem.twentyonemonthMeasurement = textindex + 1;
              updatedmdeItem.twentyonemonthMeasurementValue_ml = "";
              updatedmdeItem.twentyonemonthMeasurementValue_l = "";
              updatedmdeItem.twentyonemonthMeasurementValue_mg = "";
              updatedmdeItem.q36TwentyonemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyonemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwentyonemonthMeasurementEmpty = false;
            } else if (fieldName === "twentyonemonthMeasurementValue_mg") {
              updatedmdeItem.twentyonemonthMeasurementValue_mg = value;
              updatedmdeItem.twentyonemonthMeasurement = textindex + 1;
              updatedmdeItem.twentyonemonthMeasurementValue_ml = "";
              updatedmdeItem.twentyonemonthMeasurementValue_l = "";
              updatedmdeItem.twentyonemonthMeasurementValue_nl = "";
              updatedmdeItem.q36TwentyonemonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyonemonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwentyonemonthMeasurementEmpty = false;
            }

            if (fieldName === "twentyfourmonthMeasurement") {
              if (parseInt(value, 10) === Values.value99) {
                updatedmdeItem.twentyfourmonthMeasurementValue_l = "";
                updatedmdeItem.twentyfourmonthMeasurementValue_ml = "";
                updatedmdeItem.twentyfourmonthMeasurementValue_nl = "";
                updatedmdeItem.twentyfourmonthMeasurementValue_mg = "";
              } else {
                updatedmdeItem.twentyfourmonthMeasurementValue_l = "";
                updatedmdeItem.twentyfourmonthMeasurementValue_ml = "";
                updatedmdeItem.twentyfourmonthMeasurementValue_nl = "";
                updatedmdeItem.twentyfourmonthMeasurementValue_mg = "";
              }
              updatedmdeItem.q36TwentyfourmonthMeasurementEmpty = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementValueInvalid = false;
            }
            if (fieldName === "twentyfourmonthMeasurementValue_l") {
              updatedmdeItem.twentyfourmonthMeasurementValue_l = value;
              updatedmdeItem.twentyfourmonthMeasurement = textindex + 1;
              updatedmdeItem.twentyfourmonthMeasurementValue_ml = "";
              updatedmdeItem.twentyfourmonthMeasurementValue_nl = "";
              updatedmdeItem.twentyfourmonthMeasurementValue_mg = "";
              updatedmdeItem.q36TwentyfourmonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementEmpty = false;
            } else if (fieldName === "twentyfourmonthMeasurementValue_ml") {
              updatedmdeItem.twentyfourmonthMeasurementValue_ml = value;
              updatedmdeItem.twentyfourmonthMeasurement = textindex + 1;
              updatedmdeItem.twentyfourmonthMeasurementValue_l = "";
              updatedmdeItem.twentyfourmonthMeasurementValue_nl = "";
              updatedmdeItem.twentyfourmonthMeasurementValue_mg = "";
              updatedmdeItem.q36TwentyfourmonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementEmpty = false;
            } else if (fieldName === "twentyfourmonthMeasurementValue_nl") {
              updatedmdeItem.twentyfourmonthMeasurementValue_nl = value;
              updatedmdeItem.twentyfourmonthMeasurement = textindex + 1;
              updatedmdeItem.twentyfourmonthMeasurementValue_ml = "";
              updatedmdeItem.twentyfourmonthMeasurementValue_l = "";
              updatedmdeItem.twentyfourmonthMeasurementValue_mg = "";
              updatedmdeItem.q36TwentyfourmonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementEmpty = false;
            } else if (fieldName === "twentyfourmonthMeasurementValue_mg") {
              updatedmdeItem.twentyfourmonthMeasurementValue_mg = value;
              updatedmdeItem.twentyfourmonthMeasurement = textindex + 1;
              updatedmdeItem.twentyfourmonthMeasurementValue_ml = "";
              updatedmdeItem.twentyfourmonthMeasurementValue_l = "";
              updatedmdeItem.twentyfourmonthMeasurementValue_nl = "";
              updatedmdeItem.q36TwentyfourmonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementEmpty = false;
            } else if (fieldName === "twentyfourmonthMeasurementValue_gdl") {
              updatedmdeItem.twentyfourmonthMeasurementValue_mg = "";
              updatedmdeItem.twentyfourmonthMeasurement = textindex + 1;
              updatedmdeItem.twentyfourmonthMeasurementValue_ml = "";
              updatedmdeItem.twentyfourmonthMeasurementValue_l = "";
              updatedmdeItem.twentyfourmonthMeasurementValue_nl = "";
              updatedmdeItem.q36TwentyfourmonthMeasurementValueEmpty = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementValueInvalid = false;
              updatedmdeItem.q36TwentyfourmonthMeasurementEmpty = false;
            }

            return updatedmdeItem;
          }
          return item;
        });

        return updatedmdeDetails;
      });
    }
  };

  const HandleDateChange = (name, date, optionId, index) => {
    const lastIndex = name.lastIndexOf("-");
    const idx = name.slice(lastIndex + 1);

    switch (optionId) {
  
        case "labAssessment_dt":
        {
          let Q35array = [...labassessmentDetails];
          Q35array[idx][optionId] = date;
          Q35array[idx].labAssessment = 1;
          Q35array[idx].labAssessmentUnkLTLKT = "";
          Q35array[idx].q35assessmentDateEmptyError = false;
          Q35array[idx].q35assessmentEmpty = false;
          setlabassessmentDetails(Q35array);
        }
        break;

      case "admissionAssessmentDatedt":
        {
          let Q36array = [...mdeData];
          Q36array[idx][optionId] = date;
          Q36array[idx].admissionAssessment = 1;
          Q36array[idx].q36AdmissionassessmentDateEmptyError = false;
          Q36array[idx].q36AdmissionassessmentEmpty = false;
          setmdeData(Q36array);
        }
        break;

      case "indexAssessmentDate":
        {
          let Q36array = [...mdeData];
          Q36array[idx][optionId] = date;
          Q36array[idx].indexAssessment = 1;
          Q36array[idx].q36IndexAssessmentDateEmptyError = false;
          Q36array[idx].q36IndexAssessmentEmpty = false;
          setmdeData(Q36array);
        }
        break;

      case "dischargeAssessmentDatedt":
        {
          let Q36array = [...mdeData];
          Q36array[idx][optionId] = date;
          Q36array[idx].dischargeAssessment = 1;
          Q36array[idx].q36DischargeAssessmentDateEmptyError = false;
          Q36array[idx].q36DischargeAssessmentEmpty = false;
          setmdeData(Q36array);
        }
        break;

      case "threemonthAssessmentDate":
        {
          let Q36array = [...mdeData];
          Q36array[idx][optionId] = date;
          Q36array[idx].threemonthAssessment = 1;
          Q36array[idx].q36ThreemonthAssessmentDateEmptyError = false;
          Q36array[idx].q36ThreemonthAssessmentEmpty = false;
          setmdeData(Q36array);
        }
        break;

      case "twelvemonthAssessmentDate":
        {
          let Q36array = [...mdeData];
          Q36array[idx][optionId] = date;
          Q36array[idx].twelvemonthAssessment = 1;
          Q36array[idx].q36TwelvemonthAssessmentDateEmptyError = false;
          Q36array[idx].q36TwelvemonthAssessmentEmpty = false;
          setmdeData(Q36array);
        }
        break;
      case "twentyonemonthAssessmentDate":
        {
          let Q36array = [...mdeData];
          Q36array[idx][optionId] = date;
          Q36array[idx].twentyonemonthAssessment = 1;
          Q36array[idx].q36TwentyonemonthAssessmentDateEmptyError = false;
          Q36array[idx].q36TwentyonemonthAssessmentEmpty = false;
          setmdeData(Q36array);
        }
        break;

      case "twentyfourmonthAssessmentDate":
        {
          let Q36array = [...mdeData];
          Q36array[idx][optionId] = date;
          Q36array[idx].twentyfourmonthAssessment = 1;
          Q36array[idx].q36TwentyfourmonthAssessmentDateEmptyError = false;
          Q36array[idx].q36TwentyfourmonthAssessmentEmpty = false;
          setmdeData(Q36array);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {

    async function FetchData() {
      pidRef.current = GetLocalStorageData("patientId") || 0;
      if (pidRef.current !== 0) {
        ToggleLoader(true);
        await GetLabData();
        setQ36AdmissionHideColumn(dates?.closest_transplantAdmissionDt??true);
        //   setQ36DischargeHideColumn(dates?.closest_transplantDischargeDt ?? true);
        // setQ36IndexHideColumn(true);
          setQ36ThreeMonthHideColumn(dates?.closest_threeMonths_afterIndex ?? true);
          setQ36TwelveMonthHideColumn(dates?.closest_fifteenMonths_afterIndex ?? true);
        setQ36TwentyOneMonthHideColumn(
            dates?.closest_twentyoneMonths_afterIndex ?? true
        );
        setQ36TwentyFourMonthHideColumn(
            dates?.closest_twentysevenMonths_afterIndex ?? true
        );
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const GetLabData = async () => {
    try {
      const response = await laboratoryAssessmentService.LoadOtherLabData(
        pidRef.current,
        loggedInUserId
      );
      if (response?.status === HTTPResponse.OK) {
        const { data } = response;
        setpatientLocked(data.patientLocked);


        //#region Q35
        if (
          data.labAssessmentListDetails !== null &&
          data.labAssessmentListDetails.length > 0
        ) {
          let i = 0;
          let dataarray = [];

          for (i; i < data.labAssessmentListDetails.length; i++) {
            const detailsStart = data.labAssessmentListDetails[i];
            const assessmentUnkStart =
              detailsStart.labAssessmentDateUnknown ?? "";

            const startAssessmentUnkLTLKT =
              (!dates?.zero_to12months_before_LT_LKT &&
                assessmentUnkStart === Values.value1) ||
              (!dates?.four_to_15months_after_LT_LKT &&
                assessmentUnkStart === Values.value3) ||
              (!dates?.sixteen_to_27months_after_LT_LKT &&
                assessmentUnkStart === Values.value4)
                ? ""
                : assessmentUnkStart;

            let datacomponent = {
              labassessmentid:
                data.labAssessmentListDetails[i].labAssessmentID !== null
                  ? data.labAssessmentListDetails[i].labAssessmentID
                  : 0,

              lab:
                data.labAssessmentListDetails[i].labID !== null
                  ? data.labAssessmentListDetails[i].labID
                  : "",

              labAssessment:
                data.labAssessmentListDetails[i].labAssessment !== null
                  ? data.labAssessmentListDetails[i].labAssessment
                  : "",
              labAssessment_dt:
                data.labAssessmentListDetails[i].labAssessmentDate !== null
                  ? data.labAssessmentListDetails[i].labAssessmentDate
                  : "",
              labAssessment_dt_estimated:
                data.labAssessmentListDetails[i].labAssessmentDateEstimated !=
                null
                  ? data.labAssessmentListDetails[i].labAssessmentDateEstimated
                  : false,
              labAssessmentUnkLTLKT: startAssessmentUnkLTLKT,

              labspecimen:
                data.labAssessmentListDetails[i].labSpecimen !== null
                  ? data.labAssessmentListDetails[i].labSpecimen
                  : "",

              tyrosine_measurement:
                data.labAssessmentListDetails[i].tyrosineMeasurement !== null
                  ? data.labAssessmentListDetails[i].tyrosineMeasurement
                  : "",

              tyrosine_measurement_value_l:
                data.labAssessmentListDetails[i].tyrosineMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].tyrosineMeasurement === 1
                    ? data.labAssessmentListDetails[i].tyrosineMeasurementValue
                    : ""
                  : "",

              tyrosine_measurement_value_ml:
                data.labAssessmentListDetails[i].tyrosineMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].tyrosineMeasurement === 2
                    ? data.labAssessmentListDetails[i].tyrosineMeasurementValue
                    : ""
                  : "",

              tyrosine_measurement_value_nl:
                data.labAssessmentListDetails[i].tyrosineMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].tyrosineMeasurement === 3
                    ? data.labAssessmentListDetails[i].tyrosineMeasurementValue
                    : ""
                  : "",

                  tyrosine_measurement_value_ugdl:
                  data.labAssessmentListDetails[i].tyrosineMeasurementValue !=
                  null
                    ? data.labAssessmentListDetails[i].tyrosineMeasurement === 4
                      ? data.labAssessmentListDetails[i].tyrosineMeasurementValue
                      : ""
                    : "",

              hemoglobin_measurement:
                data.labAssessmentListDetails[i].hemaglobinMeasurement !== null
                  ? data.labAssessmentListDetails[i].hemaglobinMeasurement
                  : "",

              hemoglobin_measurement_value_gl:
                data.labAssessmentListDetails[i].hemaglobinMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].hemaglobinMeasurement === 1
                    ? data.labAssessmentListDetails[i]
                        .hemaglobinMeasurementValue
                    : ""
                  : "",
                     hemoglobin_measurement_value_gdl:
                data.labAssessmentListDetails[i].hemaglobinMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].hemaglobinMeasurement === 4
                    ? data.labAssessmentListDetails[i]
                        .hemaglobinMeasurementValue
                    : ""
                  : "",

              hemoglobin_measurement_value_mgl:
                data.labAssessmentListDetails[i].hemaglobinMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].hemaglobinMeasurement === 2
                    ? data.labAssessmentListDetails[i]
                        .hemaglobinMeasurementValue
                    : ""
                  : "",

              hemoglobin_measurement_value_mgdl:
                data.labAssessmentListDetails[i].hemaglobinMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].hemaglobinMeasurement === 3
                    ? data.labAssessmentListDetails[i]
                        .hemaglobinMeasurementValue
                    : ""
                  : "",

              hematocrit_measurement:
                data.labAssessmentListDetails[i].hematocritMeasurement !== null
                  ? data.labAssessmentListDetails[i].hematocritMeasurement
                  : "",

              hematocrit_measurement_value:
                data.labAssessmentListDetails[i].hematocritMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].hematocritMeasurement === 1
                    ? data.labAssessmentListDetails[i]
                        .hematocritMeasurementValue
                    : ""
                  : "",

              platelet_measurement:
                data.labAssessmentListDetails[i].plateletMeasurement !== null
                  ? data.labAssessmentListDetails[i].plateletMeasurement
                  : "",

              platelet_measurement_value_l:
                data.labAssessmentListDetails[i].plateletMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].plateletMeasurement === 1
                    ? data.labAssessmentListDetails[i].plateletMeasurementValue
                    : ""
                  : "",

              platelet_measurement_value_ul:
                data.labAssessmentListDetails[i].plateletMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].plateletMeasurement === 2
                    ? data.labAssessmentListDetails[i].plateletMeasurementValue
                    : ""
                  : "",

              fibroblast_measurement:
                data.labAssessmentListDetails[i].fibroblastMeasurement !== null
                  ? data.labAssessmentListDetails[i].fibroblastMeasurement
                  : "",

              fibroblast_measurement_value_ng:
                data.labAssessmentListDetails[i].fibroblastMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].fibroblastMeasurement === 1
                    ? data.labAssessmentListDetails[i]
                        .fibroblastMeasurementValue
                    : ""
                  : "",

              fibroblast_measurement_value_pg:
                data.labAssessmentListDetails[i].fibroblastMeasurementValue !=
                null
                  ? data.labAssessmentListDetails[i].fibroblastMeasurement === 2
                    ? data.labAssessmentListDetails[i]
                        .fibroblastMeasurementValue
                    : ""
                  : "",

              q35labEmpty: false,
              q35assessmentEmpty: false,
              q35specimenEmpty: false,
              q35measurementEmpty: false,
              q35assessmentDateEmptyError: false,
              q35assessmentDateInvalid: false,
              q35AssessmentDateUnkEmpty: false,
              q35measurementTyrosineEmpty: false,
              q35measurementHemaglobinEmpty: false,
              q35measurementHematocritEmpty: false,
              q35measurementPlateletEmpty: false,
              q35measurementFibroblastEmpty: false,
              q35measurementTyrosineInvalid: false,
              q35measurementHemaglobinInvalid: false,
              q35measurementHematocritInvalid: false,
              q35measurementPlateletInvalid: false,
              q35measurementFibroblastInvalid: false,
            };

            dataarray.push(datacomponent);
          }
          setlabassessmentDetails(dataarray);
        }

        //#endregion

        //#region Q36-Q55
        setmdeData((prev) =>
          prev.map((item, index) => ({
            ...item,
            labAssessmentMdeTypeId:
              data.labassessmentmdetypes[index]?.labassessmentmdetypeid || 0,
            question: data.labassessmentmdetypes[index]?.questionno || "",
            label: data.labassessmentmdetypes[index]?.name || "",
            labAssessmentMdeId:
              data.labAssessmentMdeDetails[index]?.labAssessmentMdeId || 0,
            admissionAssessment:
              data.labAssessmentMdeDetails[index]?.admissionAssessment || "",
            admissionAssessmentDatedt:
              data.labAssessmentMdeDetails[index]?.admissionAssessmentDate ||
              "",
            admissionAssessmentDateEstimated:
              data.labAssessmentMdeDetails[index]
                ?.admissionAssessmentDateEstimated || false,
            admissionSpecimen:
              data.labAssessmentMdeDetails[index]?.admissionSpecimen || "",
            admissionMeasurement:
              data.labAssessmentMdeDetails[index]?.admissionMeasurement || "",

            admissionMeasurementValue_l:
              data.labAssessmentMdeDetails[index]?.admissionMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.admissionMeasurement ===
                  1
                  ? data.labAssessmentMdeDetails[index]
                      ?.admissionMeasurementValue
                  : ""
                : "",
            admissionMeasurementValue_ml:
              data.labAssessmentMdeDetails[index]?.admissionMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.admissionMeasurement ===
                  2
                  ? data.labAssessmentMdeDetails[index]
                      ?.admissionMeasurementValue
                  : ""
                : "",
            admissionMeasurementValue_nl:
              data.labAssessmentMdeDetails[index]?.admissionMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.admissionMeasurement ===
                  3
                  ? data.labAssessmentMdeDetails[index]
                      ?.admissionMeasurementValue
                  : ""
                : "",
            admissionMeasurementValue_mg:
              data.labAssessmentMdeDetails[index]?.admissionMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.admissionMeasurement ===
                  4
                  ? data.labAssessmentMdeDetails[index]
                      ?.admissionMeasurementValue
                  : ""
                : "",

            indexAssessment:
              data.labAssessmentMdeDetails[index]?.indexAssessment || "",
            indexAssessmentDate:
              data.labAssessmentMdeDetails[index]?.indexAssessmentDate || "",
            indexAssessmentDateEstimated:
              data.labAssessmentMdeDetails[index]
                ?.indexAssessmentDateEstimated || false,
            indexSpecimen:
              data.labAssessmentMdeDetails[index]?.indexSpecimen || "",
            indexMeasurement:
              data.labAssessmentMdeDetails[index]?.indexMeasurement || "",

            indexMeasurementValue_l:
              data.labAssessmentMdeDetails[index]?.indexMeasurementValue !==
              null
                ? data.labAssessmentMdeDetails[index]?.indexMeasurement === 1
                  ? data.labAssessmentMdeDetails[index]?.indexMeasurementValue
                  : ""
                : "",
            indexMeasurementValue_ml:
              data.labAssessmentMdeDetails[index]?.indexMeasurementValue !==
              null
                ? data.labAssessmentMdeDetails[index]?.indexMeasurement === 2
                  ? data.labAssessmentMdeDetails[index]?.indexMeasurementValue
                  : ""
                : "",
            indexMeasurementValue_nl:
              data.labAssessmentMdeDetails[index]?.indexMeasurementValue !==
              null
                ? data.labAssessmentMdeDetails[index]?.indexMeasurement === 3
                  ? data.labAssessmentMdeDetails[index]?.indexMeasurementValue
                  : ""
                : "",
           
            dischargeAssessment:
              data.labAssessmentMdeDetails[index]?.dischargeAssessment || "",
            dischargeAssessmentDatedt:
              data.labAssessmentMdeDetails[index]?.dischargeAssessmentDate ||
              "",
            dischargeAssessmentDateEstimated:
              data.labAssessmentMdeDetails[index]
                ?.dischargeAssessmentDateEstimated || false,
            dischargeSpecimen:
              data.labAssessmentMdeDetails[index]?.dischargeSpecimen || "",
            dischargeMeasurement:
              data.labAssessmentMdeDetails[index]?.dischargeMeasurement || "",

            dischargeMeasurementValue_l:
              data.labAssessmentMdeDetails[index]?.dischargeMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.dischargeMeasurement ===
                  1
                  ? data.labAssessmentMdeDetails[index]
                      ?.dischargeMeasurementValue
                  : ""
                : "",
            dischargeMeasurementValue_ml:
              data.labAssessmentMdeDetails[index]?.dischargeMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.dischargeMeasurement ===
                  2
                  ? data.labAssessmentMdeDetails[index]
                      ?.dischargeMeasurementValue
                  : ""
                : "",
            dischargeMeasurementValue_nl:
              data.labAssessmentMdeDetails[index]?.dischargeMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.dischargeMeasurement ===
                  3
                  ? data.labAssessmentMdeDetails[index]
                      ?.dischargeMeasurementValue
                  : ""
                : "",
              

            threemonthAssessment:
              data.labAssessmentMdeDetails[index]?.threemonthAssessment || "",
            threemonthAssessmentDate:
              data.labAssessmentMdeDetails[index]?.threemonthAssessmentDate ||
              "",
            threemonthAssessmentDateEstimated:
              data.labAssessmentMdeDetails[index]
                ?.threemonthAssessmentDateEstimated || false,
            threemonthSpecimen:
              data.labAssessmentMdeDetails[index]?.threemonthSpecimen || "",
            threemonthMeasurement:
              data.labAssessmentMdeDetails[index]?.threemonthMeasurement || "",

            threemonthMeasurementValue_l:
              data.labAssessmentMdeDetails[index]?.threemonthMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.threemonthMeasurement ===
                  1
                  ? data.labAssessmentMdeDetails[index]
                      ?.threemonthMeasurementValue
                  : ""
                : "",
            threemonthMeasurementValue_ml:
              data.labAssessmentMdeDetails[index]?.threemonthMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.threemonthMeasurement ===
                  2
                  ? data.labAssessmentMdeDetails[index]
                      ?.threemonthMeasurementValue
                  : ""
                : "",
            threemonthMeasurementValue_nl:
              data.labAssessmentMdeDetails[index]?.threemonthMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.threemonthMeasurement ===
                  3
                  ? data.labAssessmentMdeDetails[index]
                      ?.threemonthMeasurementValue
                  : ""
                : "",
            threemonthMeasurementValue_mg:
              data.labAssessmentMdeDetails[index]?.threemonthMeasurementValue !=
              null
                ? data.labAssessmentMdeDetails[index]?.threemonthMeasurement ===
                  4
                  ? data.labAssessmentMdeDetails[index]
                      ?.threemonthMeasurementValue
                  : ""
                : "",
              

            twelvemonthAssessment:
              data.labAssessmentMdeDetails[index]?.twelvemonthAssessment || "",
            twelvemonthAssessmentDate:
              data.labAssessmentMdeDetails[index]?.twelvemonthAssessmentDate ||
              "",
            twelvemonthAssessmentDateEstimated:
              data.labAssessmentMdeDetails[index]
                ?.twelvemonthAssessmentDateEstimated || false,
            twelvemonthSpecimen:
              data.labAssessmentMdeDetails[index]?.twelvemonthSpecimen || "",
            twelvemonthMeasurement:
              data.labAssessmentMdeDetails[index]?.twelvemonthMeasurement || "",

            twelvemonthMeasurementValue_l:
              data.labAssessmentMdeDetails[index]
                ?.twelvemonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twelvemonthMeasurement === 1
                  ? data.labAssessmentMdeDetails[index]
                      ?.twelvemonthMeasurementValue
                  : ""
                : "",
            twelvemonthMeasurementValue_ml:
              data.labAssessmentMdeDetails[index]
                ?.twelvemonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twelvemonthMeasurement === 2
                  ? data.labAssessmentMdeDetails[index]
                      ?.twelvemonthMeasurementValue
                  : ""
                : "",
            twelvemonthMeasurementValue_nl:
              data.labAssessmentMdeDetails[index]
                ?.twelvemonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twelvemonthMeasurement === 3
                  ? data.labAssessmentMdeDetails[index]
                      ?.twelvemonthMeasurementValue
                  : ""
                : "",
            twelvemonthMeasurementValue_mg:
              data.labAssessmentMdeDetails[index]
                ?.twelvemonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twelvemonthMeasurement === 4
                  ? data.labAssessmentMdeDetails[index]
                      ?.twelvemonthMeasurementValue
                  : ""
                : "",

            twentyonemonthAssessment:
              data.labAssessmentMdeDetails[index]?.twentyonemonthAssessment ||
              "",
            twentyonemonthAssessmentDate:
              data.labAssessmentMdeDetails[index]
                ?.twentyonemonthAssessmentDate || "",
            twentyonemonthAssessmentDateEstimated:
              data.labAssessmentMdeDetails[index]
                ?.twentyonemonthAssessmentDateEstimated || false,
            twentyonemonthSpecimen:
              data.labAssessmentMdeDetails[index]?.twentyonemonthSpecimen || "",
            twentyonemonthMeasurement:
              data.labAssessmentMdeDetails[index]?.twentyonemonthMeasurement ||
              "",

            twentyonemonthMeasurementValue_l:
              data.labAssessmentMdeDetails[index]
                ?.twentyonemonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyonemonthMeasurement === 1
                  ? data.labAssessmentMdeDetails[index]
                      ?.twentyonemonthMeasurementValue
                  : ""
                : "",
            twentyonemonthMeasurementValue_ml:
              data.labAssessmentMdeDetails[index]
                ?.twentyonemonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyonemonthMeasurement === 2
                  ? data.labAssessmentMdeDetails[index]
                      ?.twentyonemonthMeasurementValue
                  : ""
                : "",
            twentyonemonthMeasurementValue_nl:
              data.labAssessmentMdeDetails[index]
                ?.twentyonemonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyonemonthMeasurement === 3
                  ? data.labAssessmentMdeDetails[index]
                      ?.twentyonemonthMeasurementValue
                  : ""
                : "",
            twentyonemonthMeasurementValue_mg:
              data.labAssessmentMdeDetails[index]
                ?.twentyonemonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyonemonthMeasurement === 4
                  ? data.labAssessmentMdeDetails[index]
                      ?.twentyonemonthMeasurementValue
                  : ""
                : "",
     

            twentyfourmonthAssessment:
              data.labAssessmentMdeDetails[index]?.twentyfourmonthAssessment ||
              "",
            twentyfourmonthAssessmentDate:
              data.labAssessmentMdeDetails[index]
                ?.twentyfourmonthAssessmentDate || "",
            twentyfourmonthAssessmentDateEstimated:
              data.labAssessmentMdeDetails[index]
                ?.twentyfourmonthAssessmentDateEstimated || false,
            twentyfourmonthSpecimen:
              data.labAssessmentMdeDetails[index]?.twentyfourmonthSpecimen ||
              "",
            twentyfourmonthMeasurement:
              data.labAssessmentMdeDetails[index]?.twentyfourmonthMeasurement ||
              "",

            twentyfourmonthMeasurementValue_l:
              data.labAssessmentMdeDetails[index]
                ?.twentyfourmonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyfourmonthMeasurement === 1
                  ? data.labAssessmentMdeDetails[index]
                      ?.twentyfourmonthMeasurementValue
                  : ""
                : "",
            twentyfourmonthMeasurementValue_ml:
              data.labAssessmentMdeDetails[index]
                ?.twentyfourmonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyfourmonthMeasurement === 2
                  ? data.labAssessmentMdeDetails[index]
                      ?.twentyfourmonthMeasurementValue
                  : ""
                : "",
            twentyfourmonthMeasurementValue_nl:
              data.labAssessmentMdeDetails[index]
                ?.twentyfourmonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyfourmonthMeasurement === 3
                  ? data.labAssessmentMdeDetails[index]
                      ?.twentyfourmonthMeasurementValue
                  : ""
                : "",
            twentyfourmonthMeasurementValue_mg:
              data.labAssessmentMdeDetails[index]
                ?.twentyfourmonthMeasurementValue !== null
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyfourmonthMeasurement === 4
                  ? data.labAssessmentMdeDetails[index]
                      ?.twentyfourmonthMeasurementValue
                  : ""
                : "",
            
            q36AdmissionassessmentEmpty: false,
            q36IndexAssessmentEmpty: false,
            q36ThreemonthAssessmentEmpty: false,
            q36DischargeAssessmentEmpty: false,
            q36TwelvemonthAssessmentEmpty: false,
            q36TwentyonemonthAssessmentEmpty: false,
            q36TwentyfourmonthAssessmentEmpty: false,

            q36AdmissionspecimenEmpty: false,
            q36IndexSpecimenEmpty: false,
            q36ThreemonthSpecimenEmpty: false,
            q36DischargeSpecimenEmpty: false,
            q36TwelvemonthSpecimenEmpty: false,
            q36TwentyonemonthSpecimenEmpty: false,
            q36TwentyfourmonthSpecimenEmpty: false,

            q36AdmissionmeasurementEmpty: false,
            q36IndexMeasurementEmpty: false,
            q36ThreemonthMeasurementEmpty: false,
            q36DischargeMeasurementEmpty: false,
            q36TwelvemonthMeasurementEmpty: false,
            q36TwentyonemonthMeasurementEmpty: false,
            q36TwentyfourmonthMeasurementEmpty: false,

            q36AdmissionassessmentDateEmptyError: false,
            q36IndexAssessmentDateEmptyError: false,
            q36DischargeAssessmentDateEmptyError: false,
            q36ThreemonthAssessmentDateEmptyError: false,
            q36TwelvemonthAssessmentDateEmptyError: false,
            q36TwentyonemonthAssessmentDateEmptyError: false,
            q36TwentyfourmonthAssessmentDateEmptyError: false,

            q36AdmissionassessmentDateInvalid: false,
            q36IndexAssessmentDateInvalid: false,
            q36DischargeAssessmentDateInvalid: false,
            q36TwelvemonthAssessmentDateInvalid: false,
            q36TwentyfourmonthAssessmentDateInvalid: false,
            q36TwentyonemonthAssessmentDateInvalid: false,
            q36ThreemonthAssessmentDateInvalid: false,

            q36AdmissionmeasurementValueEmpty: false,
            q36IndexMeasurementValueEmpty: false,
            q36DischargeMeasurementValueEmpty: false,
            q36ThreemonthMeasurementValueEmpty: false,
            q36TwelvemonthMeasurementValueEmpty: false,
            q36TwentyonemonthMeasurementValueEmpty: false,
            q36TwentyfourmonthMeasurementValueEmpty: false,

            q36AdmissionmeasurementValueInvalid: false,
            q36IndexMeasurementValueInvalid: false,
            q36DischargeMeasurementValueInvalid: false,
            q36ThreemonthMeasurementValueInvalid: false,
            q36TwelvemonthMeasurementValueInvalid: false,
            q36TwentyonemonthMeasurementValueInvalid: false,
            q36TwentyfourmonthMeasurementValueInvalid: false,
          }))
        );
        //#endregion
      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else {
          throw response.error;
        }
      }
    } catch {}
  };

  const SavePage = async (validate) => {
    try {
        if (!patientLocked) {
            //Reset Errors
            let isValid = validate ? Validate() : true;

            if (!isValid) {
                setShowTopErrMsg(true);
                return false;
            }
            setShowTopErrMsg(false);
            if (pidRef.current > 0) {
                const data = {
                    LabAssessmentModel: {
                        LoggedInUserId: loggedInUserId,
                        Patientid: pidRef.current,
                        IsValidated: validate,
                        IsAdmin: IsAdmin(),
                        LabBiomarkerAssessmenListDetails: [],
                        LabRenalAssessmenListDetails: [],
                        LabChronicKidneyListDetails: [],
                        LabAssessmentListDetails: [],
                        LabRenalSettingCareDetails: [],
                        LabAssessmentMdeDetails: [],
                    },
                };


                //#region Q35

                if (labassessmentDetails.length > 0) {
                    for (const assessment of labassessmentDetails) {
                        let assessmentData = {
                            labAssessmentID: assessment.labassessmentid,
                            labID: assessment.lab,
                            labAssessment: assessment.labAssessment,
                            labAssessmentDate: assessment.labAssessment_dt,
                            labAssessmentDateEstimated: assessment.labAssessment_dt_estimated,
                            labAssessmentDateUnknown: assessment.labAssessmentUnkLTLKT,
                            labSpecimen: assessment.labspecimen,
                            tyrosineMeasurement: assessment.tyrosine_measurement,
                            tyrosineMeasurementValue:
                                assessment.tyrosine_measurement === 1
                                    ? assessment.tyrosine_measurement_value_l
                                    : assessment.tyrosine_measurement === 2
                                        ? assessment.tyrosine_measurement_value_ml
                                        : assessment.tyrosine_measurement === 3
                                            ? assessment.tyrosine_measurement_value_nl
                                            : assessment.tyrosine_measurement === 4
                                                ? assessment.tyrosine_measurement_value_ugdl
                                            : "",

                            hemaglobinMeasurement: assessment.hemoglobin_measurement,
                            hemaglobinMeasurementValue:
                                assessment.hemoglobin_measurement === 1
                                    ? assessment.hemoglobin_measurement_value_gl
                                    : assessment.hemoglobin_measurement === 2
                                        ? assessment.hemoglobin_measurement_value_mgl
                                        : assessment.hemoglobin_measurement === 3
                                            ? assessment.hemoglobin_measurement_value_mgdl
                                            : assessment.hemoglobin_measurement === 4
                                            ? assessment.hemoglobin_measurement_value_gdl
                                            : "",
                            hematocritMeasurement: assessment.hematocrit_measurement,
                            hematocritMeasurementValue:
                                assessment.hematocrit_measurement_value,

                            plateletMeasurement: assessment.platelet_measurement,
                            plateletMeasurementValue:
                                assessment.platelet_measurement === 1
                                    ? assessment.platelet_measurement_value_l
                                    : assessment.platelet_measurement === 2
                                        ? assessment.platelet_measurement_value_ul
                                        : "",

                            fibroblastMeasurement: assessment.fibroblast_measurement,
                            fibroblastMeasurementValue:
                                assessment.fibroblast_measurement === 1
                                    ? assessment.fibroblast_measurement_value_ng
                                    : assessment.fibroblast_measurement === 2
                                        ? assessment.fibroblast_measurement_value_pg
                                        : "",
                        };
                        data.LabAssessmentModel.LabAssessmentListDetails.push(
                            assessmentData
                        );
                    }
                }
                //#endregion


                //#region Q36-Q55

        if (mdeData.length > 0) {
          for (const mde of mdeData) {
            let mdeCareData = {
              labAssessmentMdeId: mde.labAssessmentMdeId,
              labAssessmentMdeTypeId: mde.labAssessmentMdeTypeId,
              admissionAssessment: mde.admissionAssessment,
              admissionAssessmentDate: mde.admissionAssessmentDatedt,
              admissionAssessmentDateEstimated:
                mde.admissionAssessmentDateEstimated,
              admissionSpecimen: mde.admissionSpecimen,
              admissionMeasurement: mde.admissionMeasurement,
              admissionMeasurementValue:
                mde.admissionMeasurement === 1
                  ? mde.admissionMeasurementValue_l
                  : mde.admissionMeasurement === 2
                  ? mde.admissionMeasurementValue_ml
                  : mde.admissionMeasurement === 3
                  ? mde.admissionMeasurementValue_nl
                  : mde.admissionMeasurement === 4
                  ? mde.admissionMeasurementValue_mg
                  : "",

              indexAssessment: mde.indexAssessment,
              indexAssessmentDate: mde.indexAssessmentDate,
              indexAssessmentDateEstimated: mde.indexAssessmentDateEstimated,
              indexSpecimen: mde.indexSpecimen,
              indexMeasurement: mde.indexMeasurement,
              indexMeasurementValue:
                mde.indexMeasurement === 1
                  ? mde.indexMeasurementValue_l
                  : mde.indexMeasurement === 2
                  ? mde.indexMeasurementValue_ml
                  : mde.indexMeasurement === 3
                  ? mde.indexMeasurementValue_nl
                  : mde.indexMeasurement === 4
                  ? mde.indexMeasurementValue_mg
                  : "",

              dischargeAssessment: mde.dischargeAssessment,
              dischargeAssessmentDate: mde.dischargeAssessmentDatedt,
              dischargeAssessmentDateEstimated:
                mde.dischargeAssessmentDateEstimated,
              dischargeSpecimen: mde.dischargeSpecimen,
              dischargeMeasurement: mde.dischargeMeasurement,
              dischargeMeasurementValue:
                mde.dischargeMeasurement === 1
                  ? mde.dischargeMeasurementValue_l
                  : mde.dischargeMeasurement === 2
                  ? mde.dischargeMeasurementValue_ml
                  : mde.dischargeMeasurement === 3
                  ? mde.dischargeMeasurementValue_nl
                  : "",

              threemonthAssessment: mde.threemonthAssessment,
              threemonthAssessmentDate: mde.threemonthAssessmentDate,
              threemonthAssessmentDateEstimated:
                mde.threemonthAssessmentDateEstimated,
              threemonthSpecimen: mde.threemonthSpecimen,
              threemonthMeasurement: mde.threemonthMeasurement,
              threemonthMeasurementValue:
                mde.threemonthMeasurement === 1
                  ? mde.threemonthMeasurementValue_l
                  : mde.threemonthMeasurement === 2
                  ? mde.threemonthMeasurementValue_ml
                  : mde.threemonthMeasurement === 3
                  ? mde.threemonthMeasurementValue_nl
                  : mde.threemonthMeasurement === 4
                  ? mde.threemonthMeasurementValue_mg
                  : "",

              twelvemonthAssessment: mde.twelvemonthAssessment,
              twelvemonthAssessmentDate: mde.twelvemonthAssessmentDate,
              twelvemonthAssessmentDateEstimated:
                mde.twelvemonthAssessmentDateEstimated,
              twelvemonthSpecimen: mde.twelvemonthSpecimen,
              twelvemonthMeasurement: mde.twelvemonthMeasurement,
              twelvemonthMeasurementValue:
                mde.twelvemonthMeasurement === 1
                  ? mde.twelvemonthMeasurementValue_l
                  : mde.twelvemonthMeasurement === 2
                  ? mde.twelvemonthMeasurementValue_ml
                  : mde.twelvemonthMeasurement === 3
                  ? mde.twelvemonthMeasurementValue_nl
                  : mde.twelvemonthMeasurement === 4
                  ? mde.twelvemonthMeasurementValue_mg 
                  : "",

              twentyonemonthAssessment: mde.twentyonemonthAssessment,
              twentyonemonthAssessmentDate: mde.twentyonemonthAssessmentDate,
              twentyonemonthAssessmentDateEstimated:
                mde.twentyonemonthAssessmentDateEstimated,
              twentyonemonthSpecimen: mde.twentyonemonthSpecimen,
              twentyonemonthMeasurement: mde.twentyonemonthMeasurement,
              twentyonemonthMeasurementValue:
                mde.twentyonemonthMeasurement === 1
                  ? mde.twentyonemonthMeasurementValue_l
                  : mde.twentyonemonthMeasurement === 2
                  ? mde.twentyonemonthMeasurementValue_ml
                  : mde.twentyonemonthMeasurement === 3
                  ? mde.twentyonemonthMeasurementValue_nl
                  : mde.twentyonemonthMeasurement === 4
                  ? mde.twentyonemonthMeasurementValue_mg
                  : "",

              twentyfourmonthAssessment: mde.twentyfourmonthAssessment,
              twentyfourmonthAssessmentDate: mde.twentyfourmonthAssessmentDate,
              twentyfourmonthAssessmentDateEstimated:
                mde.twentyfourmonthAssessmentDateEstimated,
              twentyfourmonthSpecimen: mde.twentyfourmonthSpecimen,
              twentyfourmonthMeasurement: mde.twentyfourmonthMeasurement,
              twentyfourmonthMeasurementValue:
                mde.twentyfourmonthMeasurement === 1
                  ? mde.twentyfourmonthMeasurementValue_l
                  : mde.twentyfourmonthMeasurement === 2
                  ? mde.twentyfourmonthMeasurementValue_ml
                  : mde.twentyfourmonthMeasurement === 3
                  ? mde.twentyfourmonthMeasurementValue_nl
                  : mde.twentyfourmonthMeasurement === 4
                  ? mde.twentyfourmonthMeasurementValue_mg
                  : "",
            };
            data.LabAssessmentModel.LabAssessmentMdeDetails.push(mdeCareData);
          }
        }
        //#endregion

                ToggleLoader(true);
                const response = await laboratoryAssessmentService.SaveOtherLabData(
                    data.LabAssessmentModel
                );
                ToggleLoader(false);
                if (response.status !== HTTPResponse.OK) {
                    if (response?.status === HTTPResponse.Unauthorized) {
                        HandleSessionTimeout();
                    } else throw response.error;
                } else {
                    ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
                    // await LoadData();
                    if (response) {
                        const { data } = response;
                        if (data) {
                            SetAssessmentFields(data);
                        }
                    }
                }
            }
        }
      return true;
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const SetAssessmentFields = (data) => {
 
    //#region Q35
    if (
      data.labAssessmentListDetails !== null &&
      data.labAssessmentListDetails.length > 0
    ) {
      let i = 0;
      let dataarray = [];

      for (i; i < data.labAssessmentListDetails.length; i++) {
        let datacomponent = {
          labassessmentid:
            data.labAssessmentListDetails[i].labAssessmentID !== null
              ? data.labAssessmentListDetails[i].labAssessmentID
              : 0,

          lab:
            data.labAssessmentListDetails[i].labID !== null
              ? data.labAssessmentListDetails[i].labID
              : "",

          labAssessment:
            data.labAssessmentListDetails[i].labAssessment !== null
              ? data.labAssessmentListDetails[i].labAssessment
              : "",
          labAssessment_dt:
            data.labAssessmentListDetails[i].labAssessmentDate !== null
              ? data.labAssessmentListDetails[i].labAssessmentDate
              : "",
          labAssessment_dt_estimated:
            data.labAssessmentListDetails[i].labAssessmentDateEstimated !== null
              ? data.labAssessmentListDetails[i].labAssessmentDateEstimated
              : false,
          labAssessmentUnkLTLKT:
            data.labAssessmentListDetails[i].labAssessmentDateUnknown !== null
              ? data.labAssessmentListDetails[i].labAssessmentDateUnknown
              : "",

          labspecimen:
            data.labAssessmentListDetails[i].labSpecimen !== null
              ? data.labAssessmentListDetails[i].labSpecimen
              : "",

          tyrosine_measurement:
            data.labAssessmentListDetails[i].tyrosineMeasurement !== null
              ? data.labAssessmentListDetails[i].tyrosineMeasurement
              : "",

          tyrosine_measurement_value_l:
            data.labAssessmentListDetails[i].tyrosineMeasurementValue !== null
              ? data.labAssessmentListDetails[i].tyrosineMeasurement === 1
                ? data.labAssessmentListDetails[i].tyrosineMeasurementValue
                : ""
              : "",

          tyrosine_measurement_value_ml:
            data.labAssessmentListDetails[i].tyrosineMeasurementValue !== null
              ? data.labAssessmentListDetails[i].tyrosineMeasurement === 2
                ? data.labAssessmentListDetails[i].tyrosineMeasurementValue
                : ""
              : "",

          tyrosine_measurement_value_nl:
            data.labAssessmentListDetails[i].tyrosineMeasurementValue !== null
              ? data.labAssessmentListDetails[i].tyrosineMeasurement === 3
                ? data.labAssessmentListDetails[i].tyrosineMeasurementValue
                : ""
              : "",

              tyrosine_measurement_value_ugdl:
            data.labAssessmentListDetails[i].tyrosineMeasurementValue !== null
              ? data.labAssessmentListDetails[i].tyrosineMeasurement === 4
                ? data.labAssessmentListDetails[i].tyrosineMeasurementValue
                : ""
                : "",
          

          hemoglobin_measurement:
            data.labAssessmentListDetails[i].hemaglobinMeasurement !== null
              ? data.labAssessmentListDetails[i].hemaglobinMeasurement
              : "",

          hemoglobin_measurement_value_gl:
            data.labAssessmentListDetails[i].hemaglobinMeasurementValue !== null
              ? data.labAssessmentListDetails[i].hemaglobinMeasurement === 1
                ? data.labAssessmentListDetails[i].hemaglobinMeasurementValue
                : ""
              : "",
              hemoglobin_measurement_value_gdl:
            data.labAssessmentListDetails[i].hemaglobinMeasurementValue !== null
              ? data.labAssessmentListDetails[i].hemaglobinMeasurement === 4
                ? data.labAssessmentListDetails[i].hemaglobinMeasurementValue
                : ""
              : "",

          hemoglobin_measurement_value_mgl:
            data.labAssessmentListDetails[i].hemaglobinMeasurementValue !== null
              ? data.labAssessmentListDetails[i].hemaglobinMeasurement === 2
                ? data.labAssessmentListDetails[i].hemaglobinMeasurementValue
                : ""
              : "",

          hemoglobin_measurement_value_mgdl:
            data.labAssessmentListDetails[i].hemaglobinMeasurementValue !== null
              ? data.labAssessmentListDetails[i].hemaglobinMeasurement === 3
                ? data.labAssessmentListDetails[i].hemaglobinMeasurementValue
                : ""
              : "",

          hematocrit_measurement:
            data.labAssessmentListDetails[i].hematocritMeasurement !== null
              ? data.labAssessmentListDetails[i].hematocritMeasurement
              : "",

          hematocrit_measurement_value:
            data.labAssessmentListDetails[i].hematocritMeasurementValue !== null
              ? data.labAssessmentListDetails[i].hematocritMeasurement === 1
                ? data.labAssessmentListDetails[i].hematocritMeasurementValue
                : ""
              : "",

          platelet_measurement:
            data.labAssessmentListDetails[i].plateletMeasurement !== null
              ? data.labAssessmentListDetails[i].plateletMeasurement
              : "",

          platelet_measurement_value_l:
            data.labAssessmentListDetails[i].plateletMeasurementValue !== null
              ? data.labAssessmentListDetails[i].plateletMeasurement === 1
                ? data.labAssessmentListDetails[i].plateletMeasurementValue
                : ""
              : "",

          platelet_measurement_value_ul:
            data.labAssessmentListDetails[i].plateletMeasurementValue !== null
              ? data.labAssessmentListDetails[i].plateletMeasurement === 2
                ? data.labAssessmentListDetails[i].plateletMeasurementValue
                : ""
              : "",

          fibroblast_measurement:
            data.labAssessmentListDetails[i].fibroblastMeasurement !== null
              ? data.labAssessmentListDetails[i].fibroblastMeasurement
              : "",

          fibroblast_measurement_value_ng:
            data.labAssessmentListDetails[i].fibroblastMeasurementValue !== null
              ? data.labAssessmentListDetails[i].fibroblastMeasurement === 1
                ? data.labAssessmentListDetails[i].fibroblastMeasurementValue
                : ""
              : "",

          fibroblast_measurement_value_pg:
            data.labAssessmentListDetails[i].fibroblastMeasurementValue !== null
              ? data.labAssessmentListDetails[i].fibroblastMeasurement === 2
                ? data.labAssessmentListDetails[i].fibroblastMeasurementValue
                : ""
              : "",
          q35labEmpty: false,
          q35assessmentEmpty: false,
          q35specimenEmpty: false,
          q35measurementEmpty: false,
          q35assessmentDateEmptyError: false,
          q35assessmentDateInvalid: false,
          q35AssessmentDateUnkEmpty: false,
          q35measurementTyrosineEmpty: false,
          q35measurementHemaglobinEmpty: false,
          q35measurementHematocritEmpty: false,
          q35measurementPlateletEmpty: false,
          q35measurementFibroblastEmpty: false,
          q35measurementTyrosineInvalid: false,
          q35measurementHemaglobinInvalid: false,
          q35measurementHematocritInvalid: false,
          q35measurementPlateletInvalid: false,
          q35measurementFibroblastInvalid: false,
        };

        dataarray.push(datacomponent);
      }
      setlabassessmentDetails(dataarray);
    }
    //#endregion

    //#region Q36-Q55
    setmdeData((prev) =>
      prev
        .map((item, index) => ({
          ...item,
          labAssessmentMdeTypeId:
            data.labassessmentmdetypes[index]?.labassessmentmdetypeid || 0,
          question: data.labassessmentmdetypes[index]?.questionno || "",
          label: data.labassessmentmdetypes[index]?.name || "",
          labAssessmentMdeId:
            data.labAssessmentMdeDetails[index]?.labAssessmentMdeId || 0,
          admissionAssessment:
            data.labAssessmentMdeDetails[index]?.admissionAssessment || "",
          admissionAssessmentDatedt:
            data.labAssessmentMdeDetails[index]?.admissionAssessmentDate || "",
          admissionAssessmentDateEstimated:
            data.labAssessmentMdeDetails[index]
              ?.admissionAssessmentDateEstimated || false,
          admissionSpecimen:
            data.labAssessmentMdeDetails[index]?.admissionSpecimen || "",
          admissionMeasurement:
            data.labAssessmentMdeDetails[index]?.admissionMeasurement || "",

          admissionMeasurementValue_l:
            data.labAssessmentMdeDetails[index]?.admissionMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.admissionMeasurement === 1
                ? data.labAssessmentMdeDetails[index]?.admissionMeasurementValue
                : ""
              : "",
          admissionMeasurementValue_ml:
            data.labAssessmentMdeDetails[index]?.admissionMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.admissionMeasurement === 2
                ? data.labAssessmentMdeDetails[index]?.admissionMeasurementValue
                : ""
              : "",
          admissionMeasurementValue_nl:
            data.labAssessmentMdeDetails[index]?.admissionMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.admissionMeasurement === 3
                ? data.labAssessmentMdeDetails[index]?.admissionMeasurementValue
                : ""
              : "",
          admissionMeasurementValue_mg:
            data.labAssessmentMdeDetails[index]?.admissionMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.admissionMeasurement === 4
                ? data.labAssessmentMdeDetails[index]?.admissionMeasurementValue
                : ""
              : "",
        

          indexAssessment:
            data.labAssessmentMdeDetails[index]?.indexAssessment || "",
          indexAssessmentDate:
            data.labAssessmentMdeDetails[index]?.indexAssessmentDate || "",
          indexAssessmentDateEstimated:
            data.labAssessmentMdeDetails[index]?.indexAssessmentDateEstimated ||
            false,
          indexSpecimen:
            data.labAssessmentMdeDetails[index]?.indexSpecimen || "",
          indexMeasurement:
            data.labAssessmentMdeDetails[index]?.indexMeasurement || "",

          indexMeasurementValue_l:
            data.labAssessmentMdeDetails[index]?.indexMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]?.indexMeasurement === 1
                ? data.labAssessmentMdeDetails[index]?.indexMeasurementValue
                : ""
              : "",
          indexMeasurementValue_ml:
            data.labAssessmentMdeDetails[index]?.indexMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]?.indexMeasurement === 2
                ? data.labAssessmentMdeDetails[index]?.indexMeasurementValue
                : ""
              : "",
          indexMeasurementValue_nl:
            data.labAssessmentMdeDetails[index]?.indexMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]?.indexMeasurement === 3
                ? data.labAssessmentMdeDetails[index]?.indexMeasurementValue
                : ""
              : "",
        

          dischargeAssessment:
            data.labAssessmentMdeDetails[index]?.dischargeAssessment || "",
          dischargeAssessmentDatedt:
            data.labAssessmentMdeDetails[index]?.dischargeAssessmentDate || "",
          dischargeAssessmentDateEstimated:
            data.labAssessmentMdeDetails[index]
              ?.dischargeAssessmentDateEstimated || false,
          dischargeSpecimen:
            data.labAssessmentMdeDetails[index]?.dischargeSpecimen || "",
          dischargeMeasurement:
            data.labAssessmentMdeDetails[index]?.dischargeMeasurement || "",

          dischargeMeasurementValue_l:
            data.labAssessmentMdeDetails[index]?.dischargeMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.dischargeMeasurement === 1
                ? data.labAssessmentMdeDetails[index]?.dischargeMeasurementValue
                : ""
              : "",
          dischargeMeasurementValue_ml:
            data.labAssessmentMdeDetails[index]?.dischargeMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.dischargeMeasurement === 2
                ? data.labAssessmentMdeDetails[index]?.dischargeMeasurementValue
                : ""
              : "",
          dischargeMeasurementValue_nl:
            data.labAssessmentMdeDetails[index]?.dischargeMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.dischargeMeasurement === 3
                ? data.labAssessmentMdeDetails[index]?.dischargeMeasurementValue
                : ""
              : "",
          

          threemonthAssessment:
            data.labAssessmentMdeDetails[index]?.threemonthAssessment || "",
          threemonthAssessmentDate:
            data.labAssessmentMdeDetails[index]?.threemonthAssessmentDate || "",
          threemonthAssessmentDateEstimated:
            data.labAssessmentMdeDetails[index]
              ?.threemonthAssessmentDateEstimated || false,
          threemonthSpecimen:
            data.labAssessmentMdeDetails[index]?.threemonthSpecimen || "",
          threemonthMeasurement:
            data.labAssessmentMdeDetails[index]?.threemonthMeasurement || "",

          threemonthMeasurementValue_l:
            data.labAssessmentMdeDetails[index]?.threemonthMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.threemonthMeasurement === 1
                ? data.labAssessmentMdeDetails[index]
                    ?.threemonthMeasurementValue
                : ""
              : "",
          threemonthMeasurementValue_ml:
            data.labAssessmentMdeDetails[index]?.threemonthMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.threemonthMeasurement === 2
                ? data.labAssessmentMdeDetails[index]
                    ?.threemonthMeasurementValue
                : ""
              : "",
          threemonthMeasurementValue_nl:
            data.labAssessmentMdeDetails[index]?.threemonthMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.threemonthMeasurement === 3
                ? data.labAssessmentMdeDetails[index]
                    ?.threemonthMeasurementValue
                : ""
              : "",
          threemonthMeasurementValue_mg:
            data.labAssessmentMdeDetails[index]?.threemonthMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.threemonthMeasurement === 4
                ? data.labAssessmentMdeDetails[index]
                    ?.threemonthMeasurementValue
                : ""
              : "",
  
          twelvemonthAssessment:
            data.labAssessmentMdeDetails[index]?.twelvemonthAssessment || "",
          twelvemonthAssessmentDate:
            data.labAssessmentMdeDetails[index]?.twelvemonthAssessmentDate ||
            "",
          twelvemonthAssessmentDateEstimated:
            data.labAssessmentMdeDetails[index]
              ?.twelvemonthAssessmentDateEstimated || false,
          twelvemonthSpecimen:
            data.labAssessmentMdeDetails[index]?.twelvemonthSpecimen || "",
          twelvemonthMeasurement:
            data.labAssessmentMdeDetails[index]?.twelvemonthMeasurement || "",

          twelvemonthMeasurementValue_l:
            data.labAssessmentMdeDetails[index]?.twelvemonthMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.twelvemonthMeasurement ===
                1
                ? data.labAssessmentMdeDetails[index]
                    ?.twelvemonthMeasurementValue
                : ""
              : "",
          twelvemonthMeasurementValue_ml:
            data.labAssessmentMdeDetails[index]?.twelvemonthMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.twelvemonthMeasurement ===
                2
                ? data.labAssessmentMdeDetails[index]
                    ?.twelvemonthMeasurementValue
                : ""
              : "",
          twelvemonthMeasurementValue_nl:
            data.labAssessmentMdeDetails[index]?.twelvemonthMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.twelvemonthMeasurement ===
                3
                ? data.labAssessmentMdeDetails[index]
                    ?.twelvemonthMeasurementValue
                : ""
              : "",
          twelvemonthMeasurementValue_mg:
            data.labAssessmentMdeDetails[index]?.twelvemonthMeasurementValue !=
            null
              ? data.labAssessmentMdeDetails[index]?.twelvemonthMeasurement ===
                4
                ? data.labAssessmentMdeDetails[index]
                    ?.twelvemonthMeasurementValue
                : ""
              : "",

          twentyonemonthAssessment:
            data.labAssessmentMdeDetails[index]?.twentyonemonthAssessment || "",
          twentyonemonthAssessmentDate:
            data.labAssessmentMdeDetails[index]?.twentyonemonthAssessmentDate ||
            "",
          twentyonemonthAssessmentDateEstimated:
            data.labAssessmentMdeDetails[index]
              ?.twentyonemonthAssessmentDateEstimated || false,
          twentyonemonthSpecimen:
            data.labAssessmentMdeDetails[index]?.twentyonemonthSpecimen || "",
          twentyonemonthMeasurement:
            data.labAssessmentMdeDetails[index]?.twentyonemonthMeasurement ||
            "",

          twentyonemonthMeasurementValue_l:
            data.labAssessmentMdeDetails[index]
              ?.twentyonemonthMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]
                  ?.twentyonemonthMeasurement === 1
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyonemonthMeasurementValue
                : ""
              : "",
          twentyonemonthMeasurementValue_ml:
            data.labAssessmentMdeDetails[index]
              ?.twentyonemonthMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]
                  ?.twentyonemonthMeasurement === 2
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyonemonthMeasurementValue
                : ""
              : "",
          twentyonemonthMeasurementValue_nl:
            data.labAssessmentMdeDetails[index]
              ?.twentyonemonthMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]
                  ?.twentyonemonthMeasurement === 3
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyonemonthMeasurementValue
                : ""
              : "",
          twentyonemonthMeasurementValue_mg:
            data.labAssessmentMdeDetails[index]
              ?.twentyonemonthMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]
                  ?.twentyonemonthMeasurement === 4
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyonemonthMeasurementValue
                : ""
              : "",

          twentyfourmonthAssessment:
            data.labAssessmentMdeDetails[index]?.twentyfourmonthAssessment ||
            "",
          twentyfourmonthAssessmentDate:
            data.labAssessmentMdeDetails[index]
              ?.twentyfourmonthAssessmentDate || "",
          twentyfourmonthAssessmentDateEstimated:
            data.labAssessmentMdeDetails[index]
              ?.twentyfourmonthAssessmentDateEstimated || false,
          twentyfourmonthSpecimen:
            data.labAssessmentMdeDetails[index]?.twentyfourmonthSpecimen || "",
          twentyfourmonthMeasurement:
            data.labAssessmentMdeDetails[index]?.twentyfourmonthMeasurement ||
            "",

          twentyfourmonthMeasurementValue_l:
            data.labAssessmentMdeDetails[index]
              ?.twentyfourmonthMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]
                  ?.twentyfourmonthMeasurement === 1
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyfourmonthMeasurementValue
                : ""
              : "",
          twentyfourmonthMeasurementValue_ml:
            data.labAssessmentMdeDetails[index]
              ?.twentyfourmonthMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]
                  ?.twentyfourmonthMeasurement === 2
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyfourmonthMeasurementValue
                : ""
              : "",
          twentyfourmonthMeasurementValue_nl:
            data.labAssessmentMdeDetails[index]
              ?.twentyfourmonthMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]
                  ?.twentyfourmonthMeasurement === 3
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyfourmonthMeasurementValue
                : ""
              : "",
          twentyfourmonthMeasurementValue_mg:
            data.labAssessmentMdeDetails[index]
              ?.twentyfourmonthMeasurementValue !== null
              ? data.labAssessmentMdeDetails[index]
                  ?.twentyfourmonthMeasurement === 4
                ? data.labAssessmentMdeDetails[index]
                    ?.twentyfourmonthMeasurementValue
                : ""
              : "",
        
          q36AdmissionassessmentEmpty: false,
          q36IndexAssessmentEmpty: false,
          q36ThreemonthAssessmentEmpty: false,
          q36DischargeAssessmentEmpty: false,
          q36TwelvemonthAssessmentEmpty: false,
          q36TwentyonemonthAssessmentEmpty: false,
          q36TwentyfourmonthAssessmentEmpty: false,

          q36AdmissionspecimenEmpty: false,
          q36IndexSpecimenEmpty: false,
          q36ThreemonthSpecimenEmpty: false,
          q36DischargeSpecimenEmpty: false,
          q36TwelvemonthSpecimenEmpty: false,
          q36TwentyonemonthSpecimenEmpty: false,
          q36TwentyfourmonthSpecimenEmpty: false,

          q36AdmissionmeasurementEmpty: false,
          q36IndexMeasurementEmpty: false,
          q36ThreemonthMeasurementEmpty: false,
          q36DischargeMeasurementEmpty: false,
          q36TwelvemonthMeasurementEmpty: false,
          q36TwentyonemonthMeasurementEmpty: false,
          q36TwentyfourmonthMeasurementEmpty: false,

          q36AdmissionassessmentDateEmptyError: false,
          q36IndexAssessmentDateEmptyError: false,
          q36DischargeAssessmentDateEmptyError: false,
          q36ThreemonthAssessmentDateEmptyError: false,
          q36TwelvemonthAssessmentDateEmptyError: false,
          q36TwentyonemonthAssessmentDateEmptyError: false,
          q36TwentyfourmonthAssessmentDateEmptyError: false,

          q36AdmissionassessmentDateInvalid: false,
          q36IndexAssessmentDateInvalid: false,
          q36DischargeAssessmentDateInvalid: false,
          q36TwelvemonthAssessmentDateInvalid: false,
          q36TwentyfourmonthAssessmentDateInvalid: false,
          q36TwentyonemonthAssessmentDateInvalid: false,
          q36ThreemonthAssessmentDateInvalid: false,

          q36AdmissionmeasurementValueEmpty: false,
          q36IndexMeasurementValueEmpty: false,
          q36DischargeMeasurementValueEmpty: false,
          q36ThreemonthMeasurementValueEmpty: false,
          q36TwelvemonthMeasurementValueEmpty: false,
          q36TwentyonemonthMeasurementValueEmpty: false,
          q36TwentyfourmonthMeasurementValueEmpty: false,

          q36AdmissionmeasurementValueInvalid: false,
          q36IndexMeasurementValueInvalid: false,
          q36DischargeMeasurementValueInvalid: false,
          q36ThreemonthMeasurementValueInvalid: false,
          q36TwelvemonthMeasurementValueInvalid: false,
          q36TwentyonemonthMeasurementValueInvalid: false,
          q36TwentyfourmonthMeasurementValueInvalid: false,
        }))
        .sort((a, b) => a.labAssessmentMdeTypeId - b.labAssessmentMdeTypeId)
    );
    //#endregion
  };

  const validateConcentrationUnits = (
    value,
    unit,
    LitreMinRange,
    litreMaxRange
  ) => {
    let validrange;
    //const minL = 0, maxL = 60000; // Allowed range in Litres

    let volumeInLitres;
    let litreMaxRanges = litreMaxRange;
    let LitreMinRanges = LitreMinRange;
    volumeInLitres = value;
    // if (unit === "L" || unit === "nl") {
    //   volumeInLitres = value; // No conversion needed
    // } else
    if (unit === "mL") {
      // volumeInLitres = value ; // Convert to Litres
      litreMaxRanges = litreMaxRanges / 1000;
    }

    if (unit === "mg") {
      // volumeInLitres = value ; // Convert to Litres
        litreMaxRanges =  1200;
    }

    if(unit === "ug/dL"){
     
      LitreMinRanges = 0;
        litreMaxRanges =  1200;
    }

    if (volumeInLitres >= LitreMinRanges && volumeInLitres <= litreMaxRanges) {
      validrange = false;
    } else validrange = true; 

    return validrange;
  };

  const validateMassConcentrationUnits = (value, unit, MinRange, MaxRange) => {
    let validrange;

    let volumeInGrams;
    let gramsMaxRanges = MaxRange;
    volumeInGrams = value;
    // if (unit === "L" || unit === "mL") {
    //   volumeInGrams = value; // No conversion needed
    // } else
    if (unit === "dl") {
      //  volumeInGrams = value / 10; // Convert to dL
      gramsMaxRanges = gramsMaxRanges / 10;
    }

    if (volumeInGrams >= MinRange && volumeInGrams <= gramsMaxRanges) {
      validrange = false;
    } else validrange = true;

    return validrange;
  };




// Convert µmol/L → mg/dL
const umolToMgDl = (umolValue) => {
  const conversionFactor = 0.011312; // (Molar Mass / 10,000), M = 113.12 g/mol
  return umolValue * conversionFactor;
};

// Validate if user input falls in serum creatinine range (mg/dL)
const validateCreatinineMgDl = (umolValue, minRange , maxRange ) => {
  
  let validrange;
  const mgDlValue = umolToMgDl(umolValue); //user value umol - mg/dL
  maxRange = umolToMgDl(900); //max value umol 900 to mg/dL
  // return {
  //   isValid: mgDlValue >= minRange && mgDlValue <= maxRange,
  // };

  if (mgDlValue >= minRange && mgDlValue <= maxRange) {
    validrange = false;
  } else validrange = true;

  return validrange;
};



  const validateMassUnits = (value, unit, MinRange, MaxRange) => {
    
    let validrange;

    let volumeInGrams;

    //if (unit === "g") {
    volumeInGrams = value; // No conversion needed  
    if (unit === "L") {
      // volumeInGrams = value * 1000; // Convert to mg/L
      MaxRange = MaxRange * 1000;
    } else if (unit === "dL") {
      //  volumeInGrams = value * 100; // Convert to dL
      MaxRange = MaxRange * 100;
    }

    else if (unit === "mg"){ //--g/dL
      MaxRange = 10;
    }
    else if (unit =="gdL"){
       MaxRange = 30;
    }

    if (volumeInGrams >= MinRange && volumeInGrams <= MaxRange) {
      validrange = false;
    } else validrange = true;

    return validrange;
  };

  const validateMillimoleUnits = (value, unit, MinRange, MaxRange) => {
    let validrange;
    let unitsValue;
    if (value !== "") {
      // Convert mmol/L to µmol/L
      unitsValue = value;//* 1000;
      // if (unit === "mL") {
      //   // Convert mmol/L to µmol/mL
      //   unitsValue = unitsValue / 1000;
      // }
      // Convert range bounds to µmol/L

      let maxValueRanges = MaxRange * 1000;
      let maxValueRange;
      if (unit === "mL") {
        maxValueRange = maxValueRanges / 1000;
      }
      else{
         maxValueRange = maxValueRanges;
      }

      if (unitsValue >= MinRange && unitsValue <= maxValueRange) {
        validrange = false;
      } else validrange = true;
    } else validrange = true;
    return validrange;
  };

  const validateSmallConcentrationUnits = (value, unit, MinRange, MaxRange) => {
    let validrange;
    let unitsValue;
    if (value !== "") {
      if (unit === "ng") unitsValue = value;
      else {
        // Convertng/mL to pg/mL
        unitsValue = value;
      }

      // Convert range bounds to µmol/L
      let minValueRange = MinRange;
      let maxValueRange;
      maxValueRange = MaxRange;
      if (unit === "pg") {
        maxValueRange = MaxRange * 1000;
      }

      if (unitsValue >= minValueRange && unitsValue <= maxValueRange) {
        validrange = false;
      } else validrange = true;
    } else validrange = true;
    return validrange;
  };

  const validateMeasurement = (
    labDetails,
    qarray,
    index,
    maxLimit,
    questionno,
    isValidValue
  ) => {
    let isValid = isValidValue;


    //#region  Q35
    if (questionno === "Q35") {
      if (
        [
          Values.value1,
          Values.value2,
          Values.value4,
          Values.value5,
          Values.value6,
          Values.value7,
          Values.value8,
          Values.value9,
          Values.value10,
          Values.value11,
          Values.value12,
          Values.value13,
        ].includes(labDetails.lab)
      ) {
        if(labDetails.tyrosine_measurement !== Values.value99) {

          if (labDetails.lab === Values.value4 ) {
           const measurementValue =
              labDetails.tyrosine_measurement === 1
                ? labDetails.tyrosine_measurement_value_l
                : labDetails.tyrosine_measurement === 2
                ? labDetails.tyrosine_measurement_value_ml
                : labDetails.tyrosine_measurement === 3
                ? labDetails.tyrosine_measurement_value_nl
                : labDetails.tyrosine_measurement_value_ugdl; // For µg/dL option
    
           const unit =
              labDetails.tyrosine_measurement === 1
                ? "L"
                : labDetails.tyrosine_measurement === 2
                ? "mL"
                : labDetails.tyrosine_measurement === 3
                ? "mg"
                : "ug/dL"; // Here is the new µg/dL unit

                
                qarray[index].q35measurementTyrosineInvalid =
                validateConcentrationUnits(measurementValue, unit, 0, 1600);
              if (qarray[index].q35measurementTyrosineInvalid) {
                isValid = false;
              }
              
          } 
          else{
        const measurementValue =
          labDetails.tyrosine_measurement === 1
            ? labDetails.tyrosine_measurement_value_l
            : labDetails.tyrosine_measurement === 2
            ? labDetails.tyrosine_measurement_value_ml
            : labDetails.tyrosine_measurement_value_nl
           
        const unit =
          labDetails.tyrosine_measurement === 1
            ? "L"
            : labDetails.tyrosine_measurement === 3
            ? "nl"
            : labDetails.tyrosine_measurement === 4
            ? "mg"
            : "mL";
        qarray[index].q35measurementTyrosineInvalid =
          validateConcentrationUnits(measurementValue, unit, 0, maxLimit);
        if (qarray[index].q35measurementTyrosineInvalid) {
          isValid = false;
        }
      }
       }
      } else if (labDetails.lab === Values.value3) {
        if(labDetails.tyrosine_measurement !== Values.value99) {
        const measurementValue =
          labDetails.tyrosine_measurement === 1
            ? labDetails.tyrosine_measurement_value_l
            : labDetails.tyrosine_measurement === 2
            ? labDetails.tyrosine_measurement_value_ml
            : labDetails.tyrosine_measurement_value_nl;
        const unit =
          labDetails.tyrosine_measurement === 1
            ? "L"
            : labDetails.tyrosine_measurement === 3
            ? "nl"
            : labDetails.tyrosine_measurement === 4
            ? "mg"
            : "mL";
        qarray[index].q35measurementTyrosineInvalid = validateConcentrationUnits(
          measurementValue,
          unit,
          0,
          maxLimit
        );
        if (qarray[index].q35measurementTyrosineInvalid) {
          isValid = false;
        }
      }
      } else if (labDetails.lab === Values.value14) {
        if(labDetails.hemoglobin_measurement !== Values.value99) {
        const measurementValue =
          labDetails.hemoglobin_measurement === 1
            ? labDetails.hemoglobin_measurement_value_gl
            : labDetails.hemoglobin_measurement === 2
            ? labDetails.hemoglobin_measurement_value_mgl
            :labDetails.hemoglobin_measurement === 3
            ? labDetails.hemoglobin_measurement_value_mgdl
            :labDetails.hemoglobin_measurement_value_gdl;
        const unit =
          labDetails.hemoglobin_measurement === 1
            ? "g"
            : labDetails.hemoglobin_measurement === 2
            ? "L"
            : labDetails.hemoglobin_measurement === 3
            ? "dL"
            :"gdL";
        qarray[index].q35measurementHemaglobinInvalid = validateMassUnits(
          measurementValue,
          unit,
          0,
          labDetails.hemoglobin_measurement==4?30: maxLimit
        );
        if (qarray[index].q35measurementHemaglobinInvalid) {
          isValid = false;
        }
      }
      } else if (labDetails.lab === Values.value15) {
        if(labDetails.hematocrit_measurement !== Values.value99) {
        const measurementValue = labDetails.hematocrit_measurement_value;
        qarray[index].q35measurementHematocritInvalid =
          measurementValue < 0 || measurementValue > maxLimit ? true : false;
        if (qarray[index].q35measurementHematocritInvalid) {
          isValid = false;
        }
      }
      } else if (
        [
          "",
          Values.value16,
          Values.value17,
          Values.value18,
          Values.value19,
        ].includes(labDetails.lab)
      ) {
        if(labDetails.platelet_measurement !== Values.value99) {
        const measurementValue =
          labDetails.platelet_measurement === 1
            ? labDetails.platelet_measurement_value_l
            : labDetails.platelet_measurement_value_ul;
        qarray[index].q35measurementPlateletInvalid =
          measurementValue < 0 || measurementValue > maxLimit ? true : false;
        if (qarray[index].q35measurementPlateletInvalid) {
          isValid = false;
        }
      }
      } else {
        if(labDetails.fibroblast_measurement !== Values.value99) {

        const measurementValue =
          labDetails.fibroblast_measurement === 1
            ? labDetails.fibroblast_measurement_value_ng
            : labDetails.fibroblast_measurement_value_pg;
        const unit = labDetails.fibroblast_measurement === 1 ? "ng" : "pg";
        if (
          (labDetails.fibroblast_measurement_value_ng !== "" ||
            labDetails.fibroblast_measurement_value_pg !== "") &&
          labDetails.fibroblast_measurement !== Values.value99
        ) {
          qarray[index].q35measurementFibroblastInvalid =
            validateSmallConcentrationUnits(
              measurementValue,
              unit,
              0,
              maxLimit
            );
          if (qarray[index].q35measurementFibroblastInvalid) {
            isValid = false;
          }
        }
        }
      }
    }
    //#endregion


    //#region  Q36
    if (questionno === "Q36") {
      if (
        [
          Values.value1,
          Values.value2,
          Values.value4,
          Values.value5,
          Values.value6,
          Values.value7,
          Values.value8,
          Values.value9,
          Values.value10,
          Values.value11,
          Values.value12,
          Values.value13,
        ].includes(labDetails.labAssessmentMdeTypeId)
      ) {
        const AdmissionmeasurementValue =
          labDetails.admissionMeasurement === 1
            ? labDetails.admissionMeasurementValue_l
            : labDetails.admissionMeasurement === 2
            ? labDetails.admissionMeasurementValue_ml
            : labDetails.admissionMeasurement === 3
            ? labDetails.admissionMeasurementValue_nl
            : labDetails.admissionMeasurementValue_mg;
        const Admissionunit =
          labDetails.admissionMeasurement === 1
            ? "L"
            : labDetails.admissionMeasurement === 3
            ? "nl"
            : labDetails.admissionMeasurement === 4
            ? "mg"
            : "mL";
        if (Q36AdmissionHideColumn === true) {
          qarray[index].q36AdmissionmeasurementValueInvalid =
            validateConcentrationUnits(
              AdmissionmeasurementValue,
              Admissionunit,
              0,
              maxLimit
            );
          if (qarray[index].q36AdmissionmeasurementValueInvalid) {
            isValid = false;
          }
        }

        const dischargemeasurementValue =
          labDetails.dischargeMeasurement === 1
            ? labDetails.dischargeMeasurementValue_l
            : labDetails.dischargeMeasurement === 2
            ? labDetails.dischargeMeasurementValue_ml
            : labDetails.dischargeMeasurementValue_nl;
        const dischargeunit =
          labDetails.dischargeMeasurement === 1
            ? "L"
            : labDetails.dischargeMeasurement === 3
            ? "nl"
            : labDetails.dischargeMeasurement === 4
            ? "mg"
            : "mL";

        if (Q36DischargeHideColumn === true) {
          qarray[index].q36DischargeMeasurementValueInvalid =
            validateConcentrationUnits(
              dischargemeasurementValue,
              dischargeunit,
              0,
              maxLimit
            );
          if (qarray[index].q36DischargeMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const indexmeasurementValue =
          labDetails.indexMeasurement === 1
            ? labDetails.indexMeasurementValue_l
            : labDetails.indexMeasurement === 2
            ? labDetails.indexMeasurementValue_ml
            : labDetails.indexMeasurementValue_nl;
        const indexunit =
          labDetails.indexMeasurement === 1
            ? "L"
            : labDetails.indexMeasurement === 3
            ? "nl"
            : labDetails.indexMeasurement === 4
            ? "mg"
            : "mL";
        // qarray[index].q36IndexMeasurementValueInvalid =
        //   validateConcentrationUnits(
        //     indexmeasurementValue,
        //     indexunit,
        //     0,
        //     maxLimit
        //   );
        // if (qarray[index].q36IndexMeasurementValueInvalid) {
        //   isValid = false;
        // }

        const threeMonthmeasurementValue =
          labDetails.threemonthMeasurement === 1
            ? labDetails.threemonthMeasurementValue_l
            : labDetails.threemonthMeasurement === 2
            ? labDetails.threemonthMeasurementValue_ml
            : labDetails.threemonthMeasurement === 3
            ? labDetails.threemonthMeasurementValue_nl
            : labDetails.threemonthMeasurementValue_mg;
        const threeMonthunit =
          labDetails.threemonthMeasurement === 1
            ? "L"
            : labDetails.threemonthMeasurement === 3
            ? "nl"
            : labDetails.threemonthMeasurement === 4
            ? "mg"
            : "mL";
        if (Q36ThreeMonthHideColumn === true) {
          qarray[index].q36ThreemonthMeasurementValueInvalid =
            validateConcentrationUnits(
              threeMonthmeasurementValue,
              threeMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36ThreemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twelveMonthmeasurementValue =
          labDetails.twelvemonthMeasurement === 1
            ? labDetails.twelvemonthMeasurementValue_l
            : labDetails.twelvemonthMeasurement === 2
            ? labDetails.twelvemonthMeasurementValue_ml
            : labDetails.twelvemonthMeasurement === 3
            ? labDetails.twelvemonthMeasurementValue_nl
            : labDetails.twelvemonthMeasurementValue_mg;
        const twelveMonthunit =
          labDetails.twelvemonthMeasurement === 1
            ? "L"
            : labDetails.twelvemonthMeasurement === 3
            ? "nl"
            : labDetails.twelvemonthMeasurement === 4
            ? "mg"
            : "mL";
        if (Q36TwelveMonthHideColumn === true) {
          qarray[index].q36TwelvemonthMeasurementValueInvalid =
            validateConcentrationUnits(
              twelveMonthmeasurementValue,
              twelveMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36TwelvemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twentyoneMonthmeasurementValue =
          labDetails.twentyonemonthMeasurement === 1
            ? labDetails.twentyonemonthMeasurementValue_l
            : labDetails.twentyonemonthMeasurement === 2
            ? labDetails.twentyonemonthMeasurementValue_ml
            : labDetails.twentyonemonthMeasurement === 3
            ? labDetails.twentyonemonthMeasurementValue_nl
            : labDetails.twentyonemonthMeasurementValue_mg;
        const twentyoneMonthunit =
          labDetails.twentyonemonthMeasurement === 1
            ? "L"
            : labDetails.twentyonemonthMeasurement === 3
            ? "nl"
            : labDetails.twentyonemonthMeasurement === 4
            ? "mg"
            : "mL";
        if (Q36TwentyOneMonthHideColumn === true) {
          qarray[index].q36TwentyonemonthMeasurementValueInvalid =
            validateConcentrationUnits(
              twentyoneMonthmeasurementValue,
              twentyoneMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36TwentyonemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twentyfourMonthmeasurementValue =
          labDetails.twentyfourmonthMeasurement === 1
            ? labDetails.twentyfourmonthMeasurementValue_l
            : labDetails.twentyfourmonthMeasurement === 2
            ? labDetails.twentyfourmonthMeasurementValue_ml
            : labDetails.twentyfourmonthMeasurement === 3
            ? labDetails.twentyfourmonthMeasurementValue_nl
            : labDetails.twentyfourmonthMeasurementValue_mg;
        const twentyfourMonthunit =
          labDetails.twentyfourmonthMeasurement === 1
            ? "L"
            : labDetails.twentyfourmonthMeasurement === 3
            ? "nl"
            : labDetails.twentyfourmonthMeasurement === 4
            ? "mg"
            : "mL";
        if (Q36TwentyFourMonthHideColumn === true) {
          qarray[index].q36TwentyfourmonthMeasurementValueInvalid =
            validateConcentrationUnits(
              twentyfourMonthmeasurementValue,
              twentyfourMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36TwentyfourmonthMeasurementValueInvalid) {
            isValid = false;
          }
        }
      } else if (labDetails.labAssessmentMdeTypeId === Values.value3) {
        const AdmissionmeasurementValue =
          labDetails.admissionMeasurement === 1
            ? labDetails.admissionMeasurementValue_l
            : labDetails.admissionMeasurement === 2
            ? labDetails.admissionMeasurementValue_ml
            : labDetails.admissionMeasurement === 3
            ? labDetails.admissionMeasurementValue_nl
            : labDetails.admissionMeasurementValue_mg;
        const Admissionunit =
          labDetails.admissionMeasurement === 1
            ? "L"
            : labDetails.admissionMeasurement === 3
            ? "nl"
            : labDetails.admissionMeasurement === 4 
            ? "mg"
            : "mL";
        if (
          qarray[index].q36AdmissionassessmentEmpty === false &&
          qarray[index].q36AdmissionmeasurementValueEmpty === false &&
          Q36AdmissionHideColumn === true &&
          labDetails.admissionMeasurement !== 4 && labDetails.admissionMeasurement !== ""&&
          labDetails.admissionAssessment !== 2
        ) {
          qarray[index].q36AdmissionmeasurementValueInvalid =
            validateMillimoleUnits(
              AdmissionmeasurementValue,
              Admissionunit,
              0,
              maxLimit
            );
          if (qarray[index].q36AdmissionmeasurementValueInvalid) {
            isValid = false;
          }
        }

        const dischargemeasurementValue =
          labDetails.dischargeMeasurement === 1
            ? labDetails.dischargeMeasurementValue_l
            : labDetails.dischargeMeasurement === 2
            ? labDetails.dischargeMeasurementValue_ml
            : labDetails.dischargeMeasurementValue_nl;
        const dischargeunit =
          labDetails.dischargeMeasurement === 1
            ? "L"
            : labDetails.dischargeMeasurement === 3
            ? "nl"
            : labDetails.dischargeMeasurement === 4
            ? "mg"
            : "mL";
        if (
          qarray[index].q36DischargeAssessmentEmpty === false &&
          qarray[index].q36DischargeMeasurementValueEmpty === false &&
          Q36DischargeHideColumn === true &&
          labDetails.dischargeMeasurement !== 4 &&labDetails.dischargeMeasurement !== ""&&
          labDetails.dischargeAssessment !== 2
        ) {
          qarray[index].q36DischargeMeasurementValueInvalid =
            validateMillimoleUnits(
              dischargemeasurementValue,
              dischargeunit,
              0,
              maxLimit
            );
          if (qarray[index].q36DischargeMeasurementValueInvalid) {
            isValid = false;
          }
        }
        const indexmeasurementValue =
          labDetails.indexMeasurement === 1
            ? labDetails.indexMeasurementValue_l
            : labDetails.indexMeasurement === 2
            ? labDetails.indexMeasurementValue_ml
            : labDetails.indexMeasurementValue_nl;
        const indexunit =
          labDetails.indexMeasurement === 1
            ? "L"
            : labDetails.indexMeasurement === 3
            ? "nl"
            : labDetails.indexMeasurement === 4
            ? "mg"
            : "mL";
        // if (
        //   qarray[index].q36IndexAssessmentEmpty === false &&
        //   qarray[index].q36IndexMeasurementValueEmpty === false &&
        //   //   setQ36IndexHideColumn == false &&
        //   labDetails.indexMeasurement !== 4 &&labDetails.indexMeasurement !== ""&&
        //   labDetails.indexAssessment !== 2
        // ) {
        //   // qarray[index].q36IndexMeasurementValueInvalid =
        //   //   validateMillimoleUnits(
        //   //     indexmeasurementValue,
        //   //     indexunit,
        //   //     0,
        //   //     maxLimit
        //   //   );
        //   // if (qarray[index].q36IndexMeasurementValueInvalid) {
        //   //   isValid = false;
        //   // }
        // }

        const threeMonthmeasurementValue =
          labDetails.threemonthMeasurement === 1
            ? labDetails.threemonthMeasurementValue_l
            : labDetails.threemonthMeasurement === 2
            ? labDetails.threemonthMeasurementValue_ml
            : labDetails.threemonthMeasurement === 3
            ? labDetails.threemonthMeasurementValue_nl
            : labDetails.threemonthMeasurementValue_mg;
        const threeMonthunit =
          labDetails.threemonthMeasurement === 1
            ? "L"
            : labDetails.threemonthMeasurement === 3
            ? "nl"
            : labDetails.threemonthMeasurement === 4
            ? "mg"
            : "mL";
        if (
          qarray[index].q36ThreemonthAssessmentEmpty === false &&
          qarray[index].q36ThreemonthMeasurementValueEmpty === false &&
          Q36ThreeMonthHideColumn === true &&
          labDetails.threemonthMeasurement !== 4 &&labDetails.threemonthMeasurement !== ""&&
          labDetails.threemonthAssessment !== 2
        ) {
          qarray[index].q36ThreemonthMeasurementValueInvalid =
            validateMillimoleUnits(
              threeMonthmeasurementValue,
              threeMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36ThreemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twelveMonthmeasurementValue =
          labDetails.twelvemonthMeasurement === 1
            ? labDetails.twelvemonthMeasurementValue_l
            : labDetails.twelvemonthMeasurement === 2
            ? labDetails.twelvemonthMeasurementValue_ml
            : labDetails.twelvemonthMeasurement === 3
            ? labDetails.twelvemonthMeasurementValue_nl
            : labDetails.twelvemonthMeasurementValue_mg;
        const twelveMonthunit =
          labDetails.twelvemonthMeasurement === 1
            ? "L"
            : labDetails.twelvemonthMeasurement === 3
            ? "nl"
            : labDetails.twelvemonthMeasurement === 4
            ? "mg"
            : "mL";
        if (
          qarray[index].q36TwelvemonthAssessmentEmpty === false &&
          qarray[index].q36TwelvemonthMeasurementValueEmpty === false &&
          Q36TwelveMonthHideColumn === true &&
          labDetails.twelvemonthMeasurement !== 4 &&labDetails.twelvemonthMeasurement !== ""&&
          labDetails.twelvemonthAssessment !== 2
        ) {
          qarray[index].q36TwelvemonthMeasurementValueInvalid =
            validateMillimoleUnits(
              twelveMonthmeasurementValue,
              twelveMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36TwelvemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twentyoneMonthmeasurementValue =
          labDetails.twentyonemonthMeasurement === 1
            ? labDetails.twentyonemonthMeasurementValue_l
            : labDetails.twentyonemonthMeasurement === 2
            ? labDetails.twentyonemonthMeasurementValue_ml
            : labDetails.twentyonemonthMeasurement === 3
            ? labDetails.twentyonemonthMeasurementValue_nl
            : labDetails.twentyonemonthMeasurementValue_mg;
        const twentyoneMonthunit =
          labDetails.twentyonemonthMeasurement === 1
            ? "L"
            : labDetails.twentyonemonthMeasurement === 3
            ? "nl"
            : labDetails.twentyonemonthMeasurement === 4
            ? "mg"
            : "mL";
        if (
          qarray[index].q36TwentyonemonthAssessmentEmpty === false &&
          qarray[index].q36TwentyonemonthMeasurementValueEmpty === false &&
          Q36TwentyOneMonthHideColumn === true &&
          labDetails.twentyonemonthMeasurement !== 4 &&labDetails.twentyonemonthMeasurement !== ""&&
          labDetails.twentyonemonthAssessment !== 2
        ) {
          qarray[index].q36TwentyonemonthMeasurementValueInvalid =
            validateMillimoleUnits(
              twentyoneMonthmeasurementValue,
              twentyoneMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36TwentyonemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twentyfourMonthmeasurementValue =
          labDetails.twentyfourmonthMeasurement === 1
            ? labDetails.twentyfourmonthMeasurementValue_l
            : labDetails.twentyfourmonthMeasurement === 2
            ? labDetails.twentyfourmonthMeasurementValue_ml
            : labDetails.twentyfourmonthMeasurement === 3
            ? labDetails.twentyfourmonthMeasurementValue_nl
            : labDetails.twentyfourmonthMeasurementValue_mg;
        const twentyfourMonthunit =
          labDetails.twentyfourmonthMeasurement === 1
            ? "L"
            : labDetails.twentyfourmonthMeasurement === 3
            ? "nl"
            : labDetails.twentyfourmonthMeasurement === 4
            ? "mg"
            : "mL";
        if (
          qarray[index].q36TwentyfourmonthAssessmentEmpty === false &&
          qarray[index].q36TwentyfourmonthMeasurementValueEmpty === false &&
          Q36TwentyFourMonthHideColumn === true &&
          labDetails.twentyfourmonthMeasurement !== 4 &&labDetails.twentyfourmonthMeasurement !== ""&&
          labDetails.twentyfourmonthAssessment !== 2
        ) {
          qarray[index].q36TwentyfourmonthMeasurementValueInvalid =
            validateMillimoleUnits(
              twentyfourMonthmeasurementValue,
              twentyfourMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36TwentyfourmonthMeasurementValueInvalid) {
            isValid = false;
          }
        }
      } else if (labDetails.labAssessmentMdeTypeId === Values.value14) {
        const AdmissionmeasurementValue =
          labDetails.admissionMeasurement === 1
            ? labDetails.admissionMeasurementValue_l
            : labDetails.admissionMeasurement === 2
            ? labDetails.admissionMeasurementValue_ml
            : labDetails.admissionMeasurement === 3
            ? labDetails.admissionMeasurementValue_nl
            : labDetails.admissionMeasurementValue_mg;
        const Admissionunit =
          labDetails.admissionMeasurement === 1
            ? "g"
            : labDetails.admissionMeasurement === 3
            ? "L"
            : labDetails.admissionMeasurement === 2
            ? "gdL"
            : "dL";
        if (Q36AdmissionHideColumn === true) {
          qarray[index].q36AdmissionmeasurementValueInvalid = validateMassUnits(
            AdmissionmeasurementValue,
            Admissionunit,
            0,
           labDetails.admissionMeasurement === 2?30: maxLimit
          );
          if (qarray[index].q36AdmissionmeasurementValueInvalid) {
            isValid = false;
          }
        }

        const dischargemeasurementValue =
          labDetails.dischargeMeasurement === 1
            ? labDetails.dischargeMeasurementValue_l
            : labDetails.dischargeMeasurement === 2
            ? labDetails.dischargeMeasurementValue_ml
            : labDetails.dischargeMeasurementValue_nl;
        const dischargeunit =
          labDetails.dischargeMeasurement === 1
            ? "g"
            : labDetails.dischargeMeasurement === 3
            ? "L"
            : "dL";
        if (Q36DischargeHideColumn === true) {
          qarray[index].q36DischargeMeasurementValueInvalid = validateMassUnits(
            dischargemeasurementValue,
            dischargeunit,
            0,
            maxLimit
          );
          if (qarray[index].q36DischargeMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const indexmeasurementValue =
          labDetails.indexMeasurement === 1
            ? labDetails.indexMeasurementValue_l
            : labDetails.indexMeasurement === 2
            ? labDetails.indexMeasurementValue_ml
            : labDetails.indexMeasurementValue_nl;
        const indexunit =
          labDetails.indexMeasurement === 1
            ? "g"
            : labDetails.indexMeasurement === 3
            ? "L"

            : "dL";
        // if (Q36IndexHideColumn == false) {
        // qarray[index].q36IndexMeasurementValueInvalid = validateMassUnits(
        //   indexmeasurementValue,
        //   indexunit,
        //   0,
        //   maxLimit
        // );
        // if (qarray[index].q36IndexMeasurementValueInvalid) {
        //   isValid = false;
        // }
        //  }

        const threeMonthmeasurementValue =
          labDetails.threemonthMeasurement === 1
            ? labDetails.threemonthMeasurementValue_l
            : labDetails.threemonthMeasurement === 2
            ? labDetails.threemonthMeasurementValue_ml
            : labDetails.threemonthMeasurement === 3
            ? labDetails.threemonthMeasurementValue_nl
            : labDetails.threemonthMeasurementValue_mg;
        const threeMonthunit =
          labDetails.threemonthMeasurement === 1
            ? "g"
            : labDetails.threemonthMeasurement === 3
            ? "L"
            : labDetails.threemonthMeasurement === 2
            ? "gdL"
            : "dL";
        if (Q36ThreeMonthHideColumn === true) {
          qarray[index].q36ThreemonthMeasurementValueInvalid =
            validateMassUnits(
              threeMonthmeasurementValue,
              threeMonthunit,
              0,
              labDetails.threemonthMeasurement === 2?30:maxLimit
            );
          if (qarray[index].q36ThreemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twelveMonthmeasurementValue =
          labDetails.twelvemonthMeasurement === 1
            ? labDetails.twelvemonthMeasurementValue_l
            : labDetails.twelvemonthMeasurement === 2
            ? labDetails.twelvemonthMeasurementValue_ml
            : labDetails.twelvemonthMeasurement === 3
            ? labDetails.twelvemonthMeasurementValue_nl
            : labDetails.twelvemonthMeasurementValue_mg;
        const twelveMonthunit =
          labDetails.twelvemonthMeasurement === 1
            ? "g"
            : labDetails.twelvemonthMeasurement === 3
            ? "L"
            : labDetails.twelvemonthMeasurement === 2
            ? "gdL"
            : "dL";
        if (Q36TwelveMonthHideColumn === true) {
          qarray[index].q36TwelvemonthMeasurementValueInvalid =
            validateMassUnits(
              twelveMonthmeasurementValue,
              twelveMonthunit,
              0,
              labDetails.twelvemonthMeasurement === 2?30:maxLimit
            );
          if (qarray[index].q36TwelvemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }
        const twentyoneMonthmeasurementValue =
          labDetails.twentyonemonthMeasurement === 1
            ? labDetails.twentyonemonthMeasurementValue_l
            : labDetails.twentyonemonthMeasurement === 2
            ? labDetails.twentyonemonthMeasurementValue_ml
            : labDetails.twentyonemonthMeasurement === 3
            ? labDetails.twentyonemonthMeasurementValue_nl

            : labDetails.twentyonemonthMeasurementValue_mg;
        const twentyoneMonthunit =
          labDetails.twentyonemonthMeasurement === 1
            ? "g"
            : labDetails.twentyonemonthMeasurement === 3
            ? "L"
            : labDetails.twentyonemonthMeasurement === 2
            ? "gdL"
            : "dL";
        if (Q36TwentyOneMonthHideColumn === true) {
          qarray[index].q36TwentyonemonthMeasurementValueInvalid =
            validateMassUnits(
              twentyoneMonthmeasurementValue,
              twentyoneMonthunit,
              0,
             labDetails.twentyonemonthMeasurement === 2?30: maxLimit
            );
          if (qarray[index].q36TwentyonemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twentyfourMonthmeasurementValue =
          labDetails.twentyfourmonthMeasurement === 1
            ? labDetails.twentyfourmonthMeasurementValue_l
            : labDetails.twentyfourmonthMeasurement === 2
            ? labDetails.twentyfourmonthMeasurementValue_ml
            : labDetails.twentyfourmonthMeasurement === 3
            ? labDetails.twentyfourmonthMeasurementValue_nl

            : labDetails.twentyfourmonthMeasurementValue_mg;
        const twentyfourMonthunit =
          labDetails.twentyfourmonthMeasurement === 1
            ? "g"
            : labDetails.twentyfourmonthMeasurement === 3
            ? "L"
            : labDetails.twentyfourmonthMeasurement === 2
            ? "gdL"
            : "dL";
        if (Q36TwentyFourMonthHideColumn === true) {
          qarray[index].q36TwentyfourmonthMeasurementValueInvalid =
            validateMassUnits(
              twentyfourMonthmeasurementValue,
              twentyfourMonthunit,
              0,
             labDetails.twentyfourmonthMeasurement === 2?30: maxLimit
            );
          if (qarray[index].q36TwentyfourmonthMeasurementValueInvalid) {
            isValid = false;
          }
        }
      } else if (labDetails.labAssessmentMdeTypeId === Values.value15) {
        const AdmissionmeasurementValue =
          labDetails.admissionMeasurementValue_l;
        if (Q36AdmissionHideColumn === true) {
          qarray[index].q36AdmissionmeasurementValueInvalid =
            AdmissionmeasurementValue < 0 ||
            AdmissionmeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36AdmissionmeasurementValueInvalid) {
            isValid = false;
          }
        }

        const dischargemeasurementValue =
          labDetails.dischargeMeasurementValue_l;
        if (Q36DischargeHideColumn === true) {
          qarray[index].q36DischargeMeasurementValueInvalid =
            dischargemeasurementValue < 0 ||
            dischargemeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36DischargeMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const indexmeasurementValue = labDetails.indexMeasurementValue_l;
        // qarray[index].q36IndexMeasurementValueInvalid =
        //   indexmeasurementValue < 0 || indexmeasurementValue > maxLimit
        //     ? true
        //     : false;
        // if (qarray[index].q36IndexMeasurementValueInvalid) {
        //   isValid = false;
        // }

        const threeMonthmeasurementValue =
          labDetails.threemonthMeasurementValue_l;
        if (Q36ThreeMonthHideColumn === true) {
          qarray[index].q36ThreemonthMeasurementValueInvalid =
            threeMonthmeasurementValue < 0 ||
            threeMonthmeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36ThreemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twelveMonthmeasurementValue =
          labDetails.twelvemonthMeasurementValue_l;
        if (Q36TwelveMonthHideColumn === true) {
          qarray[index].q36TwelvemonthMeasurementValueInvalid =
            twelveMonthmeasurementValue < 0 ||
            twelveMonthmeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36TwelvemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twentyoneMonthmeasurementValue =
          labDetails.twentyonemonthMeasurementValue_l;
        if (Q36TwentyOneMonthHideColumn === true) {
          qarray[index].q36TwentyonemonthMeasurementValueInvalid =
            twentyoneMonthmeasurementValue < 0 ||
            twentyoneMonthmeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36TwentyonemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twentyfourMonthmeasurementValue =
          labDetails.twentyfourmonthMeasurementValue_l;
        if (Q36TwentyFourMonthHideColumn === true) {
          qarray[index].q36TwentyfourmonthMeasurementValueInvalid =
            twentyfourMonthmeasurementValue < 0 ||
            twentyfourMonthmeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36TwentyfourmonthMeasurementValueInvalid) {
            isValid = false;
          }
        }
      } else if (
        [
          "",
          Values.value16,
          Values.value17,
          Values.value18,
          Values.value19,
        ].includes(labDetails.labAssessmentMdeTypeId)
      ) {
        const AdmissionmeasurementValue =
          labDetails.admissionMeasurement === 1
            ? labDetails.admissionMeasurementValue_l
            : labDetails.admissionMeasurementValue_ml;
        if (Q36AdmissionHideColumn === true) {
          qarray[index].q36AdmissionmeasurementValueInvalid =
            AdmissionmeasurementValue < 0 ||
            AdmissionmeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36AdmissionmeasurementValueInvalid) {
            isValid = false;
          }
        }

        const dischargemeasurementValue =
          labDetails.dischargeMeasurement === 1
            ? labDetails.dischargeMeasurementValue_l
            : labDetails.dischargeMeasurementValue_ml;
        if (Q36DischargeHideColumn === true) {
          qarray[index].q36DischargeMeasurementValueInvalid =
            dischargemeasurementValue < 0 ||
            dischargemeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36DischargeMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const indexmeasurementValue =
          labDetails.indexMeasurement === 1
            ? labDetails.indexMeasurementValue_l
            : labDetails.indexMeasurementValue_ml;
        // if (Q36IndexHideColumn == false) {
        // qarray[index].q36IndexMeasurementValueInvalid =
        //   indexmeasurementValue < 0 || indexmeasurementValue > maxLimit
        //     ? true
        //     : false;
        // if (qarray[index].q36IndexMeasurementValueInvalid) {
        //   isValid = false;
        // }
        //  }

        const threeMonthmeasurementValue =
          labDetails.threemonthMeasurement === 1
            ? labDetails.threemonthMeasurementValue_l
            : labDetails.threemonthMeasurementValue_ml;
        if (Q36ThreeMonthHideColumn === true) {
          qarray[index].q36ThreemonthMeasurementValueInvalid =
            threeMonthmeasurementValue < 0 ||
            threeMonthmeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36ThreemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twelveMonthmeasurementValue =
          labDetails.twelvemonthMeasurement === 1
            ? labDetails.twelvemonthMeasurementValue_l
            : labDetails.twelvemonthMeasurementValue_ml;
        if (Q36TwelveMonthHideColumn === true) {
          qarray[index].q36TwelvemonthMeasurementValueInvalid =
            twelveMonthmeasurementValue < 0 ||
            twelveMonthmeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36TwelvemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twentyoneMonthmeasurementValue =
          labDetails.twentyonemonthMeasurement === 1
            ? labDetails.twentyonemonthMeasurementValue_l
            : labDetails.twentyonemonthMeasurementValue_ml;
        if (Q36TwentyOneMonthHideColumn === true) {
          qarray[index].q36TwentyonemonthMeasurementValueInvalid =
            twentyoneMonthmeasurementValue < 0 ||
            twentyoneMonthmeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36TwentyonemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twentyfourMonthmeasurementValue =
          labDetails.twentyfourmonthMeasurement === 1
            ? labDetails.twentyfourmonthMeasurementValue_l
            : labDetails.twentyfourmonthMeasurementValue_ml;
        if (Q36TwentyFourMonthHideColumn === true) {
          qarray[index].q36TwentyfourmonthMeasurementValueInvalid =
            twentyfourMonthmeasurementValue < 0 ||
            twentyfourMonthmeasurementValue > maxLimit
              ? true
              : false;
          if (qarray[index].q36TwentyfourmonthMeasurementValueInvalid) {
            isValid = false;
          }
        }
      } else {
        const AdmissionmeasurementValue =
          labDetails.admissionMeasurement === 1
            ? labDetails.admissionMeasurementValue_l
            : labDetails.admissionMeasurementValue_ml;
        const Admissionunit =
          labDetails.admissionMeasurement === 1 ? "ng" : "pg";

        if (
          qarray[index].q36AdmissionassessmentEmpty === false &&
          qarray[index].q36AdmissionmeasurementValueEmpty === false &&
          Q36AdmissionHideColumn === true &&
          labDetails.admissionMeasurement !== 3 &&
          labDetails.admissionAssessment !== 2
        ) {
          qarray[index].q36AdmissionmeasurementValueInvalid =
            validateSmallConcentrationUnits(
              AdmissionmeasurementValue,
              Admissionunit,
              0,
              maxLimit
            );
          if (qarray[index].q36AdmissionmeasurementValueInvalid) {
            isValid = false;
          }
        }

        const dischargemeasurementValue =
          labDetails.dischargeMeasurement === 1
            ? labDetails.dischargeMeasurementValue_l
            : labDetails.dischargeMeasurementValue_ml;
        const dischargeunit =
          labDetails.dischargeMeasurement === 1 ? "ng" : "pg";
        if (
          qarray[index].q36DischargeAssessmentEmpty === false &&
          qarray[index].q36DischargeMeasurementValueEmpty === false &&
          Q36DischargeHideColumn === true &&
          labDetails.dischargeMeasurement !== 3 &&
          labDetails.dischargeAssessment !== 2
        ) {
          qarray[index].q36DischargeMeasurementValueInvalid =
            validateSmallConcentrationUnits(
              dischargemeasurementValue,
              dischargeunit,
              0,
              maxLimit
            );
          if (qarray[index].q36DischargeMeasurementValueInvalid) {
            isValid = false;
          }
        }

        // const indexmeasurementValue =
        //   labDetails.indexMeasurement === 1
        //     ? labDetails.indexMeasurementValue_l
        //     : labDetails.indexMeasurementValue_ml;
        // const indexunit = labDetails.indexMeasurement === 1 ? "ng" : "pg";
        // if (
        //   qarray[index].q36IndexAssessmentEmpty === false &&
        //   qarray[index].q36IndexMeasurementValueEmpty === false &&
        //   //   Q36IndexHideColumn == false &&
        //   labDetails.indexMeasurement !== 3 &&
        //   labDetails.indexAssessment !== 2
        // ) {
        //   // qarray[index].q36IndexMeasurementValueInvalid =
        //   //   validateSmallConcentrationUnits(
        //   //     indexmeasurementValue,
        //   //     indexunit,
        //   //     0,
        //   //     maxLimit
        //   //   );
        //   // if (qarray[index].q36IndexMeasurementValueInvalid) {
        //   //   isValid = false;
        //   // }
        // }

        const threeMonthmeasurementValue =
          labDetails.threemonthMeasurement === 1
            ? labDetails.threemonthMeasurementValue_l
            : labDetails.threemonthMeasurementValue_ml;
        const threeMonthunit =
          labDetails.threemonthMeasurement === 1 ? "ng" : "pg";
        if (
          qarray[index].q36ThreemonthAssessmentEmpty === false &&
          qarray[index].q36ThreemonthMeasurementValueEmpty === false &&
          Q36ThreeMonthHideColumn === true &&
          labDetails.threemonthMeasurement !== 3 &&
          labDetails.threemonthAssessment !== 2
        ) {
          qarray[index].q36ThreemonthMeasurementValueInvalid =
            validateSmallConcentrationUnits(
              threeMonthmeasurementValue,
              threeMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36ThreemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twelveMonthmeasurementValue =
          labDetails.twelvemonthMeasurement === 1
            ? labDetails.twelvemonthMeasurementValue_l
            : labDetails.twelvemonthMeasurementValue_ml;
        const twelveMonthunit =
          labDetails.twelvemonthMeasurement === 1 ? "ng" : "pg";
        if (
          qarray[index].q36TwelvemonthAssessmentEmpty == false &&
          qarray[index].q36TwelvemonthMeasurementValueEmpty === false &&
          Q36TwelveMonthHideColumn === true &&
          labDetails.twelvemonthMeasurement !== 3 &&
          labDetails.twelvemonthAssessment !== 2
        ) {
          qarray[index].q36TwelvemonthMeasurementValueInvalid =
            validateSmallConcentrationUnits(
              twelveMonthmeasurementValue,
              twelveMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36TwelvemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }
        const twentyoneMonthmeasurementValue =
          labDetails.twentyonemonthMeasurement === 1
            ? labDetails.twentyonemonthMeasurementValue_l
            : labDetails.twentyonemonthMeasurementValue_ml;
        const twentyoneMonthunit =
          labDetails.twentyonemonthMeasurement === 1 ? "ng" : "pg";
        if (
          qarray[index].q36TwentyonemonthAssessmentEmpty == false &&
          qarray[index].q36TwentyonemonthMeasurementValueEmpty === false &&
          Q36TwentyOneMonthHideColumn === true &&
          labDetails.twentyonemonthMeasurement !== 3 &&
          labDetails.twentyonemonthAssessment !== 2
        ) {
          qarray[index].q36TwentyonemonthMeasurementValueInvalid =
            validateSmallConcentrationUnits(
              twentyoneMonthmeasurementValue,
              twentyoneMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36TwentyonemonthMeasurementValueInvalid) {
            isValid = false;
          }
        }

        const twentyfourMonthmeasurementValue =
          labDetails.twentyfourmonthMeasurement === 1
            ? labDetails.twentyfourmonthMeasurementValue_l
            : labDetails.twentyfourmonthMeasurementValue_ml;
        const twentyfourMonthunit =
          labDetails.twentyfourmonthMeasurement === 1 ? "ng" : "pg";
        if (
          qarray[index].q36TwentyfourmonthAssessmentEmpty == false &&
          qarray[index].q36TwentyfourmonthMeasurementValueEmpty === false &&
          Q36TwentyFourMonthHideColumn === true &&
          labDetails.twentyfourmonthMeasurement !== 3 &&
          labDetails.twentyfourmonthAssessment !== 2
        ) {
          qarray[index].q36TwentyfourmonthMeasurementValueInvalid =
            validateSmallConcentrationUnits(
              twentyfourMonthmeasurementValue,
              twentyfourMonthunit,
              0,
              maxLimit
            );
          if (qarray[index].q36TwentyfourmonthMeasurementValueInvalid) {
            isValid = false;
          }
        }
      }
    }
    //#endregion

    return isValid;
  };

  const Validate = () => {

    let isValid = true;
    let isQ35Valid = true;
    let isQ36Valid = true;


    isQ35Valid = ValidateQ35();
    isQ36Valid = ValidateQ36();
    if (
      isQ35Valid &&
      isQ36Valid
    )
      isValid = true;
    else isValid = false;

    return isValid;
  };



  
  const ValidateQ35 = () => {
    
    let isValid = true;
    let q35array = [...labassessmentDetails];
    for (let i = 0; i < labassessmentDetails.length; i++) {
      if (labassessmentDetails[i].lab !== Values.value21) {
        if (labassessmentDetails[i].lab === "") {
          q35array[i].q35labEmpty = true;
          isValid = false;
        }

        if (labassessmentDetails[i].labspecimen === "") {
          q35array[i].q35specimenEmpty = true;
          isValid = false;
        }

        if (labassessmentDetails[i].labAssessment === "") {
          q35array[i].q35assessmentEmpty = true;
          isValid = false;
        }
        if (
          labassessmentDetails[i].tyrosine_measurement === "" &&
          labassessmentDetails[i].hemoglobin_measurement === "" &&
          labassessmentDetails[i].hematocrit_measurement === "" &&
          labassessmentDetails[i].platelet_measurement === "" &&
          labassessmentDetails[i].fibroblast_measurement === ""
        ) {
          q35array[i].q35measurementEmpty = true;
          isValid = false;
        } else if (
          [
            Values.value1,
            Values.value2,
            Values.value3,
            Values.value4,
            Values.value5,
            Values.value6,
            Values.value7,
            Values.value8,
            Values.value9,
            Values.value10,
            Values.value11,
            Values.value12,
            Values.value13,
          ].includes(labassessmentDetails[i].lab) &&
          labassessmentDetails[i].tyrosine_measurement === ""
        ) {
          q35array[i].q35measurementEmpty = true;
          isValid = false;
        } else if (
          labassessmentDetails[i].lab === Values.value14 &&
          labassessmentDetails[i].hemoglobin_measurement === ""
        ) {
          q35array[i].q35measurementEmpty = true;
          isValid = false;
        } else if (
          labassessmentDetails[i].lab === Values.value15 &&
          labassessmentDetails[i].hematocrit_measurement === ""
        ) {
          q35array[i].q35measurementEmpty = true;
          isValid = false;
        } else if (
          [
            "",
            Values.value16,
            Values.value17,
            Values.value18,
            Values.value19,
          ].includes(labassessmentDetails[i].lab) &&
          labassessmentDetails[i].platelet_measurement === ""
        ) {
          q35array[i].q35measurementEmpty = true;
          isValid = false;
        } else if (
          labassessmentDetails[i].lab === Values.value20 &&
          labassessmentDetails[i].fibroblast_measurement === ""
        ) {
          q35array[i].q35measurementEmpty = true;
          isValid = false;
        }

        if (
          labassessmentDetails[i].labAssessment === Values.value99 &&
          labassessmentDetails[i].labAssessmentUnkLTLKT === ""
        ) {
          q35array[i].q35AssessmentDateUnkEmpty = true;
          isValid = false;
        }

        // const isAssessmentDateBefore =
        //   dates.oneYr_pretransplant_start &&
        //   IsDateBefore(
        //     labassessmentDetails[i].labAssessment_dt,
        //     dates.oneYr_pretransplant_start
        //   );
        // const isAssessmentDateAfter =
        //   dates.oneYr_pretransplant_end &&
        //   IsDateAfter(
        //     labassessmentDetails[i].labAssessment_dt,
        //     dates.oneYr_pretransplant_end
        //   );

        // const isStabilizationDateBefore =
        //   dates.post_stabilization_start &&
        //   IsDateBefore(
        //     labassessmentDetails[i].labAssessment_dt,
        //     dates.post_stabilization_start
        //   );
        // const isStabilizationDateAfter =
        //   dates.twelve_month_post_stabilization &&
        //   IsDateAfter(
        //     labassessmentDetails[i].labAssessment_dt,
        //     dates.twelve_month_post_stabilization
        //   );

        // if (labassessmentDetails[i].labAssessment_dt === "Invalid Date") {
        //   q35array[i].q35assessmentDateInvalid = true;
        // } else if (isAssessmentDateBefore || isAssessmentDateAfter) {
        //   q35array[i].q35assessmentDateInvalid = true;
        // } else if (isStabilizationDateBefore || isStabilizationDateAfter) {
        //   q35array[i].q35assessmentDateInvalid = true;
        // } else {
        //   q35array[i].q35assessmentDateInvalid = false;
        // }
        const assessmentDate = labassessmentDetails[i].labAssessment_dt;

      // Check if date is invalid
      if (labassessmentDetails[i].labAssessment!=Values.value99){
      if (assessmentDate === "Invalid Date") {
        q35array[i].q35assessmentDateInvalid = true;
      } 
      else {


            // 
            const validationRange =
            indexMinus456days && 
            dates.twelve_month_post_stabilization &&
            DateValid(indexMinus456days,assessmentDate) &&
            DateValid(assessmentDate, dates.twelve_month_post_stabilization);


        if (
          validationRange !== null && validationRange !== undefined &&
        !validationRange) {
          q35array[i].q35assessmentDateInvalid = true; 
        } else {
          q35array[i].q35assessmentDateInvalid = false;
        }

}
}

        q35array[i].q35measurementTyrosineEmpty =
          labassessmentDetails[i].tyrosine_measurement !== "" &&
          labassessmentDetails[i].tyrosine_measurement !== 99 &&
          labassessmentDetails[i].tyrosine_measurement_value_l === "" &&
          labassessmentDetails[i].tyrosine_measurement_value_ml === "" &&
          labassessmentDetails[i].tyrosine_measurement_value_nl === "" &&
          labassessmentDetails[i].tyrosine_measurement_value_ugdl === ""
            ? true
            : false;
        q35array[i].q35measurementHemaglobinEmpty =
          labassessmentDetails[i].hemoglobin_measurement !== "" &&
          labassessmentDetails[i].hemoglobin_measurement !== 99 &&
          labassessmentDetails[i].hemoglobin_measurement_value_gl === "" &&
          labassessmentDetails[i].hemoglobin_measurement_value_gdl === "" &&
          labassessmentDetails[i].hemoglobin_measurement_value_mgdl === "" &&
          labassessmentDetails[i].hemoglobin_measurement_value_mgl === ""
            ? true
            : false;
        q35array[i].q35measurementHematocritEmpty =
          labassessmentDetails[i].hematocrit_measurement !== "" &&
          labassessmentDetails[i].hematocrit_measurement !== 99 &&
          labassessmentDetails[i].hematocrit_measurement_value === ""
            ? true
            : false;
        q35array[i].q35measurementPlateletEmpty =
          labassessmentDetails[i].platelet_measurement !== "" &&
          labassessmentDetails[i].platelet_measurement !== 99 &&
          labassessmentDetails[i].platelet_measurement &&
          labassessmentDetails[i].platelet_measurement_value_l === "" &&
          labassessmentDetails[i].platelet_measurement_value_ul === ""
            ? true
            : false;
        q35array[i].q35measurementFibroblastEmpty =
          labassessmentDetails[i].fibroblast_measurement !== "" &&
          labassessmentDetails[i].fibroblast_measurement !== 99 &&
          labassessmentDetails[i].fibroblast_measurement_value_ng === "" &&
          labassessmentDetails[i].fibroblast_measurement_value_pg === ""
            ? true
            : false;
        q35array[i].q35assessmentDateEmptyError =
          labassessmentDetails[i].labAssessment === Values.value1 &&
          labassessmentDetails[i].labAssessment_dt === ""
            ? true
            : false;

        if (
          q35array[i].q35measurementTyrosineEmpty ||
          q35array[i].q35measurementHemaglobinEmpty ||
          q35array[i].q35measurementHematocritEmpty ||
          q35array[i].q35measurementPlateletEmpty ||
          q35array[i].q35measurementFibroblastEmpty ||
          q35array[i].q35assessmentDateEmptyError ||
          q35array[i].q35assessmentDateInvalid
        ) {
          isValid = false;
        }

        const labValue = labassessmentDetails[i].lab;
        let rangeValue;

        // Define a mapping for lab values that have unique ranges
        const rangeMapping = {
          [Values.value1]: 400,
          [Values.value2]: 410,
          [Values.value3]: 20000,
          [Values.value4]: 500,
          [Values.value5]: 12000,
          [Values.value6]: 1600,
          [Values.value7]: 870,
          [Values.value8]: 560,
          [Values.value9]: 2700,
          [Values.value10]: 450,
          [Values.value11]: 1100,
          [Values.value12]: 258,
          [Values.value13]: 330,
          [Values.value14]: 300,
          [Values.value15]: 100,
          [Values.value16]: 1400,
          [Values.value17]: 33,
          [Values.value18]: 40,
          [Values.value19]: 17,
          [Values.value20]: 1200,
        };

        // Use switch for grouped cases
        switch (true) {
          case labValue in rangeMapping:
            rangeValue = rangeMapping[labValue]; // Fetch from mapping
            break;
        }

        // Call function only if rangeValue is set
        if (rangeValue !== null) {
          isValid = validateMeasurement(
            labassessmentDetails[i],
            q35array,
            i,
            rangeValue,
            "Q35",
            isValid
          );
        }
      }
    }

    setlabassessmentDetails(q35array);

    return isValid;
  };

  const ValidateQ36 = () => {
    let isValid = true;

    let q36array = [...mdeData];
    for (let i = 0; i < mdeData.length; i++) {
      if (
        mdeData[i].admissionSpecimen === "" &&
        mdeData[i].admissionAssessment !== 2 &&
        Q36AdmissionHideColumn === true
      ) {
        q36array[i].q36AdmissionspecimenEmpty = true;
        isValid = false;
      }

      // if (
      //   mdeData[i].dischargeSpecimen === "" &&
      //   mdeData[i].dischargeAssessment !== 2 &&
      //   Q36DischargeHideColumn === true
      // ) {
      //   q36array[i].q36DischargeSpecimenEmpty = true;
      //   isValid = false;
      // }

      // if (
      //   mdeData[i].indexSpecimen === "" &&
      //   mdeData[i].indexAssessment !== 2 //&&
      //   // Q36IndexHideColumn == false
      // ) {
      //   q36array[i].q36IndexSpecimenEmpty = false;//true;
      //   isValid = false;
      // }
      if (
        mdeData[i].threemonthSpecimen === "" &&
        mdeData[i].threemonthAssessment !== 2 &&
        Q36ThreeMonthHideColumn === true
      ) {
        q36array[i].q36ThreemonthSpecimenEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].twelvemonthSpecimen === "" &&
        mdeData[i].twelvemonthAssessment !== 2 &&
        Q36TwelveMonthHideColumn === true
      ) {
        q36array[i].q36TwelvemonthSpecimenEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].twentyonemonthSpecimen === "" &&
        mdeData[i].twentyonemonthAssessment !== 2 &&
        Q36TwentyOneMonthHideColumn === true
      ) {
        q36array[i].q36TwentyonemonthSpecimenEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].twentyfourmonthSpecimen === "" &&
        mdeData[i].twentyfourmonthAssessment !== 2 &&
        Q36TwentyFourMonthHideColumn === true
      ) {
        q36array[i].q36TwentyfourmonthSpecimenEmpty = true;
        isValid = false;
      }

      if (
        mdeData[i].admissionAssessment === "" &&
        Q36AdmissionHideColumn === true
      ) {
        q36array[i].q36AdmissionassessmentEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].dischargeAssessment === "" &&
        Q36DischargeHideColumn === true
      ) {
        q36array[i].q36DischargeAssessmentEmpty = true;
        isValid = false;
      }

      // if (mdeData[i].indexAssessment === "") {
      //   //&& Q36IndexHideColumn == false
      //   q36array[i].q36IndexAssessmentEmpty = false;//true;
      //   isValid = false;
      // }

      if (
        mdeData[i].threemonthAssessment === "" &&
        Q36ThreeMonthHideColumn === true
      ) {
        q36array[i].q36ThreemonthAssessmentEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].twelvemonthAssessment === "" &&
        Q36TwelveMonthHideColumn === true
      ) {
        q36array[i].q36TwelvemonthAssessmentEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].twentyonemonthAssessment === "" &&
        Q36TwentyOneMonthHideColumn === true
      ) {
        q36array[i].q36TwentyonemonthAssessmentEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].twentyfourmonthAssessment === "" &&
        Q36TwentyFourMonthHideColumn === true
      ) {
        q36array[i].q36TwentyfourmonthAssessmentEmpty = true;
        isValid = false;
      }

      if (
        mdeData[i].admissionMeasurement === "" &&
        mdeData[i].admissionAssessment !== 2 &&
        Q36AdmissionHideColumn === true
      ) {
        q36array[i].q36AdmissionmeasurementEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].dischargeMeasurement === "" &&
        mdeData[i].dischargeAssessment !== 2 &&
        Q36DischargeHideColumn === true
      ) {
        q36array[i].q36DischargeMeasurementEmpty = true;
        isValid = false;
      }
      // if (
      //   mdeData[i].indexMeasurement === "" &&
      //   mdeData[i].indexAssessment !== 2 //&&
      //   //Q36IndexHideColumn == false
      // ) {
      //   q36array[i].q36IndexMeasurementEmpty = true;
      //   isValid = false;
      // }
      if (
        mdeData[i].threemonthMeasurement === "" &&
        mdeData[i].threemonthAssessment !== 2 &&
        Q36ThreeMonthHideColumn === true
      ) {
        q36array[i].q36ThreemonthMeasurementEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].twelvemonthMeasurement === "" &&
        mdeData[i].twelvemonthAssessment !== 2 &&
        Q36TwelveMonthHideColumn === true
      ) {
        q36array[i].q36TwelvemonthMeasurementEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].twentyonemonthMeasurement === "" &&
        mdeData[i].twentyonemonthAssessment !== 2 &&
        Q36TwentyOneMonthHideColumn === true
      ) {
        q36array[i].q36TwentyonemonthMeasurementEmpty = true;
        isValid = false;
      }
      if (
        mdeData[i].twentyfourmonthMeasurement === "" &&
        mdeData[i].twentyfourmonthAssessment !== 2 &&
        Q36TwentyFourMonthHideColumn === true
      ) {
        q36array[i].q36TwentyfourmonthMeasurementEmpty = true;
        isValid = false;
      }

      if (mdeData[i].admissionAssessmentDatedt === "Invalid Date")
        q36array[i].q36AdmissionassessmentDateInvalid = true;
      else q36array[i].q36AdmissionassessmentDateInvalid = false;

      if (mdeData[i].dischargeAssessmentDatedt === "Invalid Date")
        q36array[i].q36DischargeAssessmentDateInvalid = true;
      else q36array[i].q36DischargeAssessmentDateInvalid = false;

      if (mdeData[i].indexAssessmentDate === "Invalid Date")
        q36array[i].q36IndexAssessmentDateInvalid = true;
      else q36array[i].q36IndexAssessmentDateInvalid = false;

      if (mdeData[i].threemonthAssessmentDate === "Invalid Date")
        q36array[i].q36ThreemonthAssessmentDateInvalid = true;
      else q36array[i].q36ThreemonthAssessmentDateInvalid = false;

      if (mdeData[i].twelvemonthAssessmentDate === "Invalid Date")
        q36array[i].q36TwelvemonthAssessmentDateInvalid = true;
      else q36array[i].q36TwelvemonthAssessmentDateInvalid = false;

      if (mdeData[i].twentyonemonthAssessmentDate === "Invalid Date")
        q36array[i].q36TwentyonemonthAssessmentDateInvalid = true;
      else q36array[i].q36TwentyonemonthAssessmentDateInvalid = false;

      if (mdeData[i].twentyfourmonthAssessmentDate === "Invalid Date")
        q36array[i].q36TwentyfourmonthAssessmentDateInvalid = true;
      else q36array[i].q36TwentyfourmonthAssessmentDateInvalid = false;

      q36array[i].q36AdmissionmeasurementValueEmpty =
        mdeData[i].admissionMeasurement !== "" &&
        mdeData[i].admissionAssessment !== 2 &&
        (mdeData[i].labAssessmentMdeTypeId === Values.value15
          ? mdeData[i].admissionMeasurement !== 2
          : [
              Values.value16,
              Values.value17,
              Values.value18,
              Values.value19,
              Values.value20,
            ].includes(mdeData[i].labAssessmentMdeTypeId)
          ? mdeData[i].admissionMeasurement !== 3
          :mdeData[i].labAssessmentMdeTypeId === Values.value4
          ? mdeData[i].admissionMeasurement !== 5
          :mdeData[i].admissionMeasurement !== 4) &&
        mdeData[i].admissionMeasurementValue_l === "" &&
        mdeData[i].admissionMeasurementValue_ml === "" &&
        mdeData[i].admissionMeasurementValue_nl === "" &&
        mdeData[i].admissionMeasurementValue_mg === "" 
          ? true
          : false;
      q36array[i].q36DischargeMeasurementValueEmpty =
        mdeData[i].dischargeMeasurement !== "" &&
        mdeData[i].dischargeAssessment !== 2 &&
        (mdeData[i].labAssessmentMdeTypeId === Values.value15
          ? mdeData[i].dischargeMeasurement !== 2
          : [
              Values.value16,
              Values.value17,
              Values.value18,
              Values.value19,
              Values.value20,
            ].includes(mdeData[i].labAssessmentMdeTypeId)
          ? mdeData[i].dischargeMeasurement !== 3
          : mdeData[i].dischargeMeasurement !== 4) &&
        mdeData[i].dischargeMeasurementValue_l === "" &&
        mdeData[i].dischargeMeasurementValue_ml === "" &&
        mdeData[i].dischargeMeasurementValue_nl === "" 
          ? true
          : false;
      q36array[i].q36IndexMeasurementValueEmpty =
        mdeData[i].indexMeasurement !== "" &&
        mdeData[i].indexAssessment !== 2 &&
        (mdeData[i].labAssessmentMdeTypeId === Values.value15
          ? mdeData[i].indexMeasurement !== 2
          : [
              Values.value16,
              Values.value17,
              Values.value18,
              Values.value19,
              Values.value20,
            ].includes(mdeData[i].labAssessmentMdeTypeId)
          ? mdeData[i].indexMeasurement !== 3
          : mdeData[i].indexMeasurement !== 4) &&
        mdeData[i].indexMeasurementValue_l === "" &&
        mdeData[i].indexMeasurementValue_ml === "" &&
        mdeData[i].indexMeasurementValue_nl === "" 
          ? true
          : false;
      q36array[i].q36ThreemonthMeasurementValueEmpty =
        mdeData[i].threemonthMeasurement !== "" &&
        mdeData[i].threemonthAssessment !== 2 &&
        (mdeData[i].labAssessmentMdeTypeId === Values.value15
          ? mdeData[i].threemonthMeasurement !== 2
          : [
              Values.value16,
              Values.value17,
              Values.value18,
              Values.value19,
              Values.value20,
            ].includes(mdeData[i].labAssessmentMdeTypeId)
          ? mdeData[i].threemonthMeasurement !== 3
           :mdeData[i].labAssessmentMdeTypeId === Values.value4
          ? mdeData[i].admissionMeasurement !== 5
          : mdeData[i].threemonthMeasurement !== 4) &&
        mdeData[i].threemonthMeasurementValue_l === "" &&
        mdeData[i].threemonthMeasurementValue_ml === "" &&
        mdeData[i].threemonthMeasurementValue_nl === "" &&
        mdeData[i].threemonthMeasurementValue_mg === "" 
          ? true
          : false;
      q36array[i].q36TwelvemonthMeasurementValueEmpty =
        mdeData[i].twelvemonthMeasurement !== "" &&
        mdeData[i].twelvemonthAssessment !== 2 &&
        (mdeData[i].labAssessmentMdeTypeId === Values.value15
          ? mdeData[i].twelvemonthMeasurement !== 2
          : [
              Values.value16,
              Values.value17,
              Values.value18,
              Values.value19,
              Values.value20,
            ].includes(mdeData[i].labAssessmentMdeTypeId)
          ? mdeData[i].twelvemonthMeasurement !== 3
           :mdeData[i].labAssessmentMdeTypeId === Values.value4
          ? mdeData[i].admissionMeasurement !== 5
          : mdeData[i].twelvemonthMeasurement !== 4) &&
        mdeData[i].twelvemonthMeasurementValue_l === "" &&
        mdeData[i].twelvemonthMeasurementValue_ml === "" &&
        mdeData[i].twelvemonthMeasurementValue_nl === "" &&
        mdeData[i].twelvemonthMeasurementValue_mg === "" 
          ? true
          : false;
      q36array[i].q36TwentyonemonthMeasurementValueEmpty =
        mdeData[i].twentyonemonthMeasurement !== "" &&
        mdeData[i].twentyonemonthAssessment !== 2 &&
        (mdeData[i].labAssessmentMdeTypeId === Values.value15
          ? mdeData[i].twentyonemonthMeasurement !== 2
          : [
              Values.value16,
              Values.value17,
              Values.value18,
              Values.value19,
              Values.value20,
            ].includes(mdeData[i].labAssessmentMdeTypeId)
          ? mdeData[i].twentyonemonthMeasurement !== 3
           :mdeData[i].labAssessmentMdeTypeId === Values.value4
          ? mdeData[i].admissionMeasurement !== 5
          : mdeData[i].twentyonemonthMeasurement !== 4) &&
        mdeData[i].twentyonemonthMeasurementValue_l === "" &&
        mdeData[i].twentyonemonthMeasurementValue_ml === "" &&
        mdeData[i].twentyonemonthMeasurementValue_nl === "" &&
        mdeData[i].twentyonemonthMeasurementValue_mg === "" 
          ? true
          : false;

      q36array[i].q36TwentyfourmonthMeasurementValueEmpty =
        mdeData[i].twentyfourmonthMeasurement !== "" &&
        mdeData[i].twentyfourmonthAssessment !== 2 &&
        (mdeData[i].labAssessmentMdeTypeId === Values.value15
          ? mdeData[i].twentyfourmonthMeasurement !== 2
          : [
              Values.value16,
              Values.value17,
              Values.value18,
              Values.value19,
              Values.value20,
            ].includes(mdeData[i].labAssessmentMdeTypeId)
          ? mdeData[i].twentyfourmonthMeasurement !== 3
           :mdeData[i].labAssessmentMdeTypeId === Values.value4
          ? mdeData[i].admissionMeasurement !== 5
          : mdeData[i].twentyfourmonthMeasurement !== 4) &&
        mdeData[i].twentyfourmonthMeasurementValue_l === "" &&
        mdeData[i].twentyfourmonthMeasurementValue_ml === "" &&
        mdeData[i].twentyfourmonthMeasurementValue_nl === "" &&
        mdeData[i].twentyfourmonthMeasurementValue_mg === "" 
          ? true
          : false;
      q36array[i].q36AdmissionassessmentDateEmptyError =
        mdeData[i].admissionAssessment === Values.value1 &&
        mdeData[i].admissionAssessmentDatedt === ""
          ? true
          : false;
      q36array[i].q36DischargeAssessmentDateEmptyError =
        mdeData[i].dischargeAssessment === Values.value1 &&
        mdeData[i].dischargeAssessmentDatedt === ""
          ? true
          : false;
      q36array[i].q36IndexAssessmentDateEmptyError =
        mdeData[i].indexAssessment === Values.value1 &&
        mdeData[i].indexAssessmentDate === ""
          ? true
          : false;
      q36array[i].q36ThreemonthAssessmentDateEmptyError =
        mdeData[i].threemonthAssessment === Values.value1 &&
        mdeData[i].threemonthAssessmentDate === ""
          ? true
          : false;
      q36array[i].q36TwelvemonthAssessmentDateEmptyError =
        mdeData[i].twelvemonthAssessment === Values.value1 &&
        mdeData[i].twelvemonthAssessmentDate === ""
          ? true
          : false;
      q36array[i].q36TwentyonemonthAssessmentDateEmptyError =
        mdeData[i].twentyonemonthAssessment === Values.value1 &&
        mdeData[i].twentyonemonthAssessmentDate === ""
          ? true
          : false;
      q36array[i].q36TwentyfourmonthAssessmentDateEmptyError =
        mdeData[i].twentyfourmonthAssessment === Values.value1 &&
        mdeData[i].twentyfourmonthAssessmentDate === ""
          ? true
          : false;

      if (
        q36array[i].q36AdmissionmeasurementValueEmpty ||
        q36array[i].q36DischargeMeasurementValueEmpty ||
        q36array[i].q36IndexMeasurementValueEmpty ||
        q36array[i].q36ThreemonthMeasurementValueEmpty ||
        q36array[i].q36TwelvemonthMeasurementValueEmpty ||
        q36array[i].q36TwentyonemonthMeasurementValueEmpty ||
        q36array[i].q36TwentyfourmonthMeasurementValueEmpty ||
        q36array[i].q36AdmissionassessmentDateEmptyError ||
        q36array[i].q36DischargeAssessmentDateEmptyError ||
        q36array[i].q36IndexAssessmentDateEmptyError ||
        q36array[i].q36TwelvemonthAssessmentDateEmptyError ||
        q36array[i].q36ThreemonthAssessmentDateEmptyError ||
        q36array[i].q36TwentyonemonthAssessmentDateEmptyError ||
        q36array[i].q36TwentyfourmonthAssessmentDateEmptyError ||
        q36array[i].q36AdmissionassessmentDateInvalid ||
        q36array[i].q36DischargeAssessmentDateInvalid ||
        q36array[i].q36IndexAssessmentDateInvalid ||
        q36array[i].q36ThreemonthAssessmentDateInvalid ||
        q36array[i].q36TwelvemonthAssessmentDateInvalid ||
        q36array[i].q36TwentyonemonthAssessmentDateInvalid ||
        q36array[i].q36TwentyfourmonthAssessmentDateInvalid
      ) {
        isValid = false;
      }

      const labmdeValue = mdeData[i].labAssessmentMdeTypeId;
      let rangeValue;

      // Define a mapping for lab values that have unique ranges
      const rangeMapping = {
        [Values.value1]: 400,
        [Values.value2]: 410,
        [Values.value3]: 20,
        [Values.value4]: 1600,
        [Values.value5]: 12000,
        [Values.value6]: 1600,
        [Values.value7]: 870,
        [Values.value8]: 560,
        [Values.value9]: 2700,
        [Values.value10]: 450,
        [Values.value11]: 1100,
        [Values.value12]: 258,
        [Values.value13]: 330,
        [Values.value14]: 300,
        [Values.value15]: 100,
        [Values.value16]: 1400,
        [Values.value17]: 33,
        [Values.value18]: 40,
        [Values.value19]: 17,
        [Values.value20]: 1200,
      };

      
      // Use switch for grouped cases
      switch (true) {
        case labmdeValue in rangeMapping:
          rangeValue = rangeMapping[labmdeValue]; // Fetch from mapping
          break;
      }

      // Call function only if rangeValue is set
      if (rangeValue !== null) {
        isValid = validateMeasurement(
          mdeData[i],
          q36array,
          i,
          rangeValue,
          "Q36",
          isValid
        );
      }
    }
console.log(q36array)
    setmdeData(q36array);

    return isValid;
  };

  const handleNumericInputKeyDown = (e) => {
    // Allow backspace, arrow keys, delete, and tab
    if (
      ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(e.key)
    ) {
      return;
    }

    // Prevent non-numeric characters, except '.' (and only allow one decimal point)
    if (
      !/[0-9.]/.test(e.key) ||
      (e.key === "." && e.target.value.includes("."))
    ) {
      e.preventDefault();
      return;
    }

    const value = e.target.value;
    const selectionStart = e.target.selectionStart;
    const newValue =
      value.slice(0, selectionStart) +
      e.key +
      value.slice(e.target.selectionEnd);

    // Prevent '.' as the first character
    if (e.key === "." && value === "") {
      e.preventDefault();
      return;
    }

    // Allow only two digits after the decimal point
    if (newValue.includes(".") && newValue.split(".")[1].length > 1) {
      e.preventDefault();
    }
  };

  const handleNumericInputKeyDownUpto3 = (e) => {
    // Allow backspace, arrow keys, delete, and tab
    if (
      ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(e.key)
    ) {
      return;
    }
  
    // Prevent non-numeric characters, except '.' (and only allow one decimal point)
    if (
      !/[0-9.]/.test(e.key) ||
      (e.key === "." && e.target.value.includes("."))
    ) {
      e.preventDefault();
      return;
    }
  
    const value = e.target.value;
    const selectionStart = e.target.selectionStart;
    const newValue =
      value.slice(0, selectionStart) +
      e.key +
      value.slice(e.target.selectionEnd);
  
    // Prevent '.' as the first character
    if (e.key === "." && value === "") {
      e.preventDefault();
      return;
    }
  
    // ✅ Allow only three digits after the decimal point
    if (newValue.includes(".") && newValue.split(".")[1].length > 3) {
      e.preventDefault();
    }
  };
  

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div>
          <SideBarMenu activePageId={SideMenuItems.OtherLabAssessment} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() =>
                toggleSidebar(isSideMenuActive, setisSideMenuActive)
              }
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>OTHER LAB ASSESSMENTS</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}

              <div className="survey-question-section" >
                <div className="survey-question-content survey-content-box grey-bg">
                  <div className="question-answer grid-overflow">
               

              

             

      
                    {/* here211 */}
                    <div
                      className="block-border block-margin white-bg"
                      style={{ marginBlock: "20px 0" }}
                    >
                      <div>
                        <div className="question">
                          <span className="question-weight">Q35.</span>
                          <span className="quest-text-pad question-weight">
                            Please report <u>laboratory assessments</u> that
                            occurred <u>outside of MDEs</u> in the following manner:

                          <br />- The closest records to 12 months <span  style={{ color: PageDesignConstants.fontColor }}>{indexMinus365days}</span> and 6 months <span  style={{ color: PageDesignConstants.fontColor }}>{indexMinus182days}</span> <i>prior to the index date</i> 
                          <br />- The closest record to 9 months <span  style={{ color: PageDesignConstants.fontColor }}>{indexPlus273days}</span> <i>after the index date</i> 

                          <br /><br /> Add additional rows for each occurrence of each
                            assessment, as needed.
                          </span>
                        </div>
                        
                      </div>
                       <div style={{height:"500px",overflowY:"auto"}}>
                      {labassessmentDetails &&
                        labassessmentDetails.length > 0 &&
                        labassessmentDetails.map((data, idx) => (
                          <div className="loop-section-ul">
                            <div className="loop-head">
                              <span className="question-weight">
                                {GetOrdinal(idx + 1)} Laboratory Assessment
                              </span>
                              {idx != 0 && (
                                <div className="delete-btn-div">
                                  <img
                                    width="16px"
                                    src="../Assets/images/Icon-material-delete.png"
                                    alt=""
                                    onClick={() => deleteAssessmentDetails(idx)}
                                  />
                                </div>
                              )}
                            </div>
                            <div
                              className="containertd grid-overflow" style={{display: "contents"}}
                              colSpan={3}
                            >
                            <div style={{display: "block", overflowY: "auto"}}>
                              <table
                                className="borderTable custom-th-width"
                                style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}

                              >
                                <thead>
                                  <tr>
                                    <th className="table-th-sec">
                                      Lab <span className="indigo-text"></span>
                                    </th>
                                    <th className="table-th-sec">
                                      Specimen{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                    <th className="table-th-sec">
                                      Date of assessment{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                    <th className="table-th-sec">
                                      Measurement{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    



                                    <td className="modal-popup-table-cell" style={{alignContent:"flex-start", paddingBottom: "10rem"}}>
                                      <div className="option-without-input" style={{marginTop:"14px"}}>
                                        <label>
                                          <span className="radio-text-padding leftPad8">
                                            <Dropdown className="custom-dropdown-caret">
                                              <Dropdown.Toggle
                                                variant=""
                                                id={`lab-dropdown-${idx}`}
                                                className="w110 epcoritamab-custom-dropdown-button"
                                                style={{ width: '300px' }}
                                              >
                                                {/* Display selected lab name */}
                                                {labOptions.find(opt => opt.value === data.lab)?.label || "Select Assessment"}
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu className="w110 Demographic-custom-dropdown-menu" style={{ width: '100%',zIndex:"1",marginLeft:"10px" }}>
                                                {labOptions.map(opt => (
                                                  <Dropdown.Item
                                                    as="button"
                                                    key={opt.value}
                                                    value={opt.value}
                                                    className={`custom-dropdown-item ${opt.value === data.lab ? "custom-dropdown-item-selected" : ""}`}
                                                    onClick={() => HandleLabFieldChange({
                                                      target: {
                                                        name: `lab-${idx}-lab`,
                                                        value: opt.value,
                                                        type: "select"
                                                      }
                                                    })}
                                                  >
                                                    {opt.label}
                                                  </Dropdown.Item>
                                                ))}
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </span>
                                        </label>
                                      </div>
                                      <ErrorField
                                        show={data.q35labEmpty}
                                        message={CommonError_Msgs.Msg1}
                                      />
                                    </td>



                                    {data.lab === Values.value21 ? (
                                      <td
                                        className="containertd"
                                        style={{
                                          textAlign: "center",
                                          borderRight: "0",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not Applicable</b>
                                        </span>
                                      </td>
                                    ) : (
                                      <td className="modal-popup-table-cell" style={{alignContent:"flex-start"}}>
                                        <div className="date-field-padding" style={{marginTop:"14px"}}>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "labspecimen-" + idx + "-lab"
                                              }
                                              value={1}
                                              checked={
                                                data.labspecimen ===
                                                Values.value1
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <span className="">Blood</span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "labspecimen-" + idx + "-lab"
                                              }
                                              value={2}
                                              checked={
                                                data.labspecimen ===
                                                Values.value2
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <span className="">Plasma</span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "labspecimen-" + idx + "-lab"
                                              }
                                              value={3}
                                              checked={
                                                data.labspecimen ===
                                                Values.value3
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <span className="">Serum</span>
                                          </label>
                                        </div>

                                        <ErrorField
                                          show={data.q35specimenEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                      </td>
                                    )}

                                    {data.lab === Values.value21 ? (
                                      <td
                                        className="containertd"
                                        style={{
                                          textAlign: "center",
                                          borderRight: "0",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not Applicable</b>
                                        </span>
                                      </td>
                                    ) : (
                                      <td className="modal-popup-table-cell" style={{alignContent:"flex-start"}}>
                                        <div className="date-field-padding" style={{marginTop:"14px"}}>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "labAssessment-" + idx + "-lab"
                                              }
                                              value={1}
                                              checked={
                                                data.labAssessment ===
                                                Values.value1
                                              }
                                              onChange={HandleLabFieldChange}
                                            />

                                            <span className="">
                                              <DateControl
                                                optionId={"labAssessment_dt"}
                                                ctrlId={
                                                  "labAssessment_dt-" + idx
                                                }
                                                HandleDateChange={
                                                  HandleDateChange
                                                }
                                                date={data.labAssessment_dt}
                                              />
                                            </span>
                                          </label>
                                        </div>
                                        <div className="estimated-date-padding text-margin">
                                          <label>
                                            <input
                                              type="checkbox"
                                              id={idx}
                                              name={
                                                "labAssessment_dt_estimated-" +
                                                idx +
                                                "-lab"
                                              }
                                              checked={
                                                data.labAssessment_dt_estimated
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <span className="radio-text-padding">
                                              Estimated Date
                                            </span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "labAssessment-" + idx + "-lab"
                                              }
                                              value={99}
                                              checked={
                                                data.labAssessment ===
                                                Values.value99
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <span className="">
                                              Date unknown
                                            </span>
                                          </label>
                                          <div style={{ marginLeft: "44px" }}>
                                            {dates?.zero_to12months_before_LT_LKT !==
                                              null &&
                                              dates?.zero_to12months_before_LT_LKT && (
                                                <div>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "labAssessmentUnkLTLKT-" +
                                                        idx +
                                                        "-lab"
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.labAssessmentUnkLTLKT ===
                                                        Values.value1
                                                      }
                                                      onChange={
                                                        HandleLabFieldChange
                                                      }
                                                    />
                                                    <span
                                                      data-tooltip-id="encounterTip"
                                                      className="modal-popup"
                                                      onClick={() =>
                                                        setShowHide012HyperlinkModal(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      0 to 12 months before
                                                      LT/LKT
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                            {dates?.four_to_15months_after_LT_LKT !==
                                              null &&
                                              dates?.four_to_15months_after_LT_LKT && (
                                                <div>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "labAssessmentUnkLTLKT-" +
                                                        idx +
                                                        "-lab"
                                                      }
                                                      value={3}
                                                      checked={
                                                        data.labAssessmentUnkLTLKT ===
                                                        Values.value3
                                                      }
                                                      onChange={
                                                        HandleLabFieldChange
                                                      }
                                                    />
                                                    <span
                                                      data-tooltip-id="encounterTip"
                                                      className="modal-popup"
                                                      onClick={() =>
                                                        setShowHide415HyperlinkModal(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      4 to 15 months after
                                                      LT/LKT
                                                    </span>
                                                  </label>
                                                </div>
                                              )}

                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "labAssessmentUnkLTLKT-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  value={5}
                                                  checked={
                                                    data.labAssessmentUnkLTLKT ===
                                                    Values.value5
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />
                                                <span className="">
                                                  Date completely unknown
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                        <ErrorField
                                          show={
                                            data.q35assessmentDateEmptyError
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />

                                        <ErrorField
                                          show={data.q35AssessmentDateUnkEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />

                                        <ErrorField
                                          show={data.q35assessmentEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />

                                        <ErrorField
                                          show={data.q35assessmentDateInvalid}
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    )}

                                    {data.lab === Values.value21 ? (
                                      <td
                                        className="containertd"
                                        style={{
                                          textAlign: "center",
                                          borderRight: "0",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not Applicable</b>
                                        </span>
                                      </td>
                                    ) : [
                                        "",
                                        Values.value1,
                                        Values.value2,
                                        Values.value3,
                                        Values.value4,
                                        Values.value5,
                                        Values.value6,
                                        Values.value7,
                                        Values.value8,
                                        Values.value9,
                                        Values.value10,
                                        Values.value11,
                                        Values.value12,
                                        Values.value13,
                                      ].includes(data.lab) ? (
                                      <td className="modal-popup-table-cell" style={{alignContent:"flex-start"}}>
                                        <div className="date-field-padding" style={{marginTop:"14px"}}>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "tyrosine_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={1}
                                              checked={
                                                data.tyrosine_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "tyrosine_measurement_value_l-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.tyrosine_measurement ===
                                                    Values.value1
                                                      ? data.tyrosine_measurement_value_l
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; µmol/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "tyrosine_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={2}
                                              checked={
                                                data.tyrosine_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "tyrosine_measurement_value_ml-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.tyrosine_measurement ===
                                                    Values.value2
                                                      ? data.tyrosine_measurement_value_ml
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; µmol/mL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "tyrosine_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={3}
                                              checked={
                                                data.tyrosine_measurement ===
                                                Values.value3
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "tyrosine_measurement_value_nl-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.tyrosine_measurement ===
                                                    Values.value3
                                                      ? data.tyrosine_measurement_value_nl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; nmol/mL 
                                              </span>
                                            </div>
                                          </label>
                                        </div>






                                        {data.lab === Values.value4 && (
                                          <div className="date-field-padding">
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"tyrosine_measurement-" + idx + "-lab"}
                                                value={4}
                                                checked={data.tyrosine_measurement === Values.value4}
                                                onChange={HandleLabFieldChange}
                                              />
                                              <div className="option-fbox">
                                                <span>
                                                  <input
                                                    className="sub-input-dash"
                                                    id={idx}
                                                    name={"tyrosine_measurement_value_ugdl-" + idx + "-lab"}
                                                    type="text"
                                                    value={
                                                      data.tyrosine_measurement === Values.value4
                                                        ? data.tyrosine_measurement_value_ugdl
                                                        : ""
                                                    }
                                                    maxLength={8}
                                                    onKeyDown={handleNumericInputKeyDown}
                                                    onChange={HandleLabFieldChange}
                                                  />
                                                  &nbsp; µg/dL
                                                </span>
                                              </div>
                                            </label>
                                          </div>
                                        )}
    


























                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "tyrosine_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={99}
                                              checked={
                                                data.tyrosine_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>

                                        <ErrorField
                                          show={data.q35measurementEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q35measurementTyrosineEmpty
                                          }
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q35measurementTyrosineInvalid
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    ) : data.lab === Values.value14 ? (
                                      <td className="modal-popup-table-cell" style={{alignContent:"flex-start"}}>
                                        <div className="date-field-padding" style={{marginTop:"14px"}}>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "hemoglobin_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={1}
                                              checked={
                                                data.hemoglobin_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleLabFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "hemoglobin_measurement_value_gl-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.hemoglobin_measurement ===
                                                    Values.value1
                                                      ? data.hemoglobin_measurement_value_gl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; g/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>


                                            <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "hemoglobin_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={4}
                                              checked={
                                                data.hemoglobin_measurement ===
                                                Values.value4
                                              }
                                              onChange={HandleLabFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "hemoglobin_measurement_value_gdl-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.hemoglobin_measurement ===
                                                    Values.value4
                                                      ? data.hemoglobin_measurement_value_gdl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; g/dL
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "hemoglobin_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={2}
                                              checked={
                                                data.hemoglobin_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleLabFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "hemoglobin_measurement_value_mgl-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.hemoglobin_measurement ===
                                                    Values.value2
                                                      ? data.hemoglobin_measurement_value_mgl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; mg/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "hemoglobin_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={3}
                                              checked={
                                                data.hemoglobin_measurement ===
                                                Values.value3
                                              }
                                              onChange={HandleLabFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "hemoglobin_measurement_value_mgdl-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.hemoglobin_measurement ===
                                                    Values.value3
                                                      ? data.hemoglobin_measurement_value_mgdl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; mg/dL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "hemoglobin_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={99}
                                              checked={
                                                data.hemoglobin_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>

                                        <ErrorField
                                          show={data.q35measurementEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q35measurementHemaglobinEmpty
                                          }
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q35measurementHemaglobinInvalid
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    ) : data.lab === Values.value15 ? (
                                      <td className="modal-popup-table-cell" style={{alignContent:"flex-start"}}>
                                        <div className="date-field-padding" style={{marginTop:"14px"}}>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "hematocrit_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={1}
                                              checked={
                                                data.hematocrit_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleLabFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "hematocrit_measurement_value-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.hematocrit_measurement ===
                                                    Values.value1
                                                      ? data.hematocrit_measurement_value
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; %
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "hematocrit_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={99}
                                              checked={
                                                data.hematocrit_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>

                                        <ErrorField
                                          show={data.q35measurementEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q35measurementHematocritEmpty
                                          }
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q35measurementHematocritInvalid
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    ) : [
                                        "",
                                        Values.value16,
                                        Values.value17,
                                        Values.value18,
                                        Values.value19,
                                      ].includes(data.lab) ? (
                                      <td className="modal-popup-table-cell" style={{alignContent:"flex-start"}}>
                                        <div className="date-field-padding" style={{marginTop:"14px"}}>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "platelet_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={1}
                                              checked={
                                                data.platelet_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleLabFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "platelet_measurement_value_l-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.platelet_measurement ===
                                                    Values.value1
                                                      ? data.platelet_measurement_value_l
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; 10<sup>9</sup>/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "platelet_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={2}
                                              checked={
                                                data.platelet_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleLabFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "platelet_measurement_value_ul-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.platelet_measurement ===
                                                    Values.value2
                                                      ? data.platelet_measurement_value_ul
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; 10<sup>3</sup>/µL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "platelet_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={99}
                                              checked={
                                                data.platelet_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>
                                        <ErrorField
                                          show={data.q35measurementEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q35measurementPlateletEmpty
                                          }
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q35measurementPlateletInvalid
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    ) : (
                                      <td className="modal-popup-table-cell" style={{alignContent:"flex-start"}}>
                                        <div className="date-field-padding" style={{marginTop:"14px"}}>
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "fibroblast_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={1}
                                              checked={
                                                data.fibroblast_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleLabFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "fibroblast_measurement_value_ng-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.fibroblast_measurement ===
                                                    Values.value1
                                                      ? data.fibroblast_measurement_value_ng
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; ng/mL
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "fibroblast_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={2}
                                              checked={
                                                data.fibroblast_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleLabFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "fibroblast_measurement_value_pg-" +
                                                    idx +
                                                    "-lab"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.fibroblast_measurement ===
                                                    Values.value2
                                                      ? data.fibroblast_measurement_value_pg
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleLabFieldChange}
                                                />{" "}
                                                &nbsp; pg/mL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "fibroblast_measurement-" +
                                                idx +
                                                "-lab"
                                              }
                                              value={99}
                                              checked={
                                                data.fibroblast_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleLabFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>
                                        <ErrorField
                                          show={data.q35measurementEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q35measurementFibroblastEmpty
                                          }
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q35measurementFibroblastInvalid
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                              </div>
                            </div>
                          </div>
                        ))}
                        </div>

                      {labassessmentDetails &&
                        labassessmentDetails[0].lab !== Values.value21 && patientLocked===false && (
                          <div>
                            <div
                              className="answer-list-text"
                              onClick={addassessmentRow}
                            >
                              <a>
                                <img
                                  width="18px"
                                  src="../Assets/images/plus.png"
                                  alt=""
                                />
                              </a>
                              <a className="radio-text-padding">
                                Click to add additional rows for laboratory
                                assessments
                              </a>
                            </div>
                          </div>
                        )}
                    </div>

                    {/*  */}
                    {/*Q36-39*/}
                    <div
                      className="block-margin white-bg"
                      style={{ marginBlock: "20px 0" }}
                    >
                      {/* <table
                      cellpadding="0"
                      cellspacing="0"
                      border="0"
                      width="100%"
                    >
                      <tr>
                        <td> */}
                      {/* Q36 to Q55 iterated togater */}
                      <div className="grid-overflow">
                        <table
                          border="1"
                          width="100%"
                          cellPadding="5"
                          cellSpacing="0"
                        >
                          <tr>
                            <td
                              style={{
                                border: "1px solid #808080",
                                padding: "10px",
                              }}
                              colSpan={targetDates.length + 2}
                            >
                              Please report the laboratory assessment that
                              occurred{" "}
                              <u>
                                on or closest to the provided target date that
                                occurred outside of MDEs only for{" "}
                                <b>other MMA-related assessments.</b>
                              </u>
                              .
                              <ul>
                                <li>
                                  For lactate and ammonia assessments, only
                                  select records that occurred outside of all
                                  MDEs during the record selection window.{" "}
                                  <u>
                                    Please do not duplicate any lactate or
                                    ammonia assessments reported in{" "}
                                    <span className="indigo-text">Q28.1</span>.
                                  </u>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </table>
                        <div
                          style={{
                            maxHeight: "1060px",
                            overflowY: "auto",
                            border: "1px solid #ccc",
                          }}
                        >
                          <table
                            border="1"
                            width="100%"
                            cellPadding="5"
                            cellSpacing="0"
                            style={patientLocked ? { pointerEvents: 'none' } : {}}
                            className="conditional-columns-table"
                          >
                            {/* Table Instructions */}

                            {/* Table Header */}
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 9,
                                background: "#fff",
                                //borderBottom: "2px solid #000",
                              }}
                            >
                              <tr className="custom-position-rel">
                                <th
                                  colSpan="2"
                                  style={{
                                    border: "1px solid #808080",
                                    padding: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <div className="floating-border-bottom"></div>
                                  Target Date
                                </th>
                                {targetDates.map((date, index) => (
                                  <th
                                    className="custom-position-rel"
                                    style={{
                                      border: "1px solid #808080",
                                      padding: "10px",
                                    }}
                                    key={index}
                                  >
                                    <div className="floating-border-left-first"></div>
                                    {date}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            {mdeData
                              .filter((item) =>
                                [
                                  Values.value1,
                                  Values.value2,
                                  Values.value3,
                                  Values.value4,
                                ].includes(item.labAssessmentMdeTypeId)
                              )
                              .map((item, idx) => (
                                <React.Fragment key={idx}>
                                  <tr>
                                    {/* Lab Test Name */}
                                    <td
                                      rowSpan="3"
                                      style={{
                                        border: "1px solid #808080",
                                        padding: "10px",
                                      }}
                                    >
                                      <b>{item.question} </b>
                                      {item.label}
                                    </td>

                                    {/* Date of Assessment */}
                                    <td
                                      style={{
                                        border: "1px solid #808080",
                                        padding: "10px",
                                      }}
                                    >
                                      <b>Date of assessment</b>
                                    </td>
                                    {Array.from(
                                      { length: 7 },
                                      (_, i) => i + 1
                                    ).map((index) => {
                                      if(index === 2 || index === 3) return null;
                                      if (
                                        index === 1
                                          ? Q36AdmissionHideColumn === false
                                          : index === 2
                                          ? Q36IndexHideColumn === false
                                          : index === 3
                                          ? Q36DischargeHideColumn === false
                                          : index === 4
                                          ? Q36ThreeMonthHideColumn === false
                                          : index === 5
                                          ? Q36TwelveMonthHideColumn === false
                                          : index === 6
                                          ? Q36TwentyOneMonthHideColumn ===
                                            false
                                          : Q36TwentyFourMonthHideColumn ===
                                            false
                                      ) {
                                        return (
                                          <td
                                            className="containertd"
                                            key={`na-${index}`} // Unique key
                                            style={{
                                              textAlign: "left",
                                              borderRight: "1px solid #808080",
                                            }}
                                          >
                                            <span
                                              style={{ textAlign: "center" }}
                                            ></span>
                                          </td>
                                        );
                                      }
                                      return (
                                        <td
                                          key={index}
                                          style={{
                                            border: "1px solid #808080",
                                            padding: "10px",
                                          }}
                                        >
                                          <div>
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-mde-${idx}`
                                                    : index === 2
                                                    ? `indexAssessment-${index}-mde-${idx}`
                                                    : index === 3
                                                    ? `dischargeAssessment-${index}-mde-${idx}`
                                                    : index === 4
                                                    ? `threemonthAssessment-${index}-mde-${idx}`
                                                    : index === 5
                                                    ? `twelvemonthAssessment-${index}-mde-${idx}`
                                                    : index === 6
                                                    ? `twentyonemonthAssessment-${index}-mde-${idx}`
                                                    : `twentyfourmonthAssessment-${index}-mde-${idx}`
                                                }
                                                name={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-mde-${idx}`
                                                    : index === 2
                                                    ? `indexAssessment-${index}-mde-${idx}`
                                                    : index === 3
                                                    ? `dischargeAssessment-${index}-mde-${idx}`
                                                    : index === 4
                                                    ? `threemonthAssessment-${index}-mde-${idx}`
                                                    : index === 5
                                                    ? `twelvemonthAssessment-${index}-mde-${idx}`
                                                    : index === 6
                                                    ? `twentyonemonthAssessment-${index}-mde-${idx}`
                                                    : `twentyfourmonthAssessment-${index}-mde-${idx}`
                                                }
                                                value={1}
                                                checked={
                                                  index == Values.value1
                                                    ? item.admissionAssessment ===
                                                      Values.value1
                                                    : index === Values.value2
                                                    ? item.indexAssessment ===
                                                      Values.value1
                                                    : index === Values.value3
                                                    ? item.dischargeAssessment ===
                                                      Values.value1
                                                    : index === Values.value4
                                                    ? item.threemonthAssessment ===
                                                      Values.value1
                                                    : index === Values.value5
                                                    ? item.twelvemonthAssessment ===
                                                      Values.value1
                                                    : index === Values.value6
                                                    ? item.twentyonemonthAssessment ===
                                                      Values.value1
                                                    : item.twentyfourmonthAssessment ===
                                                      Values.value1
                                                }
                                                onChange={HandleMdeFieldChange}
                                              />

                                              <span>
                                                <DateControl
                                                  optionId={
                                                    index === 1
                                                      ? "admissionAssessmentDatedt"
                                                      : index === 2
                                                      ? "indexAssessmentDate"
                                                      : index === 3
                                                      ? "dischargeAssessmentDatedt"
                                                      : index === 4
                                                      ? "threemonthAssessmentDate"
                                                      : index === 5
                                                      ? "twelvemonthAssessmentDate"
                                                      : index === 6
                                                      ? "twentyonemonthAssessmentDate"
                                                      : "twentyfourmonthAssessmentDate"
                                                  }
                                                  ctrlId={
                                                    index === 1
                                                      ? "admissionAssessmentDatedt-" +
                                                        idx
                                                      : index === 2
                                                      ? "indexAssessmentDate-" +
                                                        idx
                                                      : index === 3
                                                      ? "dischargeAssessmentDatedt-" +
                                                        idx
                                                      : index === 4
                                                      ? "threemonthAssessmentDate-" +
                                                        idx
                                                      : index === 5
                                                      ? "twelvemonthAssessmentDate-" +
                                                        idx
                                                      : index === 6
                                                      ? "twentyonemonthAssessmentDate-" +
                                                        idx
                                                      : "twentyfourmonthAssessmentDate-" +
                                                        idx
                                                  }
                                                  HandleDateChange={
                                                    HandleDateChange
                                                  }
                                                  date={
                                                    index === Values.value1
                                                      ? item.admissionAssessmentDatedt
                                                      : index === Values.value2
                                                      ? item.indexAssessmentDate
                                                      : index === Values.value3
                                                      ? item.dischargeAssessmentDatedt
                                                      : index === Values.value4
                                                      ? item.threemonthAssessmentDate
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessmentDate
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessmentDate
                                                      : item.twentyfourmonthAssessmentDate
                                                  }
                                                />
                                              </span>
                                            </label>
                                          </div>
                                          <div className="estimated-date-padding text-margin">
                                            <label>
                                              <input
                                                type="checkbox"
                                                id={
                                                  index === 1
                                                    ? `admissionAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : index === 2
                                                    ? `indexAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : index === 3
                                                    ? `dischargeAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : index === 4
                                                    ? `threemonthAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : index === 5
                                                    ? `twelvemonthAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : index === 6
                                                    ? `twentyonemonthAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : `twentyfourmonthAssessmentDateEstimated-${index}-mde-${idx}`
                                                }
                                                name={
                                                  index === 1
                                                    ? `admissionAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : index === 2
                                                    ? `indexAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : index === 3
                                                    ? `dischargeAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : index === 4
                                                    ? `threemonthAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : index === 5
                                                    ? `twelvemonthAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : index === 6
                                                    ? `twentyonemonthAssessmentDateEstimated-${index}-mde-${idx}`
                                                    : `twentyfourmonthAssessmentDateEstimated-${index}-mde-${idx}`
                                                }
                                                checked={
                                                  index == Values.value1
                                                    ? item.admissionAssessmentDateEstimated
                                                    : index === Values.value2
                                                    ? item.indexAssessmentDateEstimated 
                                                    : index === Values.value3
                                                    ? item.dischargeAssessmentDateEstimated 
                                                    : index === Values.value4
                                                    ? item.threemonthAssessmentDateEstimated 
                                                    : index === Values.value5
                                                    ? item.twelvemonthAssessmentDateEstimated
                                                    : index === Values.value6
                                                    ? item.twentyonemonthAssessmentDateEstimated 
                                                    : item.twentyfourmonthAssessmentDateEstimated 
                                                }
                                                onChange={HandleMdeFieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                Estimated Date
                                              </span>
                                            </label>
                                          </div>
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-mde-${idx}`
                                                    : index === 2
                                                    ? `indexAssessment-${index}-mde-${idx}`
                                                    : index === 3
                                                    ? `dischargeAssessment-${index}-mde-${idx}`
                                                    : index === 4
                                                    ? `threemonthAssessment-${index}-mde-${idx}`
                                                    : index === 5
                                                    ? `twelvemonthAssessment-${index}-mde-${idx}`
                                                    : index === 6
                                                    ? `twentyonemonthAssessment-${index}-mde-${idx}`
                                                    : `twentyfourmonthAssessment-${index}-mde-${idx}`
                                                }
                                                name={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-mde-${idx}`
                                                    : index === 2
                                                    ? `indexAssessment-${index}-mde-${idx}`
                                                    : index === 3
                                                    ? `dischargeAssessment-${index}-mde-${idx}`
                                                    : index === 4
                                                    ? `threemonthAssessment-${index}-mde-${idx}`
                                                    : index === 5
                                                    ? `twelvemonthAssessment-${index}-mde-${idx}`
                                                    : index === 6
                                                    ? `twentyonemonthAssessment-${index}-mde-${idx}`
                                                    : `twentyfourmonthAssessment-${index}-mde-${idx}`
                                                }
                                                value={99}
                                                checked={
                                                  index == Values.value1
                                                    ? item.admissionAssessment ===
                                                      Values.value99
                                                    : index === Values.value2
                                                    ? item.indexAssessment ===
                                                      Values.value99
                                                    : index === Values.value3
                                                    ? item.dischargeAssessment ===
                                                      Values.value99
                                                    : index === Values.value4
                                                    ? item.threemonthAssessment ===
                                                      Values.value99
                                                    : index === Values.value5
                                                    ? item.twelvemonthAssessment ===
                                                      Values.value99
                                                    : index === Values.value6
                                                    ? item.twentyonemonthAssessment ===
                                                      Values.value99
                                                    : item.twentyfourmonthAssessment ===
                                                      Values.value99
                                                }
                                                onChange={HandleMdeFieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                {" "}
                                                Date unknown
                                              </span>
                                            </label>
                                          </div>
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-mde-${idx}`
                                                    : index === 2
                                                    ? `indexAssessment-${index}-mde-${idx}`
                                                    : index === 3
                                                    ? `dischargeAssessment-${index}-mde-${idx}`
                                                    : index === 4
                                                    ? `threemonthAssessment-${index}-mde-${idx}`
                                                    : index === 5
                                                    ? `twelvemonthAssessment-${index}-mde-${idx}`
                                                    : index === 6
                                                    ? `twentyonemonthAssessment-${index}-mde-${idx}`
                                                    : `twentyfourmonthAssessment-${index}-mde-${idx}`
                                                }
                                                name={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-mde-${idx}`
                                                    : index === 2
                                                    ? `indexAssessment-${index}-mde-${idx}`
                                                    : index === 3
                                                    ? `dischargeAssessment-${index}-mde-${idx}`
                                                    : index === 4
                                                    ? `threemonthAssessment-${index}-mde-${idx}`
                                                    : index === 5
                                                    ? `twelvemonthAssessment-${index}-mde-${idx}`
                                                    : index === 6
                                                    ? `twentyonemonthAssessment-${index}-mde-${idx}`
                                                    : `twentyfourmonthAssessment-${index}-mde-${idx}`
                                                }
                                                value={2}
                                                checked={
                                                  index === Values.value1
                                                    ? item.admissionAssessment ===
                                                      Values.value2
                                                    : index === Values.value2
                                                    ? item.indexAssessment ===
                                                      Values.value2
                                                    : index === Values.value3
                                                    ? item.dischargeAssessment ===
                                                      Values.value2
                                                    : index === Values.value4
                                                    ? item.threemonthAssessment ===
                                                      Values.value2
                                                    : index === Values.value5
                                                    ? item.twelvemonthAssessment ===
                                                      Values.value2
                                                    : index === Values.value6
                                                    ? item.twentyonemonthAssessment ===
                                                      Values.value2
                                                    : item.twentyfourmonthAssessment ===
                                                      Values.value2
                                                }
                                                onChange={HandleMdeFieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                {" "}
                                                Not assessed
                                              </span>
                                            </label>
                                          </div>
                                          <ErrorField
                                            show={
                                              index === Values.value1
                                                ? item.q36AdmissionassessmentDateEmptyError
                                                : index === Values.value2
                                                ? item.q36IndexAssessmentDateEmptyError
                                                : index === Values.value3
                                                ? item.q36DischargeAssessmentDateEmptyError
                                                : index === Values.value4
                                                ? item.q36ThreemonthAssessmentDateEmptyError
                                                : index === Values.value5
                                                ? item.q36TwelvemonthAssessmentDateEmptyError
                                                : index === Values.value6
                                                ? item.q36TwentyonemonthAssessmentDateEmptyError
                                                : item.q36TwentyfourmonthAssessmentDateEmptyError
                                            }
                                            message={CommonError_Msgs.Msg2}
                                          />

                                          <ErrorField
                                            show={
                                              index === Values.value1
                                                ? item.q36AdmissionassessmentEmpty
                                                : index === Values.value2
                                                ? item.q36IndexAssessmentEmpty
                                                : index === Values.value3
                                                ? item.q36DischargeAssessmentEmpty
                                                : index === Values.value4
                                                ? item.q36ThreemonthAssessmentEmpty
                                                : index === Values.value5
                                                ? item.q36TwelvemonthAssessmentEmpty
                                                : index === Values.value6
                                                ? item.q36TwentyonemonthAssessmentEmpty
                                                : item.q36TwentyfourmonthAssessmentEmpty
                                            }
                                            message={CommonError_Msgs.Msg1}
                                          />

                                          <ErrorField
                                            show={
                                              index === Values.value1
                                                ? item.q36AdmissionassessmentDateInvalid
                                                : index === Values.value2
                                                ? item.q36IndexAssessmentDateInvalid
                                                : index === Values.value3
                                                ? item.q36DischargeAssessmentDateInvalid
                                                : index === Values.value4
                                                ? item.q36ThreemonthAssessmentDateInvalid
                                                : index === Values.value5
                                                ? item.q36TwelvemonthAssessmentDateInvalid
                                                : index === Values.value6
                                                ? item.q36TwentyonemonthAssessmentDateInvalid
                                                : item.q36TwentyfourmonthAssessmentDateInvalid
                                            }
                                            message={CommonError_Msgs.Msg2}
                                          />
                                        </td>
                                      );
                                    })}
                                  </tr>
                                  {/* Specimen Type */}
                                  <tr>
                                    <td
                                      style={{
                                        border: "1px solid #808080",
                                        padding: "10px",
                                      }}
                                    >
                                      <b>Specimen Type</b>
                                    </td>
                                    {Array(7)
                                      .fill(null)
                                      .map((_, colIndex) => {
                                        if (colIndex === 1 || colIndex === 2) return null;
                                        const notAssesed =
                                          colIndex === Values.value0
                                            ? item.admissionAssessment ===
                                              Values.value2
                                            : colIndex === Values.value1
                                            ? item.indexAssessment ===
                                              Values.value2
                                            : colIndex === Values.value2
                                            ? item.dischargeAssessment ===
                                              Values.value2
                                            : colIndex === Values.value3
                                            ? item.threemonthAssessment ===
                                              Values.value2
                                            : colIndex === Values.value4
                                            ? item.twelvemonthAssessment ===
                                              Values.value2
                                            : colIndex === Values.value5
                                            ? item.twentyonemonthAssessment ===
                                              Values.value2
                                            : item.twentyfourmonthAssessment ===
                                              Values.value2;

                                        const hidecolumn =
                                          colIndex === 0
                                            ? Q36AdmissionHideColumn === false
                                            : colIndex === 1
                                            ? Q36IndexHideColumn === false
                                            : colIndex === 2
                                            ? Q36DischargeHideColumn === false
                                            : colIndex === 3
                                            ? Q36ThreeMonthHideColumn === false
                                            : colIndex === 4
                                            ? Q36TwelveMonthHideColumn === false
                                            : colIndex === 5
                                            ? Q36TwentyOneMonthHideColumn ===
                                              false
                                            : Q36TwentyFourMonthHideColumn ===
                                              false;

                                        if (notAssesed || hidecolumn) {
                                          return (
                                            <td
                                              className="containertd"
                                              key={`na-${colIndex}`} // Unique key
                                              style={{
                                                textAlign: hidecolumn
                                                  ? "center"
                                                  : "left",
                                                borderRight:
                                                  "1px solid #808080",
                                                borderBottom: hidecolumn
                                                  ? ""
                                                  : "1px solid #808080",
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                                className="not-applicable"
                                              >
                                                <b>Not Applicable</b>
                                              </span>
                                            </td>
                                          );
                                        }

                                        return (
                                          <td
                                            key={colIndex}
                                            style={{
                                              border: "1px solid #808080",
                                              padding: "10px",
                                            }}
                                          >
                                            {item.specimenTypes.map(
                                              (type, typeIndex) => (
                                                <div key={typeIndex}>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={
                                                        colIndex === 0
                                                          ? `admissionSpecimen-${colIndex}-mde-${idx}`
                                                          : colIndex === 1
                                                          ? `indexSpecimen-${colIndex}-mde-${idx}`
                                                          : colIndex === 2
                                                          ? `dischargeSpecimen-${colIndex}-mde-${idx}`
                                                          : colIndex === 3
                                                          ? `threemonthSpecimen-${colIndex}-mde-${idx}`
                                                          : colIndex === 4
                                                          ? `twelvemonthSpecimen-${colIndex}-mde-${idx}`
                                                          : colIndex === 5
                                                          ? `twentyonemonthSpecimen-${colIndex}-mde-${idx}`
                                                          : `twentyfourmonthSpecimen-${colIndex}-mde-${idx}`
                                                      }
                                                      name={
                                                        colIndex === 0
                                                          ? `admissionSpecimen-${colIndex}-mde-${idx}`
                                                          : colIndex === 1
                                                          ? `indexSpecimen-${colIndex}-mde-${idx}`
                                                          : colIndex === 2
                                                          ? `dischargeSpecimen-${colIndex}-mde-${idx}`
                                                          : colIndex === 3
                                                          ? `threemonthSpecimen-${colIndex}-mde-${idx}`
                                                          : colIndex === 4
                                                          ? `twelvemonthSpecimen-${colIndex}-mde-${idx}`
                                                          : colIndex === 5
                                                          ? `twentyonemonthSpecimen-${colIndex}-mde-${idx}`
                                                          : `twentyfourmonthSpecimen-${colIndex}-mde-${idx}`
                                                      }
                                                      value={typeIndex + 1}
                                                      checked={
                                                        colIndex ===
                                                        Values.value0
                                                          ? item.admissionSpecimen ===
                                                            typeIndex + 1
                                                          : colIndex ===
                                                            Values.value1
                                                          ? item.indexSpecimen ===
                                                            typeIndex + 1
                                                          : colIndex ===
                                                            Values.value2
                                                          ? item.dischargeSpecimen ===
                                                            typeIndex + 1
                                                          : colIndex ===
                                                            Values.value3
                                                          ? item.threemonthSpecimen ===
                                                            typeIndex + 1
                                                          : colIndex ===
                                                            Values.value4
                                                          ? item.twelvemonthSpecimen ===
                                                            typeIndex + 1
                                                          : colIndex ===
                                                            Values.value5
                                                          ? item.twentyonemonthSpecimen ===
                                                            typeIndex + 1
                                                          : item.twentyfourmonthSpecimen ===
                                                            typeIndex + 1
                                                      }
                                                      onChange={
                                                        HandleMdeFieldChange
                                                      }
                                                    />
                                                    <span> {type}</span>
                                                  </label>
                                                </div>
                                              )
                                            )}

                                            <ErrorField
                                              show={
                                                colIndex === Values.value0
                                                  ? item.q36AdmissionspecimenEmpty
                                                  : colIndex === Values.value1
                                                  ? item.q36IndexSpecimenEmpty
                                                  : colIndex === Values.value2
                                                  ? item.q36DischargeSpecimenEmpty
                                                  : colIndex === Values.value3
                                                  ? item.q36ThreemonthSpecimenEmpty
                                                  : colIndex === Values.value4
                                                  ? item.q36TwelvemonthSpecimenEmpty
                                                  : colIndex === Values.value5
                                                  ? item.q36TwentyonemonthSpecimenEmpty
                                                  : item.q36TwentyfourmonthSpecimenEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />
                                          </td>
                                        );
                                      })}
                                  </tr>
                                  {/* Measurement */}
                                  <tr>
                                    <td
                                      style={{
                                        border: "1px solid #808080",
                                        padding: "10px",
                                      }}
                                    >
                                      <b>Measurement</b>
                                    </td>
                                    {Array(7)
                                      .fill(null)
                                      .map((_, colIndex) => {
                                        if (colIndex === 1 || colIndex === 2) return null;
                                        const notAssesed =
                                          colIndex === Values.value0
                                            ? item.admissionAssessment ===
                                              Values.value2
                                            : colIndex === Values.value1
                                            ? item.indexAssessment ===
                                              Values.value2
                                            : colIndex === Values.value2
                                            ? item.dischargeAssessment ===
                                              Values.value2
                                            : colIndex === Values.value3
                                            ? item.threemonthAssessment ===
                                              Values.value2
                                            : colIndex === Values.value4
                                            ? item.twelvemonthAssessment ===
                                              Values.value2
                                            : colIndex === Values.value5
                                            ? item.twentyonemonthAssessment ===
                                              Values.value2
                                            : item.twentyfourmonthAssessment ===
                                              Values.value2;

                                        const hidecolumn =
                                          colIndex === 0
                                            ? Q36AdmissionHideColumn === false
                                            : colIndex === 1
                                            ? Q36IndexHideColumn === false
                                            : colIndex === 2
                                            ? Q36DischargeHideColumn === false
                                            : colIndex === 3
                                            ? Q36ThreeMonthHideColumn === false
                                            : colIndex === 4
                                            ? Q36TwelveMonthHideColumn === false
                                            : colIndex === 5
                                            ? Q36TwentyOneMonthHideColumn ===
                                              false
                                            : Q36TwentyFourMonthHideColumn ===
                                              false;

                                        if (notAssesed || hidecolumn) {
                                          return (
                                            <td
                                              className="containertd"
                                              key={`na-${colIndex}`} // Unique key
                                              style={{
                                                textAlign: hidecolumn
                                                  ? ""
                                                  : "left",
                                                borderRight:
                                                  "1px solid #808080",
                                                borderBottom: hidecolumn
                                                  ? "1px solid #808080"
                                                  : "",
                                              }}
                                            >
                                              {notAssesed &&
                                                hidecolumn === false && (
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not Applicable</b>
                                                  </span>
                                                )}
                                            </td>
                                          );
                                        }

                                        return (
                                          <td
                                            key={colIndex}
                                            style={{
                                              border: "1px solid #808080",
                                              padding: "10px",
                                            }}
                                          >
                                            {item.measurements.map(
                                              (unit, mIndex) => (
                                                <div key={mIndex}>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={
                                                        colIndex === 0
                                                          ? `admissionMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : colIndex === 1
                                                          ? `indexMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : colIndex === 2
                                                          ? `dischargeMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : colIndex === 3
                                                          ? `threemonthMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : colIndex === 4
                                                          ? `twelvemonthMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : colIndex === 5
                                                          ? `twentyonemonthMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : `twentyfourmonthMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                      }
                                                      name={
                                                        colIndex === 0
                                                          ? `admissionMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : colIndex === 1
                                                          ? `indexMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : colIndex === 2
                                                          ? `dischargeMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : colIndex === 3
                                                          ? `threemonthMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : colIndex === 4
                                                          ? `twelvemonthMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : colIndex === 5
                                                          ? `twentyonemonthMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                          : `twentyfourmonthMeasurement-${colIndex}-mde-${idx}-${mIndex}`
                                                      }
                                                      value={mIndex + 1}
                                                      checked={
                                                        colIndex ===
                                                        Values.value0
                                                          ? item.admissionMeasurement ===
                                                            mIndex + 1
                                                          : colIndex ===
                                                            Values.value1
                                                          ? item.indexMeasurement ===
                                                            mIndex + 1
                                                          : colIndex ===
                                                            Values.value2
                                                          ? item.dischargeMeasurement ===
                                                            mIndex + 1
                                                          : colIndex ===
                                                            Values.value3
                                                          ? item.threemonthMeasurement ===
                                                            mIndex + 1
                                                          : colIndex ===
                                                            Values.value4
                                                          ? item.twelvemonthMeasurement ===
                                                            mIndex + 1
                                                          : colIndex ===
                                                            Values.value5
                                                          ? item.twentyonemonthMeasurement ===
                                                            mIndex + 1
                                                          : item.twentyfourmonthMeasurement ===
                                                            mIndex + 1
                                                      }
                                                      onChange={
                                                        HandleMdeFieldChange
                                                      }
                                                    />

                                                    {unit === "Unknown" ? (
                                                      <></>
                                                    ) : (
                                                      <input
                                                        className="sub-input-dash"
                                                        id={
                                                          colIndex === 0
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `admissionMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `admissionMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `admissionMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `admissionMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : colIndex === 1
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `indexMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `indexMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `indexMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `indexMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : colIndex === 2
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `dischargeMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `dischargeMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `dischargeMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `dischargeMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : colIndex === 3
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `threemonthMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `threemonthMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `threemonthMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `threemonthMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : colIndex === 4
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `twelvemonthMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `twelvemonthMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `twelvemonthMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `twelvemonthMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : colIndex === 5
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `twentyonemonthMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `twentyonemonthMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `twentyonemonthMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `twentyonemonthMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : mIndex ===
                                                              Values.value0
                                                            ? `twentyfourmonthMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                            : mIndex ===
                                                              Values.value1
                                                            ? `twentyfourmonthMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                            : mIndex ===
                                                              Values.value2
                                                            ? `twentyfourmonthMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                            : `twentyfourmonthMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                        }
                                                        name={
                                                          colIndex === 0
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `admissionMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `admissionMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `admissionMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `admissionMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : colIndex === 1
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `indexMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `indexMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `indexMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `indexMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : colIndex === 2
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `dischargeMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `dischargeMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `dischargeMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `dischargeMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : colIndex === 3
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `threemonthMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `threemonthMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `threemonthMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `threemonthMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : colIndex === 4
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `twelvemonthMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `twelvemonthMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `twelvemonthMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `twelvemonthMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : colIndex === 5
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? `twentyonemonthMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `twentyonemonthMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                               : mIndex ===
                                                                Values.value2
                                                              ? `twentyonemonthMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                              : `twentyonemonthMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}`
                                                            : mIndex ===
                                                              Values.value0
                                                            ? `twentyfourmonthMeasurementValue_l-${colIndex}-mde-${idx}-${mIndex}`
                                                            : mIndex ===
                                                              Values.value1
                                                            ? `twentyfourmonthMeasurementValue_ml-${colIndex}-mde-${idx}-${mIndex}`
                                                            : mIndex ===
                                                              Values.value2
                                                            ? `twentyfourmonthMeasurementValue_nl-${colIndex}-mde-${idx}-${mIndex}`
                                                            : `twentyfourmonthMeasurementValue_mg-${colIndex}-mde-${idx}-${mIndex}-${item.label}`
                                                        }
                                                        type="text"
                                                        value={
                                                          colIndex ===
                                                          Values.value0
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? item.admissionMeasurement ===
                                                                mIndex + 1
                                                                ? item.admissionMeasurementValue_l
                                                                : ""
                                                              : mIndex ===
                                                                Values.value1
                                                              ? item.admissionMeasurement ===
                                                                mIndex + 1
                                                                ? item.admissionMeasurementValue_ml
                                                                : ""
                                                              : mIndex ===
                                                                Values.value2
                                                              ? item.admissionMeasurement ===
                                                                mIndex + 1
                                                                ? item.admissionMeasurementValue_nl
                                                                : ""
                                                              : item.admissionMeasurement ===
                                                                mIndex + 1
                                                              ? item.admissionMeasurementValue_mg
                                                              : ""
                                                            : colIndex ===
                                                              Values.value1
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? item.indexMeasurement ===
                                                                mIndex + 1
                                                                ? item.indexMeasurementValue_l
                                                                : ""
                                                              : mIndex ===
                                                                Values.value1
                                                              ? item.indexMeasurement ===
                                                                mIndex + 1
                                                                ? item.indexMeasurementValue_ml
                                                                : ""
                                                              : mIndex ===
                                                                Values.value2
                                                              ? item.indexMeasurement ===
                                                                mIndex + 1
                                                                ? item.indexMeasurementValue_nl
                                                                : ""
                                                              : item.indexMeasurement ===
                                                                mIndex + 1
                                                              ? item.indexMeasurementValue_mg
                                                              : ""
                                                            : colIndex ===
                                                              Values.value2
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? item.dischargeMeasurement ===
                                                                mIndex + 1
                                                                ? item.dischargeMeasurementValue_l
                                                                : ""
                                                              : mIndex ===
                                                                Values.value1
                                                              ? item.dischargeMeasurement ===
                                                                mIndex + 1
                                                                ? item.dischargeMeasurementValue_ml
                                                                : ""
                                                              : mIndex ===
                                                                Values.value2
                                                              ? item.dischargeMeasurement ===
                                                                mIndex + 1
                                                                ? item.dischargeMeasurementValue_nl
                                                                : ""
                                                              : item.dischargeMeasurement ===
                                                                mIndex + 1
                                                              ? item.dischargeMeasurementValue_mg
                                                              : ""
                                                            : colIndex ===
                                                              Values.value3
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? item.threemonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.threemonthMeasurementValue_l
                                                                : ""
                                                              : mIndex ===
                                                                Values.value1
                                                              ? item.threemonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.threemonthMeasurementValue_ml
                                                                : ""
                                                              : mIndex ===
                                                                Values.value2
                                                              ? item.threemonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.threemonthMeasurementValue_nl
                                                                : ""
                                                              : item.threemonthMeasurement ===
                                                                mIndex + 1
                                                              ? item.threemonthMeasurementValue_mg
                                                              : ""
                                                            : colIndex ===
                                                              Values.value4
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? item.twelvemonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twelvemonthMeasurementValue_l
                                                                : ""
                                                              : mIndex ===
                                                                Values.value1
                                                              ? item.twelvemonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twelvemonthMeasurementValue_ml
                                                                : ""
                                                              : mIndex ===
                                                                Values.value2
                                                              ? item.twelvemonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twelvemonthMeasurementValue_nl
                                                                : ""
                                                              : item.twelvemonthMeasurement ===
                                                                mIndex + 1
                                                              ? item.twelvemonthMeasurementValue_mg
                                                              : ""
                                                            : colIndex ===
                                                              Values.value5
                                                            ? mIndex ===
                                                              Values.value0
                                                              ? item.twentyonemonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyonemonthMeasurementValue_l
                                                                : ""
                                                              : mIndex ===
                                                                Values.value1
                                                              ? item.twentyonemonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyonemonthMeasurementValue_ml
                                                                : ""
                                                              : mIndex ===
                                                                Values.value2
                                                              ? item.twentyonemonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyonemonthMeasurementValue_nl
                                                                : ""
                                                              : item.twentyonemonthMeasurement ===
                                                                mIndex + 1
                                                              ? item.twentyonemonthMeasurementValue_mg
                                                              : ""
                                                            : mIndex ===
                                                              Values.value0
                                                            ? item.twentyfourmonthMeasurement ===
                                                              mIndex + 1
                                                              ? item.twentyfourmonthMeasurementValue_l
                                                              : ""
                                                            : mIndex ===
                                                              Values.value1
                                                            ? item.twentyfourmonthMeasurement ===
                                                              mIndex + 1
                                                              ? item.twentyfourmonthMeasurementValue_ml
                                                              : ""
                                                            : mIndex ===
                                                              Values.value2
                                                            ? item.twentyfourmonthMeasurement ===
                                                              mIndex + 1
                                                              ? item.twentyfourmonthMeasurementValue_nl
                                                              : ""
                                                            : item.twentyfourmonthMeasurement ===
                                                              mIndex + 1
                                                            ? item.twentyfourmonthMeasurementValue_mg
                                                            : ""
                                                        }
                                                        maxLength={8}
                                                        onKeyDown={
                                                          handleNumericInputKeyDown
                                                        }
                                                        onChange={
                                                          HandleMdeFieldChange
                                                        }
                                                      />
                                                    )}
                                                    <span>{unit}</span>
                                                  </label>
                                                </div>
                                              )
                                            )}
                                            <ErrorField
                                              show={
                                                colIndex === Values.value0
                                                  ? item.q36AdmissionmeasurementEmpty
                                                  : colIndex === Values.value1
                                                  ? item.q36IndexMeasurementEmpty
                                                  : colIndex === Values.value2
                                                  ? item.q36DischargeMeasurementEmpty
                                                  : colIndex === Values.value3
                                                  ? item.q36ThreemonthMeasurementEmpty
                                                  : colIndex === Values.value4
                                                  ? item.q36TwelvemonthMeasurementEmpty
                                                  : colIndex === Values.value5
                                                  ? item.q36TwentyonemonthMeasurementEmpty
                                                  : item.q36TwentyfourmonthMeasurementEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />
                                            <ErrorField
                                              show={
                                                colIndex === Values.value0
                                                  ? item.q36AdmissionmeasurementValueEmpty
                                                  : colIndex === Values.value1
                                                  ? item.q36IndexMeasurementValueEmpty
                                                  : colIndex === Values.value2
                                                  ? item.q36DischargeMeasurementValueEmpty
                                                  : colIndex === Values.value3
                                                  ? item.q36ThreemonthMeasurementValueEmpty
                                                  : colIndex === Values.value4
                                                  ? item.q36TwelvemonthMeasurementValueEmpty
                                                  : colIndex === Values.value5
                                                  ? item.q36TwentyonemonthMeasurementValueEmpty
                                                  : item.q36TwentyfourmonthMeasurementValueEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />
                                            <ErrorField
                                              show={
                                                colIndex === Values.value0
                                                  ? item.q36AdmissionmeasurementValueInvalid
                                                  : colIndex === Values.value1
                                                  ? item.q36IndexMeasurementValueInvalid
                                                  : colIndex === Values.value2
                                                  ? item.q36DischargeMeasurementValueInvalid
                                                  : colIndex === Values.value3
                                                  ? item.q36ThreemonthMeasurementValueInvalid
                                                  : colIndex === Values.value4
                                                  ? item.q36TwelvemonthMeasurementValueInvalid
                                                  : colIndex === Values.value5
                                                  ? item.q36TwentyonemonthMeasurementValueInvalid
                                                  : item.q36TwentyfourmonthMeasurementValueInvalid
                                              }
                                              message={CommonError_Msgs.Msg2}
                                            />
                                          </td>
                                        );
                                      })}
                                  </tr>
                                </React.Fragment>
                              ))}
                          </table>
                        </div>
                      </div>
                    </div>

                    {/*Q40-48*/}
                    <div
                      className="block-margin white-bg"
                      style={{ marginBlock: "20px 0" }}
                    >
                      <div className="grid-overflow">
                        <table
                          border="1"
                          width="100%"
                          cellPadding="5"
                          cellSpacing="0"
                          style={patientLocked ? { pointerEvents: 'none'} : {}}
                          className="conditional-columns-table"
                        >
                          <tr>
                            <td
                              style={{
                                border: "1px solid #808080",
                                padding: "10px",
                              }}
                              colSpan={targetDates.length + 2}
                            >
                              Please report the laboratory assessment that
                              occurred{" "}
                              <u>
                                on or closest to the provided target date that
                                occurred outside of MDEs only for{" "}
                                <b>amino acid assessments.</b>
                              </u>
                            </td>
                          </tr>
                        </table>
                        <div
                          style={{
                            maxHeight: "1060px",
                            overflowY: "auto",
                            border: "1px solid #ccc",
                          }}
                        >
                          <table
                            border="1"
                            width="100%"
                            cellPadding="5"
                            cellSpacing="0"
                            style={patientLocked ? { pointerEvents: 'none' } : {}}
                            className="conditional-columns-table"
                          >
                            {/* Table Instructions */}

                            {/* Table Header */}
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 9,
                                background: "#fff",
                                //borderBottom: "2px solid #000",
                              }}
                            >
                              <tr className="custom-position-rel">
                                <th
                                  colSpan="2"
                                  style={{
                                    border: "1px solid #808080",
                                    padding: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <div className="floating-border-bottom"></div>
                                  Target Date
                                </th>
                                {targetDates.map((date, index) => (
                                  <th
                                    className="custom-position-rel"
                                    style={{
                                      border: "1px solid #808080",
                                      padding: "10px",
                                    }}
                                    key={index}
                                  >
                                    <div className="floating-border-left-first"></div>
                                    {date}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            {mdeData
                              .filter((item) =>
                                [
                                  Values.value5,
                                  Values.value6,
                                  Values.value7,
                                  Values.value8,
                                  Values.value9,
                                  Values.value10,
                                  Values.value11,
                                  Values.value12,
                                  Values.value13,
                                ].includes(item.labAssessmentMdeTypeId)
                              )
                              .map((item, idx) => {
                                const adjustedIdx = idx + 4;
                                return (
                                  <React.Fragment key={adjustedIdx}>
                                    <tr>
                                      {/* Lab Test Name */}
                                      <td
                                        rowSpan="3"
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>{item.question} </b>
                                        {item.label}
                                      </td>

                                      {/* Date of Assessment */}
                                      <td
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>Date of assessment</b>
                                      </td>
                                      {Array.from(
                                        
                                        { length: 7 },
                                        (_, i) => i + 1
                                      ).map((index) => {
                                        if(index === 2 || index === 3) return null;
                                        if (
                                          index === 1
                                            ? Q36AdmissionHideColumn === false
                                            : index === 2
                                            ? Q36IndexHideColumn === false
                                            : index == 3
                                            ? Q36DischargeHideColumn === false
                                            : index === 4
                                            ? Q36ThreeMonthHideColumn === false
                                            : index === 5
                                            ? Q36TwelveMonthHideColumn === false
                                            : index === 6
                                            ? Q36TwentyOneMonthHideColumn ===
                                              false
                                            : Q36TwentyFourMonthHideColumn ===
                                              false
                                        ) {
                                          return (
                                            <td
                                              className="containertd"
                                              key={`na-${index}`} // Unique key
                                              style={{
                                                textAlign: "left",
                                                borderRight:
                                                  "1px solid #808080",
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                              ></span>
                                            </td>
                                          );
                                        }
                                        return (
                                          <td
                                            key={index}
                                            style={{
                                              border: "1px solid #808080",
                                              padding: "10px",
                                            }}
                                          >
                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustedIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustedIdx}`
                                                  }
                                                  value={1}
                                                  checked={
                                                    index == Values.value1
                                                      ? item.admissionAssessment ===
                                                        Values.value1
                                                      : index === Values.value2
                                                      ? item.indexAssessment ===
                                                        Values.value1
                                                      : index === Values.value3
                                                      ? item.dischargeAssessment ===
                                                        Values.value1
                                                      : index === Values.value4
                                                      ? item.threemonthAssessment ===
                                                        Values.value1
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessment ===
                                                        Values.value1
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessment ===
                                                        Values.value1
                                                      : item.twentyfourmonthAssessment ===
                                                        Values.value1
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />

                                                <span>
                                                  <DateControl
                                                    optionId={
                                                      index === 1
                                                        ? "admissionAssessmentDatedt"
                                                        : index === 2
                                                        ? "indexAssessmentDate"
                                                        : index === 3
                                                        ? "dischargeAssessmentDatedt"
                                                        : index === 4
                                                        ? "threemonthAssessmentDate"
                                                        : index === 5
                                                        ? "twelvemonthAssessmentDate"
                                                        : index === 6
                                                        ? "twentyonemonthAssessmentDate"
                                                        : "twentyfourmonthAssessmentDate"
                                                    }
                                                    ctrlId={
                                                      index === 1
                                                        ? "admissionAssessmentDatedt-" +
                                                          adjustedIdx
                                                        : index === 2
                                                        ? "indexAssessmentDate-" +
                                                          adjustedIdx
                                                        : index === 3
                                                        ? "dischargeAssessmentDatedt-" +
                                                          adjustedIdx
                                                        : index === 4
                                                        ? "threemonthAssessmentDate-" +
                                                          adjustedIdx
                                                        : index === 5
                                                        ? "twelvemonthAssessmentDate-" +
                                                          adjustedIdx
                                                        : index === 6
                                                        ? "twentyonemonthAssessmentDate-" +
                                                          adjustedIdx
                                                        : "twentyfourmonthAssessmentDate-" +
                                                          adjustedIdx
                                                    }
                                                    HandleDateChange={
                                                      HandleDateChange
                                                    }
                                                    date={
                                                      index === Values.value1
                                                        ? item.admissionAssessmentDatedt
                                                        : index ===
                                                          Values.value2
                                                        ? item.indexAssessmentDate
                                                        : index ===
                                                          Values.value3
                                                        ? item.dischargeAssessmentDatedt
                                                        : index ===
                                                          Values.value4
                                                        ? item.threemonthAssessmentDate
                                                        : index ===
                                                          Values.value5
                                                        ? item.twelvemonthAssessmentDate
                                                        : index ===
                                                          Values.value6
                                                        ? item.twentyonemonthAssessmentDate
                                                        : item.twentyfourmonthAssessmentDate
                                                    }
                                                  />
                                                </span>
                                              </label>
                                            </div>
                                            <div className="estimated-date-padding text-margin">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : index === 2
                                                      ? `indexAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : `twentyfourmonthAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : index === 2
                                                      ? `indexAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                      : `twentyfourmonthAssessmentDateEstimated-${index}-mde-${adjustedIdx}`
                                                  }
                                                  checked={
                                                    index == Values.value1
                                                      ? item.admissionAssessmentDateEstimated 
                                                      : index === Values.value2
                                                      ? item.indexAssessmentDateEstimated 
                                                      : index === Values.value3
                                                      ? item.dischargeAssessmentDateEstimated 
                                                      : index === Values.value4
                                                      ? item.threemonthAssessmentDateEstimated 
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessmentDateEstimated 
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessmentDateEstimated 
                                                      : item.twentyfourmonthAssessmentDateEstimated 
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Estimated Date
                                                </span>
                                              </label>
                                            </div>
                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustedIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustedIdx}`
                                                  }
                                                  value={99}
                                                  checked={
                                                    index === Values.value1
                                                      ? item.admissionAssessment ===
                                                        Values.value99
                                                      : index === Values.value2
                                                      ? item.indexAssessment ===
                                                        Values.value99
                                                      : index === Values.value3
                                                      ? item.dischargeAssessment ===
                                                        Values.value99
                                                      : index === Values.value4
                                                      ? item.threemonthAssessment ===
                                                        Values.value99
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessment ===
                                                        Values.value99
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessment ===
                                                        Values.value99
                                                      : item.twentyfourmonthAssessment ===
                                                        Values.value99
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  {" "}
                                                  Date unknown
                                                </span>
                                              </label>
                                            </div>
                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustedIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustedIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustedIdx}`
                                                  }
                                                  value={2}
                                                  checked={
                                                    index === Values.value1
                                                      ? item.admissionAssessment ===
                                                        Values.value2
                                                      : index === Values.value2
                                                      ? item.indexAssessment ===
                                                        Values.value2
                                                      : index === Values.value3
                                                      ? item.dischargeAssessment ===
                                                        Values.value2
                                                      : index === Values.value4
                                                      ? item.threemonthAssessment ===
                                                        Values.value2
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessment ===
                                                        Values.value2
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessment ===
                                                        Values.value2
                                                      : item.twentyfourmonthAssessment ===
                                                        Values.value2
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  {" "}
                                                  Not assessed
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                index === Values.value1
                                                  ? item.q36AdmissionassessmentDateEmptyError
                                                  : index === Values.value2
                                                  ? item.q36IndexAssessmentDateEmptyError
                                                  : index === Values.value3
                                                  ? item.q36DischargeAssessmentDateEmptyError
                                                  : index === Values.value4
                                                  ? item.q36ThreemonthAssessmentDateEmptyError
                                                  : index === Values.value5
                                                  ? item.q36TwelvemonthAssessmentDateEmptyError
                                                  : index === Values.value6
                                                  ? item.q36TwentyonemonthAssessmentDateEmptyError
                                                  : item.q36TwentyfourmonthAssessmentDateEmptyError
                                              }
                                              message={CommonError_Msgs.Msg2}
                                            />

                                            <ErrorField
                                              show={
                                                index === Values.value1
                                                  ? item.q36AdmissionassessmentEmpty
                                                  : index === Values.value2
                                                  ? item.q36IndexAssessmentEmpty
                                                  : index === Values.value3
                                                  ? item.q36DischargeAssessmentEmpty
                                                  : index === Values.value4
                                                  ? item.q36ThreemonthAssessmentEmpty
                                                  : index === Values.value5
                                                  ? item.q36TwelvemonthAssessmentEmpty
                                                  : index === Values.value6
                                                  ? item.q36TwentyonemonthAssessmentEmpty
                                                  : item.q36TwentyfourmonthAssessmentEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />

                                            <ErrorField
                                              show={
                                                index === Values.value1
                                                  ? item.q36AdmissionassessmentDateInvalid
                                                  : index === Values.value2
                                                  ? item.q36IndexAssessmentDateInvalid
                                                  : index === Values.value3
                                                  ? item.q36DischargeAssessmentDateInvalid
                                                  : index === Values.value4
                                                  ? item.q36ThreemonthAssessmentDateInvalid
                                                  : index === Values.value5
                                                  ? item.q36TwelvemonthAssessmentDateInvalid
                                                  : index === Values.value6
                                                  ? item.q36TwentyonemonthAssessmentDateInvalid
                                                  : item.q36TwentyfourmonthAssessmentDateInvalid
                                              }
                                              message={CommonError_Msgs.Msg2}
                                            />
                                          </td>
                                        );
                                      })}
                                    </tr>
                                    {/* Specimen Type */}
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>Specimen Type</b>
                                      </td>
                                      {Array(7)
                                        .fill(null)
                                        .map((_, colIndex) => {
                                          if (colIndex === 1 || colIndex === 2) return null;
                                          const notAssesed =
                                            colIndex === Values.value0
                                              ? item.admissionAssessment ===
                                                Values.value2
                                              : colIndex === Values.value1
                                              ? item.indexAssessment ===
                                                Values.value2
                                              : colIndex === Values.value2
                                              ? item.dischargeAssessment ===
                                                Values.value2
                                              : colIndex === Values.value3
                                              ? item.threemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value4
                                              ? item.twelvemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value5
                                              ? item.twentyonemonthAssessment ===
                                                Values.value2
                                              : item.twentyfourmonthAssessment ===
                                                Values.value2;

                                          const hidecolumn =
                                            colIndex === 0
                                              ? Q36AdmissionHideColumn === false
                                              : colIndex === 1
                                              ? Q36IndexHideColumn === false
                                              : colIndex === 2
                                              ? Q36DischargeHideColumn === false
                                              : colIndex === 3
                                              ? Q36ThreeMonthHideColumn ===
                                                false
                                              : colIndex === 4
                                              ? Q36TwelveMonthHideColumn ===
                                                false
                                              : colIndex === 5
                                              ? Q36TwentyOneMonthHideColumn ===
                                                false
                                              : Q36TwentyFourMonthHideColumn ===
                                                false;

                                          if (notAssesed || hidecolumn) {
                                            return (
                                              <td
                                                className="containertd"
                                                key={`na-${colIndex}`} // Unique key
                                                style={{
                                                  textAlign: hidecolumn
                                                    ? "center"
                                                    : "left",
                                                  borderRight:
                                                    "1px solid #808080",
                                                  borderBottom: hidecolumn
                                                    ? ""
                                                    : "1px solid #808080",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not Applicable</b>
                                                </span>
                                              </td>
                                            );
                                          }

                                          return (
                                            <td
                                              key={colIndex}
                                              style={{
                                                border: "1px solid #808080",
                                                padding: "10px",
                                              }}
                                            >
                                              {item.specimenTypes.map(
                                                (type, typeIndex) => (
                                                  <div key={typeIndex}>
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={
                                                          colIndex === 0
                                                            ? `admissionSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : colIndex === 1
                                                            ? `indexSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : colIndex === 2
                                                            ? `dischargeSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : colIndex === 3
                                                            ? `threemonthSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : colIndex === 4
                                                            ? `twelvemonthSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : `twentyfourmonthSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                        }
                                                        name={
                                                          colIndex === 0
                                                            ? `admissionSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : colIndex === 1
                                                            ? `indexSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : colIndex === 2
                                                            ? `dischargeSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : colIndex === 3
                                                            ? `threemonthSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : colIndex === 4
                                                            ? `twelvemonthSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                            : `twentyfourmonthSpecimen-${colIndex}-mde-${adjustedIdx}`
                                                        }
                                                        value={typeIndex + 1}
                                                        checked={
                                                          colIndex ===
                                                          Values.value0
                                                            ? item.admissionSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value1
                                                            ? item.indexSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value2
                                                            ? item.dischargeSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value3
                                                            ? item.threemonthSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value4
                                                            ? item.twelvemonthSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value5
                                                            ? item.twentyonemonthSpecimen ===
                                                              typeIndex + 1
                                                            : item.twentyfourmonthSpecimen ===
                                                              typeIndex + 1
                                                        }
                                                        onChange={
                                                          HandleMdeFieldChange
                                                        }
                                                      />
                                                      <span> {type}</span>
                                                    </label>
                                                  </div>
                                                )
                                              )}

                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionspecimenEmpty
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexSpecimenEmpty
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeSpecimenEmpty
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthSpecimenEmpty
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthSpecimenEmpty
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthSpecimenEmpty
                                                    : item.q36TwentyfourmonthSpecimenEmpty
                                                }
                                                message={CommonError_Msgs.Msg1}
                                              />
                                            </td>
                                          );
                                        })}
                                    </tr>
                                    {/* Measurement */}
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>Measurement</b>
                                      </td>
                                      {Array(7)
                                        .fill(null)
                                        .map((_, colIndex) => {
                                          if (colIndex === 1 || colIndex === 2) return null;
                                          const notAssesed =
                                            colIndex === Values.value0
                                              ? item.admissionAssessment ===
                                                Values.value2
                                              : colIndex === Values.value1
                                              ? item.indexAssessment ===
                                                Values.value2
                                              : colIndex === Values.value2
                                              ? item.dischargeAssessment ===
                                                Values.value2
                                              : colIndex === Values.value3
                                              ? item.threemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value4
                                              ? item.twelvemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value5
                                              ? item.twentyonemonthAssessment ===
                                                Values.value2
                                              :item.twentyfourmonthAssessment ===
                                                Values.value2;

                                          const hidecolumn =
                                            colIndex === 0
                                              ? Q36AdmissionHideColumn === false
                                              : colIndex === 1
                                              ? Q36IndexHideColumn === false
                                              : colIndex === 2
                                              ? Q36DischargeHideColumn === false
                                              : colIndex === 3
                                              ? Q36ThreeMonthHideColumn ===
                                                false
                                              : colIndex === 4
                                              ? Q36TwelveMonthHideColumn ===
                                                false
                                              : colIndex === 5
                                              ? Q36TwentyOneMonthHideColumn ===
                                                false
                                              : Q36TwentyFourMonthHideColumn ===
                                                false;

                                          if (notAssesed || hidecolumn) {
                                            return (
                                              <td
                                                className="containertd"
                                                key={`na-${colIndex}`} // Unique key
                                                style={{
                                                  textAlign: hidecolumn
                                                    ? ""
                                                    : "left",
                                                  borderRight:
                                                    "1px solid #808080",
                                                  borderBottom: hidecolumn
                                                    ? "1px solid #808080"
                                                    : "",
                                                }}
                                              >
                                                {notAssesed &&
                                                  hidecolumn === false && (
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not Applicable</b>
                                                    </span>
                                                  )}
                                              </td>
                                            );
                                          }

                                          return (
                                            <td
                                              key={colIndex}
                                              style={{
                                                border: "1px solid #808080",
                                                padding: "10px",
                                              }}
                                            >
                                              {item.measurements.map(
                                                (unit, mIndex) => (
                                                  <div key={mIndex}>
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={
                                                          colIndex === 0
                                                            ? `admissionMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : colIndex === 1
                                                            ? `indexMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : colIndex === 2
                                                            ? `dischargeMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : colIndex === 3
                                                            ? `threemonthMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : colIndex === 4
                                                            ? `twelvemonthMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : `twentyfourmonthMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                        }
                                                        name={
                                                          colIndex === 0
                                                            ? `admissionMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : colIndex === 1
                                                            ? `indexMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : colIndex === 2
                                                            ? `dischargeMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : colIndex === 3
                                                            ? `threemonthMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : colIndex === 4
                                                            ? `twelvemonthMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                            : `twentyfourmonthMeasurement-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                        }
                                                        value={mIndex + 1}
                                                        checked={
                                                          colIndex ===
                                                          Values.value0
                                                            ? item.admissionMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value1
                                                            ? item.indexMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value2
                                                            ? item.dischargeMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value3
                                                            ? item.threemonthMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value4
                                                            ? item.twelvemonthMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value5
                                                            ? item.twentyonemonthMeasurement ===
                                                              mIndex + 1
                                                            : item.twentyfourmonthMeasurement ===
                                                              mIndex + 1
                                                        }
                                                        onChange={
                                                          HandleMdeFieldChange
                                                        }
                                                      />

                                                      {unit === "Unknown" ? (
                                                        <></>
                                                      ) : (
                                                        <input
                                                          className="sub-input-dash"
                                                          id={
                                                            colIndex === 0
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `admissionMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `admissionMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `admissionMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `admissionMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : colIndex === 1
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `indexMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `indexMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `indexMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `indexMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : colIndex === 2
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `dischargeMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `dischargeMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `dischargeMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `dischargeMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : colIndex === 3
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `threemonthMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `threemonthMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `threemonthMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `threemonthMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : colIndex === 4
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twelvemonthMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twelvemonthMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twelvemonthMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `twelvemonthMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : colIndex === 5
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twentyonemonthMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twentyonemonthMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twentyonemonthMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `twentyonemonthMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value0
                                                              ? `twentyfourmonthMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `twentyfourmonthMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `twentyfourmonthMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : `twentyfourmonthMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                          }
                                                          name={
                                                            colIndex === 0
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `admissionMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `admissionMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `admissionMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `admissionMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : colIndex === 1
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `indexMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `indexMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `indexMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `indexMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : colIndex === 2
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `dischargeMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `dischargeMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `dischargeMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `dischargeMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : colIndex === 3
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `threemonthMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `threemonthMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `threemonthMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `threemonthMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : colIndex === 4
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twelvemonthMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twelvemonthMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twelvemonthMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `twelvemonthMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : colIndex === 5
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twentyonemonthMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twentyonemonthMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twentyonemonthMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                                : `twentyonemonthMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value0
                                                              ? `twentyfourmonthMeasurementValue_l-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `twentyfourmonthMeasurementValue_ml-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `twentyfourmonthMeasurementValue_nl-${colIndex}-mde-${adjustedIdx}-${mIndex}`
                                                              : `twentyfourmonthMeasurementValue_mg-${colIndex}-mde-${adjustedIdx}-${mIndex}-${item.label}`
                                                          }
                                                          type="text"
                                                          value={
                                                            colIndex ===
                                                            Values.value0
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.admissionMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.admissionMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.admissionMeasurementValue_nl
                                                                  : ""
                                                                : item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                ? item.admissionMeasurementValue_mg
                                                                : ""
                                                              : colIndex ===
                                                                Values.value1
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.indexMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.indexMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.indexMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.indexMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.indexMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.indexMeasurementValue_nl
                                                                  : ""
                                                                : item.indexMeasurement ===
                                                                  mIndex + 1
                                                                ? item.indexMeasurementValue_mg
                                                                : ""
                                                              : colIndex ===
                                                                Values.value2
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeMeasurementValue_nl
                                                                  : ""
                                                                : item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                ? item.dischargeMeasurementValue_mg
                                                                : ""
                                                              : colIndex ===
                                                                Values.value3
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.threemonthMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.threemonthMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.threemonthMeasurementValue_nl
                                                                  : ""
                                                                : item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                ? item.threemonthMeasurementValue_mg
                                                                : ""
                                                              : colIndex ===
                                                                Values.value4
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twelvemonthMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twelvemonthMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twelvemonthMeasurementValue_nl
                                                                  : ""
                                                                : item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                ? item.twelvemonthMeasurementValue_mg
                                                                : ""
                                                              : colIndex ===
                                                                Values.value5
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twentyonemonthMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twentyonemonthMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twentyonemonthMeasurementValue_nl
                                                                  : ""
                                                                : item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                ? item.twentyonemonthMeasurementValue_mg
                                                                : ""
                                                              : mIndex ===
                                                                Values.value0
                                                              ? item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyfourmonthMeasurementValue_l
                                                                : ""
                                                              : mIndex ===
                                                                Values.value1
                                                              ? item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyfourmonthMeasurementValue_ml
                                                                : ""
                                                              : mIndex ===
                                                                Values.value2
                                                              ? item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyfourmonthMeasurementValue_nl
                                                                : ""
                                                              : item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                              ? item.twentyfourmonthMeasurementValue_mg
                                                              : ""
                                                          }
                                                          maxLength={8}
                                                          onKeyDown={
                                                            handleNumericInputKeyDown
                                                          }
                                                          onChange={
                                                            HandleMdeFieldChange
                                                          }
                                                        />
                                                      )}
                                                      <span>{unit}</span>
                                                    </label>
                                                  </div>
                                                )
                                              )}
                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionmeasurementEmpty
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexMeasurementEmpty
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeMeasurementEmpty
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthMeasurementEmpty
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthMeasurementEmpty
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthMeasurementEmpty
                                                    : item.q36TwentyfourmonthMeasurementEmpty
                                                }
                                                message={CommonError_Msgs.Msg1}
                                              />
                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionmeasurementValueEmpty
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexMeasurementValueEmpty
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeMeasurementValueEmpty
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthMeasurementValueEmpty
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthMeasurementValueEmpty
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthMeasurementValueEmpty
                                                    : item.q36TwentyfourmonthMeasurementValueEmpty
                                                }
                                                message={CommonError_Msgs.Msg1}
                                              />
                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionmeasurementValueInvalid
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexMeasurementValueInvalid
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeMeasurementValueInvalid
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthMeasurementValueInvalid
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthMeasurementValueInvalid
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthMeasurementValueEmpty
                                                    : item.q36TwentyfourmonthMeasurementValueInvalid
                                                }
                                                message={CommonError_Msgs.Msg2}
                                              />
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                          </table>
                        </div>
                      </div>
                    </div>

                    {/*Q49-54*/}
                    <div
                      className="block-margin white-bg"
                      style={{ marginBlock: "20px 0" }}
                    >
                      <div className="grid-overflow">
                        <table
                          border="1"
                          width="100%"
                          cellPadding="5"
                          cellSpacing="0"
                          style={patientLocked ? { pointerEvents: 'none'} : {}}
                          className="conditional-columns-table"
                        >
                          <tr>
                            <td
                              style={{
                                border: "1px solid #808080",
                                padding: "10px",
                              }}
                              colSpan={targetDates.length + 2}
                            >
                              Please report the laboratory assessment that
                              occurred{" "}
                              <u>
                                on or closest to the provided target date that
                                occurred outside of MDEs only for{" "}
                                <b>hematologic parameter.</b>
                              </u>
                            </td>
                          </tr>
                        </table>
                        <div
                          style={{
                            maxHeight: "1060px",
                            overflowY: "auto",
                            border: "1px solid #ccc",
                          }}
                        >
                          <table
                            border="1"
                            width="100%"
                            cellPadding="5"
                            cellSpacing="0"
                            style={patientLocked ? { pointerEvents: 'none'} : {}}
                            className="conditional-columns-table"
                          >
                            {/* Table Instructions */}

                            {/* Table Header */}
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 9,
                                background: "#fff",
                                //borderBottom: "2px solid #000",
                              }}
                            >
                              <tr className="custom-position-rel">
                                <th
                                  colSpan="2"
                                  style={{
                                    border: "1px solid #808080",
                                    padding: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <div className="floating-border-bottom"></div>
                                  Target Date
                                </th>
                                {targetDates.map((date, index) => (
                                  <th
                                    className="custom-position-rel"
                                    style={{
                                      border: "1px solid #808080",
                                      padding: "10px",
                                    }}
                                    key={index}
                                  >
                                    <div className="floating-border-left-first"></div>
                                    {date}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            {mdeData
                              .filter((item) =>
                                [
                                  Values.value14,
                                  Values.value15,
                                  Values.value16,
                                  Values.value17,
                                  Values.value18,
                                  Values.value19,
                                ].includes(item.labAssessmentMdeTypeId)
                              )
                              .map((item, idx) => {
                                const adjustIdx = idx + 13;
                                return (
                                  <React.Fragment key={adjustIdx}>
                                    <tr>
                                      {/* Lab Test Name */}
                                      <td
                                        rowSpan="3"
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>{item.question} </b>
                                        {item.label}
                                      </td>

                                      {/* Date of Assessment */}
                                      <td
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>Date of assessment</b>
                                      </td>
                                      {Array.from(
                                        { length: 7 },
                                        (_, i) => i + 1
                                      ).map((index) => {
                                        if(index === 2 || index === 3) return null;
                                        if (
                                          index === 1
                                            ? Q36AdmissionHideColumn === false
                                            : index === 2
                                            ? Q36IndexHideColumn === false
                                            : index === 3
                                            ? Q36DischargeHideColumn === false
                                            : index === 4
                                            ? Q36ThreeMonthHideColumn === false
                                            : index === 5
                                            ? Q36TwelveMonthHideColumn === false
                                            : index === 6
                                            ? Q36TwentyOneMonthHideColumn ===
                                              false
                                            : Q36TwentyFourMonthHideColumn ===
                                              false
                                        ) {
                                          return (
                                            <td
                                              className="containertd"
                                              key={`na-${index}`} // Unique key
                                              style={{
                                                textAlign: "left",
                                                borderRight:
                                                  "1px solid #808080",
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                              ></span>
                                            </td>
                                          );
                                        }
                                        return (
                                          <td
                                            key={index}
                                            style={{
                                              border: "1px solid #808080",
                                              padding: "10px",
                                            }}
                                          >
                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustIdx}`
                                                  }
                                                  value={1}
                                                  checked={
                                                    index === Values.value1
                                                      ? item.admissionAssessment ===
                                                        Values.value1
                                                      : index === Values.value2
                                                      ? item.indexAssessment ===
                                                        Values.value1
                                                      : index === Values.value3
                                                      ? item.dischargeAssessment ===
                                                        Values.value1
                                                      : index === Values.value4
                                                      ? item.threemonthAssessment ===
                                                        Values.value1
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessment ===
                                                        Values.value1
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessment ===
                                                        Values.value1
                                                      : item.twentyfourmonthAssessment ===
                                                        Values.value1
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />

                                                <span>
                                                  <DateControl
                                                    optionId={
                                                      index === 1
                                                        ? "admissionAssessmentDatedt"
                                                        : index === 2
                                                        ? "indexAssessmentDate"
                                                        : index === 3
                                                        ? "dischargeAssessmentDatedt"
                                                        : index === 4
                                                        ? "threemonthAssessmentDate"
                                                        : index === 5
                                                        ? "twelvemonthAssessmentDate"
                                                        : index === 6
                                                        ? "twentyonemonthAssessmentDate"
                                                        : "twentyfourmonthAssessmentDate"
                                                    }
                                                    ctrlId={
                                                      index === 1
                                                        ? "admissionAssessmentDatedt-" +
                                                          adjustIdx
                                                        : index === 2
                                                        ? "indexAssessmentDate-" +
                                                          adjustIdx
                                                        : index === 3
                                                        ? "dischargeAssessmentDatedt-" +
                                                          adjustIdx
                                                        : index === 4
                                                        ? "threemonthAssessmentDate-" +
                                                          adjustIdx
                                                        : index === 5
                                                        ? "twelvemonthAssessmentDate-" +
                                                          adjustIdx
                                                        : index === 6
                                                        ? "twentyonemonthAssessmentDate-" +
                                                          adjustIdx
                                                        : "twentyfourmonthAssessmentDate-" +
                                                          adjustIdx
                                                    }
                                                    HandleDateChange={
                                                      HandleDateChange
                                                    }
                                                    date={
                                                      index === Values.value1
                                                        ? item.admissionAssessmentDatedt
                                                        : index ===
                                                          Values.value2
                                                        ? item.indexAssessmentDate
                                                        : index ===
                                                          Values.value3
                                                        ? item.dischargeAssessmentDatedt
                                                        : index ===
                                                          Values.value4
                                                        ? item.threemonthAssessmentDate
                                                        : index ===
                                                          Values.value5
                                                        ? item.twelvemonthAssessmentDate
                                                        : index ===
                                                          Values.value6
                                                        ? item.twentyonemonthAssessmentDate
                                                        : item.twentyfourmonthAssessmentDate
                                                    }
                                                  />
                                                </span>
                                              </label>
                                            </div>
                                            <div className="estimated-date-padding text-margin">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : index === 2
                                                      ? `indexAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : `twentyfourmonthAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : index === 2
                                                      ? `indexAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                      : `twentyfourmonthAssessmentDateEstimated-${index}-mde-${adjustIdx}`
                                                  }
                                                  checked={
                                                    index === Values.value1
                                                      ? item.admissionAssessmentDateEstimated 
                                                      : index === Values.value2
                                                      ? item.indexAssessmentDateEstimated 
                                                      : index === Values.value3
                                                      ? item.dischargeAssessmentDateEstimated 
                                                      : index === Values.value4
                                                      ? item.threemonthAssessmentDateEstimated 
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessmentDateEstimated 
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessmentDateEstimated 
                                                      : item.twentyfourmonthAssessmentDateEstimated 
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Estimated Date
                                                </span>
                                              </label>
                                            </div>
                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustIdx}`
                                                  }
                                                  value={99}
                                                  checked={
                                                    index == Values.value1
                                                      ? item.admissionAssessment ===
                                                        Values.value99
                                                      : index === Values.value2
                                                      ? item.indexAssessment ===
                                                        Values.value99
                                                      : index === Values.value3
                                                      ? item.dischargeAssessment ===
                                                        Values.value99
                                                      : index === Values.value4
                                                      ? item.threemonthAssessment ===
                                                        Values.value99
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessment ===
                                                        Values.value99
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessment ===
                                                        Values.value99
                                                      : item.twentyfourmonthAssessment ===
                                                        Values.value99
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  {" "}
                                                  Date unknown
                                                </span>
                                              </label>
                                            </div>
                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustIdx}`
                                                  }
                                                  value={2}
                                                  checked={
                                                    index === Values.value1
                                                      ? item.admissionAssessment ===
                                                        Values.value2
                                                      : index === Values.value2
                                                      ? item.indexAssessment ===
                                                        Values.value2
                                                      : index === Values.value3
                                                      ? item.dischargeAssessment ===
                                                        Values.value2
                                                      : index === Values.value4
                                                      ? item.threemonthAssessment ===
                                                        Values.value2
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessment ===
                                                        Values.value2
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessment ===
                                                        Values.value2
                                                      : item.twentyfourmonthAssessment ===
                                                        Values.value2
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  {" "}
                                                  Not assessed
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                index === Values.value1
                                                  ? item.q36AdmissionassessmentDateEmptyError
                                                  : index === Values.value2
                                                  ? item.q36IndexAssessmentDateEmptyError
                                                  : index === Values.value3
                                                  ? item.q36DischargeAssessmentDateEmptyError
                                                  : index === Values.value4
                                                  ? item.q36ThreemonthAssessmentDateEmptyError
                                                  : index === Values.value5
                                                  ? item.q36TwelvemonthAssessmentDateEmptyError
                                                  : index === Values.value6
                                                  ? item.q36TwentyonemonthAssessmentDateEmptyError
                                                  : item.q36TwentyfourmonthAssessmentDateEmptyError
                                              }
                                              message={CommonError_Msgs.Msg2}
                                            />

                                            <ErrorField
                                              show={
                                                index === Values.value1
                                                  ? item.q36AdmissionassessmentEmpty
                                                  : index === Values.value2
                                                  ? item.q36IndexAssessmentEmpty
                                                  : index === Values.value3
                                                  ? item.q36DischargeAssessmentEmpty
                                                  : index === Values.value4
                                                  ? item.q36ThreemonthAssessmentEmpty
                                                  : index === Values.value5
                                                  ? item.q36TwelvemonthAssessmentEmpty
                                                  : index === Values.value6
                                                  ? item.q36TwentyonemonthAssessmentEmpty
                                                  : item.q36TwentyfourmonthAssessmentEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />

                                            <ErrorField
                                              show={
                                                index === Values.value1
                                                  ? item.q36AdmissionassessmentDateInvalid
                                                  : index === Values.value2
                                                  ? item.q36IndexAssessmentDateInvalid
                                                  : index === Values.value3
                                                  ? item.q36DischargeAssessmentDateInvalid
                                                  : index === Values.value4
                                                  ? item.q36ThreemonthAssessmentDateInvalid
                                                  : index === Values.value5
                                                  ? item.q36TwelvemonthAssessmentDateInvalid
                                                  : index === Values.value6
                                                  ? item.q36TwentyonemonthAssessmentDateInvalid
                                                  : item.q36TwentyfourmonthAssessmentDateInvalid
                                              }
                                              message={CommonError_Msgs.Msg2}
                                            />
                                          </td>
                                        );
                                      })}
                                    </tr>
                                    {/* Specimen Type */}
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>Specimen Type</b>
                                      </td>
                                      {Array(7)
                                        .fill(null)
                                        .map((_, colIndex) => {
                                          if (colIndex === 1 || colIndex === 2) return null;
                                          const notAssesed =
                                            colIndex === Values.value0
                                              ? item.admissionAssessment ===
                                                Values.value2
                                              : colIndex === Values.value1
                                              ? item.indexAssessment ===
                                                Values.value2
                                              : colIndex === Values.value2
                                              ? item.dischargeAssessment ===
                                                Values.value2
                                              : colIndex === Values.value3
                                              ? item.threemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value4
                                              ? item.twelvemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value5
                                              ? item.twentyonemonthAssessment ===
                                                Values.value2
                                              : item.twentyfourmonthAssessment ===
                                                Values.value2;

                                          const hidecolumn =
                                            colIndex === 0
                                              ? Q36AdmissionHideColumn === false
                                              : colIndex === 1
                                              ? Q36IndexHideColumn === false
                                              : colIndex === 2
                                              ? Q36DischargeHideColumn === false
                                              : colIndex === 3
                                              ? Q36ThreeMonthHideColumn ===
                                                false
                                              : colIndex === 4
                                              ? Q36TwelveMonthHideColumn ===
                                                false
                                              : colIndex === 5
                                              ? Q36TwentyOneMonthHideColumn ===
                                                false
                                              : Q36TwentyFourMonthHideColumn ===
                                                false;

                                          if (notAssesed || hidecolumn) {
                                            return (
                                              <td
                                                className="containertd"
                                                key={`na-${colIndex}`} // Unique key
                                                style={{
                                                  textAlign: hidecolumn
                                                    ? "center"
                                                    : "left",
                                                  borderRight:
                                                    "1px solid #808080",
                                                  borderBottom: hidecolumn
                                                    ? ""
                                                    : "1px solid #808080",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not Applicable</b>
                                                </span>
                                              </td>
                                            );
                                          }

                                          return (
                                            <td
                                              key={colIndex}
                                              style={{
                                                border: "1px solid #808080",
                                                padding: "10px",
                                              }}
                                            >
                                              {item.specimenTypes.map(
                                                (type, typeIndex) => (
                                                  <div key={typeIndex}>
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={
                                                          colIndex === 0
                                                            ? `admissionSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : colIndex === 1
                                                            ? `indexSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : colIndex === 2
                                                            ? `dischargeSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : colIndex === 3
                                                            ? `threemonthSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : colIndex === 4
                                                            ? `twelvemonthSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : `twentyfourmonthSpecimen-${colIndex}-mde-${adjustIdx}`
                                                        }
                                                        name={
                                                          colIndex === 0
                                                            ? `admissionSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : colIndex === 1
                                                            ? `indexSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : colIndex === 2
                                                            ? `dischargeSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : colIndex === 3
                                                            ? `threemonthSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : colIndex === 4
                                                            ? `twelvemonthSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthSpecimen-${colIndex}-mde-${adjustIdx}`
                                                            : `twentyfourmonthSpecimen-${colIndex}-mde-${adjustIdx}`
                                                        }
                                                        value={typeIndex + 1}
                                                        checked={
                                                          colIndex ===
                                                          Values.value0
                                                            ? item.admissionSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value1
                                                            ? item.indexSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value2
                                                            ? item.dischargeSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value3
                                                            ? item.threemonthSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value4
                                                            ? item.twelvemonthSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value5
                                                            ? item.twentyonemonthSpecimen ===
                                                              typeIndex + 1
                                                            : item.twentyfourmonthSpecimen ===
                                                              typeIndex + 1
                                                        }
                                                        onChange={
                                                          HandleMdeFieldChange
                                                        }
                                                      />
                                                      <span> {type}</span>
                                                    </label>
                                                  </div>
                                                )
                                              )}

                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionspecimenEmpty
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexSpecimenEmpty
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeSpecimenEmpty
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthSpecimenEmpty
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthSpecimenEmpty
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthSpecimenEmpty
                                                    : item.q36TwentyfourmonthSpecimenEmpty
                                                }
                                                message={CommonError_Msgs.Msg1}
                                              />
                                            </td>
                                          );
                                        })}
                                    </tr>
                                    {/* Measurement */}
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>Measurement</b>
                                      </td>
                                      {Array(7)
                                        .fill(null)
                                        .map((_, colIndex) => {
                                          if (colIndex === 1 || colIndex === 2) return null;
                                          const notAssesed =
                                            colIndex === Values.value0
                                              ? item.admissionAssessment ===
                                                Values.value2
                                              : colIndex === Values.value1
                                              ? item.indexAssessment ===
                                                Values.value2
                                              : colIndex === Values.value2
                                              ? item.dischargeAssessment ===
                                                Values.value2
                                              : colIndex === Values.value3
                                              ? item.threemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value4
                                              ? item.twelvemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value5
                                              ? item.twentyonemonthAssessment ===
                                                Values.value2
                                              : item.twentyfourmonthAssessment ===
                                                Values.value2;

                                          const hidecolumn =
                                            colIndex === 0
                                              ? Q36AdmissionHideColumn === false
                                              : colIndex === 1
                                              ? Q36IndexHideColumn === false
                                              : colIndex === 2
                                              ? Q36DischargeHideColumn === false
                                              : colIndex === 3
                                              ? Q36ThreeMonthHideColumn ===
                                                false
                                              : colIndex === 4
                                              ? Q36TwelveMonthHideColumn ===
                                                false
                                              : colIndex === 5
                                              ? Q36TwentyOneMonthHideColumn ===
                                                false
                                              : Q36TwentyFourMonthHideColumn ===
                                                false;

                                          if (notAssesed || hidecolumn) {
                                            return (
                                              <td
                                                className="containertd"
                                                key={`na-${colIndex}`} // Unique key
                                                style={{
                                                  textAlign: hidecolumn
                                                    ? ""
                                                    : "left",
                                                  borderRight:
                                                    "1px solid #808080",
                                                  borderBottom: hidecolumn
                                                    ? "1px solid #808080"
                                                    : "",
                                                }}
                                              >
                                                {notAssesed &&
                                                  hidecolumn === false && (
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not Applicable</b>
                                                    </span>
                                                  )}
                                              </td>
                                            );
                                          }

                                          return (
                                            <td
                                              key={colIndex}
                                              style={{
                                                border: "1px solid #808080",
                                                padding: "10px",
                                              }}
                                            >
                                              {item.measurements.map(
                                                (unit, mIndex) => (
                                                  <div key={mIndex}>
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={
                                                          colIndex === 0
                                                            ? `admissionMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : colIndex === 1
                                                            ? `indexMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : colIndex === 2
                                                            ? `dischargeMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : colIndex === 3
                                                            ? `threemonthMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : colIndex === 4
                                                            ? `twelvemonthMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : `twentyfourmonthMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                        }
                                                        name={
                                                          colIndex === 0
                                                            ? `admissionMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : colIndex === 1
                                                            ? `indexMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : colIndex === 2
                                                            ? `dischargeMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : colIndex === 3
                                                            ? `threemonthMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : colIndex === 4
                                                            ? `twelvemonthMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            : `twentyfourmonthMeasurement-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                        }
                                                        value={mIndex + 1}
                                                        checked={
                                                          colIndex ===
                                                          Values.value0
                                                            ? item.admissionMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value1
                                                            ? item.indexMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value2
                                                            ? item.dischargeMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value3
                                                            ? item.threemonthMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value4
                                                            ? item.twelvemonthMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value5
                                                            ? item.twentyonemonthMeasurement ===
                                                              mIndex + 1
                                                            : item.twentyfourmonthMeasurement ===
                                                              mIndex + 1
                                                        }
                                                        onChange={
                                                          HandleMdeFieldChange
                                                        }
                                                      />

                                                      {unit === "Unknown" ? (
                                                        <></>
                                                      ) : (
                                                        <input
                                                          className="sub-input-dash"
                                                          id={
                                                            colIndex === 0
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `admissionMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `admissionMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `admissionMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              
                                                                : `admissionMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : colIndex === 1
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `indexMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `indexMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `indexMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            
                                                                : `indexMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : colIndex === 2
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `dischargeMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `dischargeMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `dischargeMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                             
                                                                : `dischargeMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : colIndex === 3
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `threemonthMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `threemonthMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `threemonthMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                               
                                                                : `threemonthMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : colIndex === 4
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twelvemonthMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twelvemonthMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twelvemonthMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                
                                                                : `twelvemonthMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : colIndex === 5
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twentyonemonthMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twentyonemonthMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twentyonemonthMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                          
                                                                : `twentyonemonthMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                Values.value0
                                                              ? `twentyfourmonthMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `twentyfourmonthMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `twentyfourmonthMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              
                                                              : `twentyfourmonthMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            }
                                                          name={
                                                            colIndex === 0
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `admissionMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `admissionMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `admissionMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                             
                                                               : `admissionMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : colIndex === 1
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `indexMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `indexMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `indexMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                               
                                                                : `indexMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : colIndex === 2
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `dischargeMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `dischargeMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `dischargeMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                               
                                                                :`dischargeMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : colIndex === 3
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `threemonthMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `threemonthMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `threemonthMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              
                                                                : `threemonthMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : colIndex === 4
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twelvemonthMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twelvemonthMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twelvemonthMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                             
                                                                :`twelvemonthMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : colIndex === 5
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twentyonemonthMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twentyonemonthMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twentyonemonthMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                            
                                                                : `twentyonemonthMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value0
                                                              ? `twentyfourmonthMeasurementValue_l-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `twentyfourmonthMeasurementValue_ml-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `twentyfourmonthMeasurementValue_nl-${colIndex}-mde-${adjustIdx}-${mIndex}`
                                                             
                                                              : `twentyfourmonthMeasurementValue_mg-${colIndex}-mde-${adjustIdx}-${mIndex}-${item.label}`
                                                            }
                                                          type="text"
                                                          value={
                                                            colIndex ===
                                                            Values.value0
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.admissionMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.admissionMeasurementValue_ml
                                                                  : "" 
                                                                : mIndex === 
                                                                  Values.value2
                                                                ? item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.admissionMeasurementValue_nl
                                                                  : ""
                                                             
                                                                : item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                 ? item.admissionMeasurementValue_mg
                                                                 : ""
                                                                
                                                              : colIndex ===
                                                                Values.value1
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.indexMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.indexMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.indexMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.indexMeasurementValue_ml
                                                                  : "" 
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.indexMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.indexMeasurementValue_nl
                                                                  : "" 
                                                                
                                                                : item.indexMeasurement ===
                                                                  mIndex + 1
                                                                 ? item.indexMeasurementValue_mg
                                                                 : ""
                                                               
                                                              : colIndex ===
                                                                Values.value2
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeMeasurementValue_nl
                                                                  : ""
                                                               
                                                                : item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                 ? item.dischargeMeasurementValue_mg
                                                                 : ""
                                                               
                                                              : colIndex ===
                                                                Values.value3
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.threemonthMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.threemonthMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.threemonthMeasurementValue_nl
                                                                  : ""
                                                               
                                                                : item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                 ? item.threemonthMeasurementValue_mg
                                                                 : ""
                                                              
                                                              : colIndex ===
                                                                Values.value4
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twelvemonthMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twelvemonthMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twelvemonthMeasurementValue_nl
                                                                  : ""
                                                               
                                                                : item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                 ? item.twelvemonthMeasurementValue_mg
                                                                 : ""
                                                              
                                                              : colIndex ===
                                                                Values.value5
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twentyonemonthMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twentyonemonthMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twentyonemonthMeasurementValue_nl
                                                                  : ""
                                                               
                                                                : item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                 ? item.twentyonemonthMeasurementValue_mg
                                                                 : ""
                                                                
                                                              : mIndex ===
                                                                Values.value0
                                                              ? item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyfourmonthMeasurementValue_l
                                                                : ""
                                                              : mIndex ===
                                                                Values.value1
                                                              ? item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyfourmonthMeasurementValue_ml
                                                                : ""
                                                              : mIndex ===
                                                                Values.value2
                                                              ? item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyfourmonthMeasurementValue_nl
                                                                : ""
                                                           
                                                              : item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                              ? item.twentyfourmonthMeasurementValue_mg
                                                              : ""
                                                              
                                                          }
                                                          maxLength={8}
                                                          onKeyDown={
                                                            handleNumericInputKeyDown
                                                          }
                                                          onChange={
                                                            HandleMdeFieldChange
                                                          }
                                                        />
                                                      )}
                                                      <span>{unit}</span>
                                                    </label>
                                                  </div>
                                                )
                                              )}
                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionmeasurementEmpty
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexMeasurementEmpty
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeMeasurementEmpty
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthMeasurementEmpty
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthMeasurementEmpty
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthMeasurementEmpty
                                                    : item.q36TwentyfourmonthMeasurementEmpty
                                                }
                                                message={CommonError_Msgs.Msg1}
                                              />
                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionmeasurementValueEmpty
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexMeasurementValueEmpty
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeMeasurementValueEmpty
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthMeasurementValueEmpty
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthMeasurementValueEmpty
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthMeasurementValueEmpty
                                                    : item.q36TwentyfourmonthMeasurementValueEmpty
                                                }
                                                message={CommonError_Msgs.Msg1}
                                              />
                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionmeasurementValueInvalid
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexMeasurementValueInvalid
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeMeasurementValueInvalid
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthMeasurementValueInvalid
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthMeasurementValueInvalid
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthMeasurementValueInvalid
                                                    : item.q36TwentyfourmonthMeasurementValueInvalid
                                                }
                                                message={CommonError_Msgs.Msg2}
                                              />
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                          </table>
                        </div>
                      </div>
                    </div>

                    {/*Q55*/}
                    <div
                      className="block-margin white-bg"
                      style={{ marginBlock: "20px 0" }}
                    >
                      <div className="grid-overflow">
                        <table
                          border="1"
                          width="100%"
                          cellPadding="5"
                          cellSpacing="0"
                          style={patientLocked ? { pointerEvents: 'none'} : {}}
                          className="conditional-columns-table"
                        >
                          <tr>
                            <td
                              style={{
                                border: "1px solid #808080",
                                padding: "10px",
                              }}
                              colSpan={targetDates.length + 2}
                            >
                              Please report the laboratory assessment that
                              occurred{" "}
                              <u>
                                on or closest to the provided target date that
                                occurred outside of MDEs only for{" "}
                                <b>FGF21 assessments.</b>
                              </u>
                            </td>
                          </tr>
                        </table>
                        <div
                          style={{
                            maxHeight: "1060px",
                            overflowY: "auto",
                            border: "1px solid #ccc",
                          }}
                        >
                          <table
                            border="1"
                            width="100%"
                            cellPadding="5"
                            cellSpacing="0"
                            style={patientLocked ? { pointerEvents: 'none' } : {}}
                            className="conditional-columns-table"
                          >
                            {/* Table Instructions */}

                            {/* Table Header */}
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 9,
                                background: "#fff",
                                //borderBottom: "2px solid #000",
                              }}
                            >
                              <tr className="custom-position-rel">
                                <th
                                  colSpan="2"
                                  style={{
                                    border: "1px solid #808080",
                                    padding: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <div className="floating-border-bottom"></div>
                                  Target Date
                                </th>
                                {targetDates.map((date, index) => (
                                  <th
                                    className="custom-position-rel"
                                    style={{
                                      border: "1px solid #808080",
                                      padding: "10px",
                                    }}
                                    key={index}
                                  >
                                    <div className="floating-border-left-first"></div>
                                    {date}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            {mdeData
                              .filter((item) =>
                                [Values.value20].includes(
                                  item.labAssessmentMdeTypeId
                                )
                              )
                              .map((item, idx) => {
                                const adjustsIdx = idx + 19;
                                return (
                                  <React.Fragment key={adjustsIdx}>
                                    <tr>
                                      {/* Lab Test Name */}
                                      <td
                                        rowSpan="3"
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>{item.question} </b>
                                        {item.label}
                                      </td>

                                      {/* Date of Assessment */}
                                      <td
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>Date of assessment</b>
                                      </td>
                                      {Array.from(
                                        { length: 7 },
                                        (_, i) => i + 1
                                      ).map((index) => {
                                        if(index === 2 || index === 3) return null;
                                        if (
                                          index === 1
                                            ? Q36AdmissionHideColumn === false
                                            : index === 2
                                            ? Q36IndexHideColumn === false
                                            : index === 3
                                            ? Q36DischargeHideColumn === false
                                            : index === 4
                                            ? Q36ThreeMonthHideColumn === false
                                            : index === 5
                                            ? Q36TwelveMonthHideColumn === false
                                            : index === 6
                                            ? Q36TwentyOneMonthHideColumn ===
                                              false
                                            : Q36TwentyFourMonthHideColumn ===
                                              false
                                        ) {
                                          return (
                                            <td
                                              className="containertd"
                                              key={`na-${index}`} // Unique key
                                              style={{
                                                textAlign: "left",
                                                borderRight:
                                                  "1px solid #808080",
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                              ></span>
                                            </td>
                                          );
                                        }
                                        return (
                                          <td
                                            key={index}
                                            style={{
                                              border: "1px solid #808080",
                                              padding: "10px",
                                            }}
                                          >
                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustsIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustsIdx}`
                                                  }
                                                  value={1}
                                                  checked={
                                                    index == Values.value1
                                                      ? item.admissionAssessment ===
                                                        Values.value1
                                                      : index === Values.value2
                                                      ? item.indexAssessment ===
                                                        Values.value1
                                                      : index === Values.value3
                                                      ? item.dischargeAssessment ===
                                                        Values.value1
                                                      : index === Values.value4
                                                      ? item.threemonthAssessment ===
                                                        Values.value1
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessment ===
                                                        Values.value1
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessment ===
                                                        Values.value1
                                                      : item.twentyfourmonthAssessment ===
                                                        Values.value1
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />

                                                <span>
                                                  <DateControl
                                                    optionId={
                                                      index === 1
                                                        ? "admissionAssessmentDatedt"
                                                        : index === 2
                                                        ? "indexAssessmentDate"
                                                        : index === 3
                                                        ? "dischargeAssessmentDatedt"
                                                        : index === 4
                                                        ? "threemonthAssessmentDate"
                                                        : index === 5
                                                        ? "twelvemonthAssessmentDate"
                                                        : index === 6
                                                        ? "twentyonemonthAssessmentDate"
                                                        : "twentyfourmonthAssessmentDate"
                                                    }
                                                    ctrlId={
                                                      index === 1
                                                        ? "admissionAssessmentDatedt-" +
                                                          adjustsIdx
                                                        : index === 2
                                                        ? "indexAssessmentDate-" +
                                                          adjustsIdx
                                                        : index === 3
                                                        ? "dischargeAssessmentDatedt-" +
                                                          adjustsIdx
                                                        : index === 4
                                                        ? "threemonthAssessmentDate-" +
                                                          adjustsIdx
                                                        : index === 5
                                                        ? "twelvemonthAssessmentDate-" +
                                                          adjustsIdx
                                                        : index === 6
                                                        ? "twentyonemonthAssessmentDate-" +
                                                          adjustsIdx
                                                        : "twentyfourmonthAssessmentDate-" +
                                                          adjustsIdx
                                                    }
                                                    HandleDateChange={
                                                      HandleDateChange
                                                    }
                                                    date={
                                                      index === Values.value1
                                                        ? item.admissionAssessmentDatedt
                                                        : index ===
                                                          Values.value2
                                                        ? item.indexAssessmentDate
                                                        : index ===
                                                          Values.value3
                                                        ? item.dischargeAssessmentDatedt
                                                        : index ===
                                                          Values.value4
                                                        ? item.threemonthAssessmentDate
                                                        : index ===
                                                          Values.value5
                                                        ? item.twelvemonthAssessmentDate
                                                        : index ===
                                                          Values.value6
                                                        ? item.twentyonemonthAssessmentDate
                                                        : item.twentyfourmonthAssessmentDate
                                                    }
                                                  />
                                                </span>
                                              </label>
                                            </div>
                                            <div className="estimated-date-padding text-margin">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : index === 2
                                                      ? `indexAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : `twentyfourmonthAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : index === 2
                                                      ? `indexAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                      : `twentyfourmonthAssessmentDateEstimated-${index}-mde-${adjustsIdx}`
                                                  }
                                                  checked={
                                                    index == Values.value1
                                                      ? item.admissionAssessmentDateEstimated 
                                                      : index === Values.value2
                                                      ? item.indexAssessmentDateEstimated 
                                                      : index === Values.value3
                                                      ? item.dischargeAssessmentDateEstimated 
                                                      : index === Values.value4
                                                      ? item.threemonthAssessmentDateEstimated 
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessmentDateEstimated 
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessmentDateEstimated 
                                                      : item.twentyfourmonthAssessmentDateEstimated 
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  Estimated Date
                                                </span>
                                              </label>
                                            </div>
                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustsIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustsIdx}`
                                                  }
                                                  value={99}
                                                  checked={
                                                    index === Values.value1
                                                      ? item.admissionAssessment ===
                                                        Values.value99
                                                      : index === Values.value2
                                                      ? item.indexAssessment ===
                                                        Values.value99
                                                      : index === Values.value3
                                                      ? item.dischargeAssessment ===
                                                        Values.value99
                                                      : index === Values.value4
                                                      ? item.threemonthAssessment ===
                                                        Values.value99
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessment ===
                                                        Values.value99
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessment ===
                                                        Values.value99
                                                      : item.twentyfourmonthAssessment ===
                                                        Values.value99
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  {" "}
                                                  Date unknown
                                                </span>
                                              </label>
                                            </div>
                                            <div>
                                              <label>
                                                <input
                                                  type="radio"
                                                  id={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustsIdx}`
                                                  }
                                                  name={
                                                    index === 1
                                                      ? `admissionAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 2
                                                      ? `indexAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 3
                                                      ? `dischargeAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 4
                                                      ? `threemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 5
                                                      ? `twelvemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : index === 6
                                                      ? `twentyonemonthAssessment-${index}-mde-${adjustsIdx}`
                                                      : `twentyfourmonthAssessment-${index}-mde-${adjustsIdx}`
                                                  }
                                                  value={2}
                                                  checked={
                                                    index == Values.value1
                                                      ? item.admissionAssessment ===
                                                        Values.value2
                                                      : index === Values.value2
                                                      ? item.indexAssessment ===
                                                        Values.value2
                                                      : index === Values.value3
                                                      ? item.dischargeAssessment ===
                                                        Values.value2
                                                      : index === Values.value4
                                                      ? item.threemonthAssessment ===
                                                        Values.value2
                                                      : index === Values.value5
                                                      ? item.twelvemonthAssessment ===
                                                        Values.value2
                                                      : index === Values.value6
                                                      ? item.twentyonemonthAssessment ===
                                                        Values.value2
                                                      : item.twentyfourmonthAssessment ===
                                                        Values.value2
                                                  }
                                                  onChange={HandleMdeFieldChange}
                                                />
                                                <span className="radio-text-padding">
                                                  {" "}
                                                  Not assessed
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={
                                                index === Values.value1
                                                  ? item.q36AdmissionassessmentDateEmptyError
                                                  : index === Values.value2
                                                  ? item.q36IndexAssessmentDateEmptyError
                                                  : index === Values.value3
                                                  ? item.q36DischargeAssessmentDateEmptyError
                                                  : index === Values.value4
                                                  ? item.q36ThreemonthAssessmentDateEmptyError
                                                  : index === Values.value5
                                                  ? item.q36TwelvemonthAssessmentDateEmptyError
                                                  : index === Values.value6
                                                  ? item.q36TwentyonemonthAssessmentDateEmptyError
                                                  : item.q36TwentyfourmonthAssessmentDateEmptyError
                                              }
                                              message={CommonError_Msgs.Msg2}
                                            />

                                            <ErrorField
                                              show={
                                                index === Values.value1
                                                  ? item.q36AdmissionassessmentEmpty
                                                  : index === Values.value2
                                                  ? item.q36IndexAssessmentEmpty
                                                  : index === Values.value3
                                                  ? item.q36DischargeAssessmentEmpty
                                                  : index === Values.value4
                                                  ? item.q36ThreemonthAssessmentEmpty
                                                  : index === Values.value5
                                                  ? item.q36TwelvemonthAssessmentEmpty
                                                  : index === Values.value6
                                                  ? item.q36TwentyonemonthAssessmentEmpty
                                                  : item.q36TwentyfourmonthAssessmentEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />

                                            <ErrorField
                                              show={
                                                index === Values.value1
                                                  ? item.q36AdmissionassessmentDateInvalid
                                                  : index === Values.value2
                                                  ? item.q36IndexAssessmentDateInvalid
                                                  : index === Values.value3
                                                  ? item.q36DischargeAssessmentDateInvalid
                                                  : index === Values.value4
                                                  ? item.q36ThreemonthAssessmentDateInvalid
                                                  : index === Values.value5
                                                  ? item.q36TwelvemonthAssessmentDateInvalid
                                                  : index === Values.value5
                                                  ? item.q36TwentyonemonthMeasurementValueInvalid
                                                  : item.q36TwentyfourmonthAssessmentDateInvalid
                                              }
                                              message={CommonError_Msgs.Msg2}
                                            />
                                          </td>
                                        );
                                      })}
                                    </tr>
                                    {/* Specimen Type */}
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>Specimen Type</b>
                                      </td>
                                      {Array(7)
                                        .fill(null)
                                        .map((_, colIndex) => {
                                          if (colIndex === 1 || colIndex === 2) return null;
                                          const notAssesed =
                                            colIndex === Values.value0
                                              ? item.admissionAssessment ===
                                                Values.value2
                                              : colIndex === Values.value1
                                              ? item.indexAssessment ===
                                                Values.value2
                                              : colIndex === Values.value2
                                              ? item.dischargeAssessment ===
                                                Values.value2
                                              : colIndex === Values.value3
                                              ? item.threemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value4
                                              ? item.twelvemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value5
                                              ? item.twentyonemonthAssessment ===
                                                Values.value2
                                              : item.twentyfourmonthAssessment ===
                                                Values.value2;

                                          const hidecolumn =
                                            colIndex === 0
                                              ? Q36AdmissionHideColumn === false
                                              : colIndex === 1
                                              ? Q36IndexHideColumn === false
                                              : colIndex === 2
                                              ? Q36DischargeHideColumn === false
                                              : colIndex === 3
                                              ? Q36ThreeMonthHideColumn ===
                                                false
                                              : colIndex === 4
                                              ? Q36TwelveMonthHideColumn ===
                                                false
                                              : colIndex === 5
                                              ? Q36TwentyOneMonthHideColumn ===
                                                false
                                              : Q36TwentyFourMonthHideColumn ===
                                                false;

                                          if (notAssesed || hidecolumn) {
                                            return (
                                              <td
                                                className="containertd"
                                                key={`na-${colIndex}`} // Unique key
                                                style={{
                                                  textAlign: hidecolumn
                                                    ? "center"
                                                    : "left",
                                                  borderRight:
                                                    "1px solid #808080",
                                                  borderBottom: hidecolumn
                                                    ? ""
                                                    : "1px solid #808080",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not Applicable</b>
                                                </span>
                                              </td>
                                            );
                                          }

                                          return (
                                            <td
                                              key={colIndex}
                                              style={{
                                                border: "1px solid #808080",
                                                padding: "10px",
                                              }}
                                            >
                                              {item.specimenTypes.map(
                                                (type, typeIndex) => (
                                                  <div key={typeIndex}>
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={
                                                          colIndex === 0
                                                            ? `admissionSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : colIndex === 1
                                                            ? `indexSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : colIndex === 2
                                                            ? `dischargeSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : colIndex === 3
                                                            ? `threemonthSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : colIndex === 4
                                                            ? `twelvemonthSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : `twentyfourmonthSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                        }
                                                        name={
                                                          colIndex === 0
                                                            ? `admissionSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : colIndex === 1
                                                            ? `indexSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : colIndex === 2
                                                            ? `dischargeSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : colIndex === 3
                                                            ? `threemonthSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : colIndex === 4
                                                            ? `twelvemonthSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                            : `twentyfourmonthSpecimen-${colIndex}-mde-${adjustsIdx}`
                                                        }
                                                        value={typeIndex + 1}
                                                        checked={
                                                          colIndex ===
                                                          Values.value0
                                                            ? item.admissionSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value1
                                                            ? item.indexSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value2
                                                            ? item.dischargeSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value3
                                                            ? item.threemonthSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value4
                                                            ? item.twelvemonthSpecimen ===
                                                              typeIndex + 1
                                                            : colIndex ===
                                                              Values.value5
                                                            ? item.twentyonemonthSpecimen ===
                                                              typeIndex + 1
                                                            : item.twentyfourmonthSpecimen ===
                                                              typeIndex + 1
                                                        }
                                                        onChange={
                                                          HandleMdeFieldChange
                                                        }
                                                      />
                                                      <span> {type}</span>
                                                    </label>
                                                  </div>
                                                )
                                              )}

                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionspecimenEmpty
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexSpecimenEmpty
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeSpecimenEmpty
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthSpecimenEmpty
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthSpecimenEmpty
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthSpecimenEmpty
                                                    : item.q36TwentyfourmonthSpecimenEmpty
                                                }
                                                message={CommonError_Msgs.Msg1}
                                              />
                                            </td>
                                          );
                                        })}
                                    </tr>
                                    {/* Measurement */}
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid #808080",
                                          padding: "10px",
                                        }}
                                      >
                                        <b>Measurement</b>
                                      </td>
                                      {Array(7)
                                        .fill(null)
                                        .map((_, colIndex) => {
                                          if (colIndex === 1 || colIndex === 2) return null;
                                          const notAssesed =
                                            colIndex === Values.value0
                                              ? item.admissionAssessment ===
                                                Values.value2
                                              : colIndex === Values.value1
                                              ? item.indexAssessment ===
                                                Values.value2
                                              : colIndex === Values.value2
                                              ? item.dischargeAssessment ===
                                                Values.value2
                                              : colIndex === Values.value3
                                              ? item.threemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value4
                                              ? item.twelvemonthAssessment ===
                                                Values.value2
                                              : colIndex === Values.value5
                                              ? item.twentyonemonthAssessment ===
                                                Values.value2
                                              : item.twentyfourmonthAssessment ===
                                                Values.value2;

                                          const hidecolumn =
                                            colIndex === 0
                                              ? Q36AdmissionHideColumn === false
                                              : colIndex === 1
                                              ? Q36IndexHideColumn === false
                                              : colIndex === 2
                                              ? Q36DischargeHideColumn === false
                                              : colIndex === 3
                                              ? Q36ThreeMonthHideColumn ===
                                                false
                                              : colIndex === 4
                                              ? Q36TwelveMonthHideColumn ===
                                                false
                                              : colIndex === 5
                                              ? Q36TwentyOneMonthHideColumn ===
                                                false
                                              : Q36TwentyFourMonthHideColumn ===
                                                false;

                                          if (notAssesed || hidecolumn) {
                                            return (
                                              <td
                                                className="containertd"
                                                key={`na-${colIndex}`} // Unique key
                                                style={{
                                                  textAlign: hidecolumn
                                                    ? ""
                                                    : "left",
                                                  borderRight:
                                                    "1px solid #808080",
                                                  borderBottom: hidecolumn
                                                    ? "1px solid #808080"
                                                    : "",
                                                }}
                                              >
                                                {notAssesed &&
                                                  hidecolumn === false && (
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not Applicable</b>
                                                    </span>
                                                  )}
                                              </td>
                                            );
                                          }

                                          return (
                                            <td
                                              key={colIndex}
                                              style={{
                                                border: "1px solid #808080",
                                                padding: "10px",
                                              }}
                                            >
                                              {item.measurements.map(
                                                (unit, mIndex) => (
                                                  <div key={mIndex}>
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={
                                                          colIndex === 0
                                                            ? `admissionMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : colIndex === 1
                                                            ? `indexMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : colIndex === 2
                                                            ? `dischargeMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : colIndex === 3
                                                            ? `threemonthMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : colIndex === 4
                                                            ? `twelvemonthMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : `twentyfourmonthMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                        }
                                                        name={
                                                          colIndex === 0
                                                            ? `admissionMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : colIndex === 1
                                                            ? `indexMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : colIndex === 2
                                                            ? `dischargeMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : colIndex === 3
                                                            ? `threemonthMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : colIndex === 4
                                                            ? `twelvemonthMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : colIndex === 5
                                                            ? `twentyonemonthMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                            : `twentyfourmonthMeasurement-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                        }
                                                        value={mIndex + 1}
                                                        checked={
                                                          colIndex ===
                                                          Values.value0
                                                            ? item.admissionMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value1
                                                            ? item.indexMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value2
                                                            ? item.dischargeMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value3
                                                            ? item.threemonthMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value4
                                                            ? item.twelvemonthMeasurement ===
                                                              mIndex + 1
                                                            : colIndex ===
                                                              Values.value5
                                                            ? item.twentyonemonthMeasurement ===
                                                              mIndex + 1
                                                            : item.twentyfourmonthMeasurement ===
                                                              mIndex + 1
                                                        }
                                                        onChange={
                                                          HandleMdeFieldChange
                                                        }
                                                      />

                                                      {unit === "Unknown" ? (
                                                        <></>
                                                      ) : (
                                                        <input
                                                          className="sub-input-dash"
                                                          id={
                                                            colIndex === 0
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `admissionMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `admissionMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `admissionMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `admissionMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : colIndex === 1
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `indexMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `indexMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                 : mIndex ===
                                                                  Values.value2
                                                                ? `indexMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `indexMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : colIndex === 2
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `dischargeMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `dischargeMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                 : mIndex ===
                                                                  Values.value2
                                                                ? `dischargeMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `dischargeMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : colIndex === 3
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `threemonthMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `threemonthMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `threemonthMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `threemonthMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : colIndex === 4
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twelvemonthMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twelvemonthMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twelvemonthMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `twelvemonthMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : colIndex === 5
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twentyonemonthMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twentyonemonthMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twentyonemonthMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `twentyonemonthMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value0
                                                              ? `twentyfourmonthMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `twentyfourmonthMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `twentyfourmonthMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : `twentyfourmonthMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                          }
                                                          name={
                                                            colIndex === 0
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `admissionMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `admissionMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                Values.value2
                                                                ? `admissionMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `admissionMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : colIndex === 1
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `indexMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `indexMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `indexMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `indexMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : colIndex === 2
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `dischargeMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `dischargeMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex === Values.value2
                                                                ? `dischargeMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `dischargeMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : colIndex === 3
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `threemonthMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `threemonthMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                 : mIndex ===
                                                                  Values.value2
                                                                ? `threemonthMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `threemonthMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : colIndex === 4
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twelvemonthMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twelvemonthMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twelvemonthMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `twelvemonthMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : colIndex === 5
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? `twentyonemonthMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `twentyonemonthMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? `twentyonemonthMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                                : `twentyonemonthMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value0
                                                              ? `twentyfourmonthMeasurementValue_l-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value1
                                                              ? `twentyfourmonthMeasurementValue_ml-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : mIndex ===
                                                                Values.value2
                                                              ? `twentyfourmonthMeasurementValue_nl-${colIndex}-mde-${adjustsIdx}-${mIndex}`
                                                              : `twentyfourmonthMeasurementValue_mg-${colIndex}-mde-${adjustsIdx}-${mIndex}-${item.label}`
                                                          }
                                                          type="text"
                                                          value={
                                                            colIndex ===
                                                            Values.value0
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.admissionMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.admissionMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.admissionMeasurementValue_nl
                                                                  : ""
                                                                : item.admissionMeasurement ===
                                                                  mIndex + 1
                                                                ? item.admissionMeasurementValue_mg
                                                                : ""
                                                              : colIndex ===
                                                                Values.value1
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.indexMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.indexMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.indexMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.indexMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.indexMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.indexMeasurementValue_nl
                                                                  : ""
                                                                : item.indexMeasurement ===
                                                                  mIndex + 1
                                                                ? item.indexMeasurementValue_mg
                                                                : ""
                                                              : colIndex ===
                                                                Values.value2
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeMeasurementValue_nl
                                                                  : ""
                                                                : item.dischargeMeasurement ===
                                                                  mIndex + 1
                                                                ? item.dischargeMeasurementValue_mg
                                                                : ""
                                                              : colIndex ===
                                                                Values.value3
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.threemonthMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.threemonthMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.threemonthMeasurementValue_nl
                                                                  : ""
                                                                : item.threemonthMeasurement ===
                                                                  mIndex + 1
                                                                ? item.threemonthMeasurementValue_mg
                                                                : ""
                                                              : colIndex ===
                                                                Values.value4
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twelvemonthMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twelvemonthMeasurementValue_ml
                                                                  : "" 
                                                                : mIndex ===
                                                                  Values.value2
                                                                ? item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twelvemonthMeasurementValue_nl
                                                                  : ""
                                                                : item.twelvemonthMeasurement ===
                                                                  mIndex + 1
                                                                ? item.twelvemonthMeasurementValue_mg
                                                                : ""
                                                              : colIndex ===
                                                                Values.value5
                                                              ? mIndex ===
                                                                Values.value0
                                                                ? item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twentyonemonthMeasurementValue_l
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twentyonemonthMeasurementValue_ml
                                                                  : ""
                                                                : mIndex ===   
                                                                  Values.value2
                                                                ? item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.twentyonemonthMeasurementValue_nl
                                                                  : ""
                                                                : item.twentyonemonthMeasurement ===
                                                                  mIndex + 1
                                                                ? item.twentyonemonthMeasurementValue_mg
                                                                : ""
                                                              : mIndex ===
                                                                Values.value0
                                                              ? item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyfourmonthMeasurementValue_l
                                                                : ""
                                                              : mIndex ===
                                                                Values.value1
                                                              ? item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyfourmonthMeasurementValue_ml
                                                                : ""
                                                              : mIndex ===
                                                                Values.value2
                                                              ? item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                                ? item.twentyfourmonthMeasurementValue_nl
                                                                : ""
                                                              : item.twentyfourmonthMeasurement ===
                                                                mIndex + 1
                                                              ? item.twentyfourmonthMeasurementValue_mg
                                                              : ""
                                                          }
                                                          maxLength={8}
                                                          onKeyDown={
                                                            handleNumericInputKeyDown
                                                          }
                                                          onChange={
                                                            HandleMdeFieldChange
                                                          }
                                                        />
                                                      )}
                                                      <span>{unit}</span>
                                                    </label>
                                                  </div>
                                                )
                                              )}
                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionmeasurementEmpty
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexMeasurementEmpty
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeMeasurementEmpty
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthMeasurementEmpty
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthMeasurementEmpty
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthMeasurementEmpty
                                                    : item.q36TwentyfourmonthMeasurementEmpty
                                                }
                                                message={CommonError_Msgs.Msg1}
                                              />
                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionmeasurementValueEmpty
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexMeasurementValueEmpty
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeMeasurementValueEmpty
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthMeasurementValueEmpty
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthMeasurementValueEmpty
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthMeasurementValueEmpty
                                                    : item.q36TwentyfourmonthMeasurementValueEmpty
                                                }
                                                message={CommonError_Msgs.Msg1}
                                              />
                                              <ErrorField
                                                show={
                                                  colIndex === Values.value0
                                                    ? item.q36AdmissionmeasurementValueInvalid
                                                    : colIndex === Values.value1
                                                    ? item.q36IndexMeasurementValueInvalid
                                                    : colIndex === Values.value2
                                                    ? item.q36DischargeMeasurementValueInvalid
                                                    : colIndex === Values.value3
                                                    ? item.q36ThreemonthMeasurementValueInvalid
                                                    : colIndex === Values.value4
                                                    ? item.q36TwelvemonthMeasurementValueInvalid
                                                    : colIndex === Values.value5
                                                    ? item.q36TwentyonemonthMeasurementValueInvalid
                                                    : item.q36TwentyfourmonthMeasurementValueInvalid
                                                }
                                                message={CommonError_Msgs.Msg2}
                                              />
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="survey-section-content-foot">
                  <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showHide012HyperlinkModal && (
        <InfoPopUp
          description={zeroToTwelve(
            dates?.oneYr_pretransplant_start,
            dates?.oneYr_pretransplant_end
          )}
          OkClick={() => setShowHide012HyperlinkModal(false)}
        />
      )}
      {showHide03HyperlinkModal && (
        <InfoPopUp
          description={zeroToThree(
            dates?.indexDt,
            dates?.three_month_stabilization
          )}
          OkClick={() => setShowHide03HyperlinkModal(false)}
        />
      )}
      {showHide415HyperlinkModal && (
        <InfoPopUp
          description={fourToFifteen(
            dates?.post_stabilization_start,
            dates?.twelve_month_post_stabilization
          )}
          OkClick={() => setShowHide415HyperlinkModal(false)}
        />
      )}
      {showHide1627HyperlinkModal && (
        <InfoPopUp
          description={sixteenToTwentySeven(
            dates?.twelve_month_post_stabilization_plusOneday,
            dates?.twenty_four_months_post_stabilization
          )}
          OkClick={() => setShowHide1627HyperlinkModal(false)}
        />
      )}
    </>
  );
};

export default OtherLabAssessment;
